/* Options:
Date: 2022-10-27 12:54:43
Version: 5.50
Tip: To override a DTO option, remove "//" prefix before updating
BaseUrl: http://localhost:1337

//GlobalNamespace: 
//MakePropertiesOptional: True
//AddServiceStackTypes: True
//AddResponseStatus: False
//AddImplicitVersion: 
//AddDescriptionAsComments: True
//IncludeTypes: 
//ExcludeTypes: 
//DefaultImports: 
*/


interface IReturn<T>
{
}

interface IReturnVoid
{
}

interface IHasSessionId
{
    SessionId?: string;
}

interface IHasBearerToken
{
    BearerToken?: string;
}

interface IPost
{
}

type ImportErrorTypes = "Study" | "Phase" | "Group" | "Dosage" | "Results" | "PropertySet" | "FrequencyReport" | "Unknown";

type ImportErrorPriority = "High" | "Low" | "Default";

interface ImportError
{
    ReferenceId?: number;
    SourceReferenceId?: string;
    ErrorType?: ImportErrorTypes;
    ErrorPriority?: ImportErrorPriority;
    ErrorMsg?: string;
    BadData?: string;
    SourceName?: string;
    ErrorSubMsgs?: string[];
}

interface Reference extends IDto
{
    Id?: number;
    Archived?: boolean;
    CreatorId?: number;
    Select?: string[];
    Set?: string[];
    IgnoreCache?: boolean;
    Name?: string;
    Gestalt?: string;
    Type?: string;
    Owner?: Reference;
}

interface Search_1<T>
{
    Skip?: number;
    Take?: number;
    OrderBy?: string[];
    OrderByDesc?: string[];
    Ids?: number[];
    Select?: string[];
    VisibleFields?: string[];
    FullTextSearch?: string;
    IgnoreCache?: boolean;
    Created?: string;
    CreatedAfter?: string;
    CreatedBefore?: string;
    Updated?: string;
    UpdatedBefore?: string;
    UpdatedAfter?: string;
    Archived?: boolean[];
    Locked?: boolean[];
    Junction?: string;
}

interface JsonObject extends any
{
}

interface BackgroundTaskItemBase extends Dto<BackgroundTaskItem>
{
    /**
    * int?
    */
    // @ApiMember(Description="int?", Name="Attempts")
    Attempts?: number;

    /**
    * AuditRecord
    */
    // @ApiMember(Description="AuditRecord", Name="AuditRecord")
    AuditRecord?: Reference;

    /**
    * Primary Key of AuditRecord
    */
    // @ApiMember(Description="Primary Key of AuditRecord", Name="AuditRecordId")
    AuditRecordId?: number;

    /**
    * JsonObject
    */
    // @ApiMember(Description="JsonObject", Name="Data")
    Data?: JsonObject;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="Description")
    Description?: string;

    /**
    * DateTime?
    */
    // @ApiMember(Description="DateTime?", Name="Ended")
    Ended?: string;

    /**
    * int?
    */
    // @ApiMember(Description="int?", Name="EntityId")
    EntityId?: number;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="ExecutionTime")
    ExecutionTime?: string;

    /**
    * DateTime?
    */
    // @ApiMember(Description="DateTime?", Name="Started")
    Started?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="Status")
    Status?: string;

    /**
    * bool
    */
    // @ApiMember(Description="bool", Name="Succeeded")
    Succeeded?: boolean;

    /**
    * BackgroundTask
    */
    // @ApiMember(Description="BackgroundTask", IsRequired=true, Name="Task")
    Task?: Reference;

    /**
    * Primary Key of BackgroundTask
    */
    // @ApiMember(Description="Primary Key of BackgroundTask", Name="TaskId")
    TaskId?: number;

    /**
    * BackgroundTaskHistory
    */
    // @ApiMember(Description="BackgroundTaskHistory", Name="TaskHistory")
    TaskHistory?: Reference[];

    TaskHistoryIds?: number[];
    TaskHistoryCount?: number;
}

// @Route("/backgroundtaskitem/{Id}", "GET")
interface BackgroundTaskItem extends BackgroundTaskItemBase, IReturn<BackgroundTaskItem>, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

interface BackgroundTaskItemSearchBase extends Search_1<BackgroundTaskItem>
{
    Id?: number;
    IdAfter?: number;
    IdBefore?: number;
    Attempts?: number;
    AuditRecord?: Reference;
    AuditRecordIds?: number[];
    Data?: string;
    Datas?: string[];
    Description?: string;
    Descriptions?: string[];
    Ended?: string;
    EndedAfter?: string;
    EndedBefore?: string;
    EntityId?: number;
    ExecutionTime?: string;
    ExecutionTimes?: string[];
    Started?: string;
    StartedAfter?: string;
    StartedBefore?: string;
    Status?: string;
    Statuss?: string[];
    Succeeded?: boolean[];
    Task?: Reference;
    TaskIds?: number[];
    TaskHistoryIds?: number[];
}

interface Dto<T>
{
    // @ApiMember(Name="Id")
    Id?: number;

    // @ApiMember(Name="Created")
    Created?: string;

    // @ApiMember(Name="Updated")
    Updated?: string;

    // @ApiMember(Name="CreatorId")
    CreatorId?: number;

    // @ApiMember(Name="CopyId")
    CopyId?: number;

    // @ApiMember(ExcludeInSchema=true, Name="VersionNo")
    VersionNo?: number;

    /**
    * If true, the record is immutable and cannot be edited or deleted
    */
    // @ApiMember(Description="If true, the record is immutable and cannot be edited or deleted", Name="Locked")
    Locked?: boolean;

    /**
    * If true, the record is soft deleted (archived) and removed from views by default
    */
    // @ApiMember(Description="If true, the record is soft deleted (archived) and removed from views by default", Name="Archived")
    Archived?: boolean;

    IgnoreCache?: boolean;
    /**
    * Deprecated. Use Set instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Set instead.", Name="AssignFields")
    AssignFields?: string[];

    /**
    * The list of fields to update in the PUT/PATCH
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to update in the PUT/PATCH", Name="Set")
    Set?: string[];

    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];

    // @ApiMember(ExcludeInSchema=true, Name="Gestalt")
    Gestalt?: string;
}

interface IDto
{
    Id?: number;
    CreatorId?: number;
    IgnoreCache?: boolean;
    Select?: string[];
    Set?: string[];
}

interface ComparatorBase extends Dto<Comparator>
{
    /**
    * DocumentSet
    */
    // @ApiMember(Description="DocumentSet", Name="DocumentSets")
    DocumentSets?: Reference[];

    DocumentSetsIds?: number[];
    DocumentSetsCount?: number;
    /**
    * string
    */
    // @ApiMember(Description="string", IsRequired=true, Name="Name")
    Name?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="URI")
    URI?: string;
}

// @Route("/comparator", "POST")
// @Route("/comparator/{Id}", "GET, PATCH, PUT, DELETE")
interface Comparator extends ComparatorBase, IReturn<Comparator>, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

interface ComparatorSearchBase extends Search_1<Comparator>
{
    Id?: number;
    IdAfter?: number;
    IdBefore?: number;
    DocumentSetsIds?: number[];
    Name?: string;
    Names?: string[];
    URI?: string;
    URIs?: string[];
}

interface OpportunityFieldHistory
{
    Field?: string;
    OpportunityId?: string;
    NewValue?: string;
    OldValue?: string;
}

interface ProjectBase extends Dto<Project>
{
    /**
    * Project
    */
    // @ApiMember(Description="Project", Name="Children")
    Children?: Reference[];

    ChildrenIds?: number[];
    ChildrenCount?: number;
    /**
    * Client
    */
    // @ApiMember(Description="Client", Name="Client")
    Client?: Reference;

    /**
    * Primary Key of Client
    */
    // @ApiMember(Description="Primary Key of Client", Name="ClientId")
    ClientId?: number;

    /**
    * DateTime?
    */
    // @ApiMember(Description="DateTime?", Name="DatabaseDeadline")
    DatabaseDeadline?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="DatabaseName")
    DatabaseName?: string;

    /**
    * DocumentSet
    */
    // @ApiMember(Description="DocumentSet", Name="Dataset")
    Dataset?: Reference;

    /**
    * Primary Key of DocumentSet
    */
    // @ApiMember(Description="Primary Key of DocumentSet", Name="DatasetId")
    DatasetId?: number;

    /**
    * DateTime?
    */
    // @ApiMember(Description="DateTime?", Name="DeliverableDeadline")
    DeliverableDeadline?: string;

    /**
    * int?
    */
    // @ApiMember(Description="int?", Name="FqId")
    FqId?: number;

    /**
    * int?
    */
    // @ApiMember(Description="int?", Name="LegacyPackageId")
    LegacyPackageId?: number;

    /**
    * int?
    */
    // @ApiMember(Description="int?", Name="LibraryPackageId")
    LibraryPackageId?: number;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="LibraryPackageName")
    LibraryPackageName?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="Number")
    Number?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="OperationsDeliverable")
    OperationsDeliverable?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="OpportunityId")
    OpportunityId?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="OpportunityName")
    OpportunityName?: string;

    /**
    * Project
    */
    // @ApiMember(Description="Project", Name="Parent")
    Parent?: Reference;

    /**
    * Primary Key of Project
    */
    // @ApiMember(Description="Primary Key of Project", Name="ParentId")
    ParentId?: number;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="PICO")
    PICO?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="ProjectId")
    ProjectId?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="ProjectName")
    ProjectName?: string;

    /**
    * LookupTable
    */
    // @ApiMember(Description="LookupTable", Name="Status")
    Status?: Reference;

    /**
    * Primary Key of LookupTable
    */
    // @ApiMember(Description="Primary Key of LookupTable", Name="StatusId")
    StatusId?: number;

    /**
    * TimeCard
    */
    // @ApiMember(Description="TimeCard", Name="TimeCards")
    TimeCards?: Reference[];

    TimeCardsIds?: number[];
    TimeCardsCount?: number;
    /**
    * DateTime
    */
    // @ApiMember(Description="DateTime", Name="ContractEndDate")
    ContractEndDate?: string;

    /**
    * DateTime
    */
    // @ApiMember(Description="DateTime", Name="ArchivedDate")
    ArchivedDate?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="Stage")
    Stage?: string;

    /**
    * DateTime
    */
    // @ApiMember(Description="DateTime", Name="ClosedDate")
    ClosedDate?: string;

    /**
    * Array
    */
    // @ApiMember(Description="Array", Name="History")
    History?: OpportunityFieldHistory[];
}

// @Route("/project", "POST")
// @Route("/project/{Id}", "GET, PATCH, PUT, DELETE")
interface Project extends ProjectBase, IReturn<Project>, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

interface ProjectSearchBase extends Search_1<Project>
{
    Id?: number;
    IdAfter?: number;
    IdBefore?: number;
    ChildrenIds?: number[];
    Client?: Reference;
    ClientIds?: number[];
    DatabaseDeadline?: string;
    DatabaseDeadlineAfter?: string;
    DatabaseDeadlineBefore?: string;
    DatabaseName?: string;
    DatabaseNames?: string[];
    Dataset?: Reference;
    DatasetIds?: number[];
    DeliverableDeadline?: string;
    DeliverableDeadlineAfter?: string;
    DeliverableDeadlineBefore?: string;
    FqId?: number;
    LegacyPackageId?: number;
    LibraryPackageId?: number;
    LibraryPackageName?: string;
    LibraryPackageNames?: string[];
    Number?: string;
    Numbers?: string[];
    OperationsDeliverable?: string;
    OperationsDeliverables?: string[];
    OpportunityId?: string;
    OpportunityIds?: string[];
    OpportunityName?: string;
    OpportunityNames?: string[];
    Parent?: Reference;
    ParentIds?: number[];
    PICO?: string;
    PICOs?: string[];
    ProjectId?: string;
    ProjectIds?: string[];
    ProjectName?: string;
    ProjectNames?: string[];
    Status?: Reference;
    StatusIds?: number[];
    StatusNames?: string[];
    TimeCardsIds?: number[];
    ContactId?: string;
    ParentId?: string;
    ChildIds?: string[];
    PicoId?: string;
    Description?: string;
    CaseName?: string;
    Deliverable?: string;
    DateInitiated?: string;
    ClosedDate?: string;
    GlobalBusinessUnit?: string;
    ContactName?: string;
    Workstream?: string;
    ClientName?: string;
}

interface DefaultBase extends Dto<Default>
{
    /**
    * DocumentSet
    */
    // @ApiMember(Description="DocumentSet", IsRequired=true, Name="DiseaseState")
    DiseaseState?: Reference;

    /**
    * Primary Key of DocumentSet
    */
    // @ApiMember(Description="Primary Key of DocumentSet", Name="DiseaseStateId")
    DiseaseStateId?: number;

    /**
    * Role
    */
    // @ApiMember(Description="Role", Name="Role")
    Role?: Reference;

    /**
    * Primary Key of Role
    */
    // @ApiMember(Description="Primary Key of Role", Name="RoleId")
    RoleId?: number;

    /**
    * Scope
    */
    // @ApiMember(Description="Scope", IsRequired=true, Name="Scope")
    Scope?: Reference;

    /**
    * Primary Key of Scope
    */
    // @ApiMember(Description="Primary Key of Scope", Name="ScopeId")
    ScopeId?: number;

    /**
    * DocumentSet
    */
    // @ApiMember(Description="DocumentSet", IsRequired=true, Name="TherapeuticArea")
    TherapeuticArea?: Reference;

    /**
    * Primary Key of DocumentSet
    */
    // @ApiMember(Description="Primary Key of DocumentSet", Name="TherapeuticAreaId")
    TherapeuticAreaId?: number;
}

// @Route("/default/{Id}", "GET, PATCH, PUT")
// @Route("/default", "POST")
interface Default extends DefaultBase, IReturn<Default>, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

interface DefaultSearchBase extends Search_1<Default>
{
    Id?: number;
    IdAfter?: number;
    IdBefore?: number;
    DiseaseState?: Reference;
    DiseaseStateIds?: number[];
    Role?: Reference;
    RoleIds?: number[];
    Scope?: Reference;
    ScopeIds?: number[];
    TherapeuticArea?: Reference;
    TherapeuticAreaIds?: number[];
}

interface QueryBase
{
    // @DataMember(Order=1)
    Skip?: number;

    // @DataMember(Order=2)
    Take?: number;

    // @DataMember(Order=3)
    OrderBy?: string;

    // @DataMember(Order=4)
    OrderByDesc?: string;

    // @DataMember(Order=5)
    Include?: string;

    // @DataMember(Order=6)
    Fields?: string;

    // @DataMember(Order=7)
    Meta?: { [index:string]: string; };
}

interface QueryDb_2<From, Into> extends QueryBase
{
}

interface MiniProfiler
{
    RowId?: number;
    Id?: string;
    RootTimingId?: string;
    Name?: string;
    Started?: string;
    DurationMilliseconds?: number;
    User?: string;
    HasUserViewed?: boolean;
    MachineName?: string;
    // @StringLength(2147483647)
    CustomLinksJson?: string;

    ClientTimingsRedirectCount?: number;
    SessionId?: string;
    ClientId?: string;
    // @StringLength(2147483647)
    Results?: string;
}

interface ProfilerStack
{
    Id?: string;
    Started?: string;
    DurationMilliseconds?: number;
    User?: string;
    Name?: string;
    SessionId?: string;
    ClientId?: string;
    Results?: string;
}

// @DataContract
interface ResponseError
{
    // @DataMember(Order=1, EmitDefaultValue=false)
    ErrorCode?: string;

    // @DataMember(Order=2, EmitDefaultValue=false)
    FieldName?: string;

    // @DataMember(Order=3, EmitDefaultValue=false)
    Message?: string;

    // @DataMember(Order=4, EmitDefaultValue=false)
    Meta?: { [index:string]: string; };
}

// @DataContract
interface ResponseStatus
{
    // @DataMember(Order=1)
    ErrorCode?: string;

    // @DataMember(Order=2)
    Message?: string;

    // @DataMember(Order=3)
    StackTrace?: string;

    // @DataMember(Order=4)
    Errors?: ResponseError[];

    // @DataMember(Order=5)
    Meta?: { [index:string]: string; };
}

interface QueryDb_1<T> extends QueryBase
{
}

interface Timing
{
    RowId?: number;
    Id?: string;
    MiniProfilerId?: string;
    ParentTimingId?: string;
    Name?: string;
    StartMilliseconds?: number;
    DurationMilliseconds?: number;
    IsRoot?: boolean;
    Date?: string;
    Depth?: number;
    // @StringLength(2147483647)
    CustomTimingsJson?: string;
}

interface RequestLog
{
    Id?: number;
    ExceptionSource?: string;
    // @StringLength(2147483647)
    ErrorResponse?: string;

    // @StringLength(2147483647)
    ResponseDto?: string;

    // @StringLength(2147483647)
    Session?: string;

    Items?: { [index:string]: string; };
    FormData?: { [index:string]: string; };
    Headers?: { [index:string]: string; };
    Referer?: string;
    ForwardedFor?: string;
    IpAddress?: string;
    SessionId?: string;
    UserAuthId?: string;
    // @StringLength(2147483647)
    RequestDto?: string;

    // @StringLength(2147483647)
    RequestBody?: string;

    PathInfo?: string;
    AbsoluteUri?: string;
    HttpMethod?: string;
    StatusDescription?: string;
    StatusCode?: number;
    DateTime?: string;
    ExceptionData?: { [index:string]: string; };
    RequestDuration?: string;
    IsError?: boolean;
    MiniProfilerId?: string;
}

interface ImpersonationBase extends Dto<Impersonation>
{
    /**
    * User
    */
    // @ApiMember(Description="User", IsRequired=true, Name="AuthenticatedUser")
    AuthenticatedUser?: Reference;

    /**
    * Primary Key of User
    */
    // @ApiMember(Description="Primary Key of User", Name="AuthenticatedUserId")
    AuthenticatedUserId?: number;

    /**
    * User
    */
    // @ApiMember(Description="User", IsRequired=true, Name="ImpersonatedUser")
    ImpersonatedUser?: Reference;

    /**
    * Primary Key of User
    */
    // @ApiMember(Description="Primary Key of User", Name="ImpersonatedUserId")
    ImpersonatedUserId?: number;

    /**
    * UserSession
    */
    // @ApiMember(Description="UserSession", Name="UserSession")
    UserSession?: Reference;

    /**
    * Primary Key of UserSession
    */
    // @ApiMember(Description="Primary Key of UserSession", Name="UserSessionId")
    UserSessionId?: number;
}

// @Route("/impersonation/{Id}", "GET")
interface Impersonation extends ImpersonationBase, IReturn<Impersonation>, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

interface ImpersonationSearchBase extends Search_1<Impersonation>
{
    Id?: number;
    IdAfter?: number;
    IdBefore?: number;
    AuthenticatedUser?: Reference;
    AuthenticatedUserIds?: number[];
    ImpersonatedUser?: Reference;
    ImpersonatedUserIds?: number[];
    UserSession?: Reference;
    UserSessionIds?: number[];
}

interface AppBase extends Dto<App>
{
    /**
    * string
    */
    // @ApiMember(Description="string", Name="Description")
    Description?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", IsRequired=true, Name="Name")
    Name?: string;

    /**
    * Page
    */
    // @ApiMember(Description="Page", Name="Pages")
    Pages?: Reference[];

    PagesIds?: number[];
    PagesCount?: number;
    /**
    * Role
    */
    // @ApiMember(Description="Role", Name="Roles")
    Roles?: Reference[];

    RolesIds?: number[];
    RolesCount?: number;
    /**
    * Scope
    */
    // @ApiMember(Description="Scope", Name="Scopes")
    Scopes?: Reference[];

    ScopesIds?: number[];
    ScopesCount?: number;
}

// @Route("/app/{Id}", "GET, PATCH, PUT")
interface App extends AppBase, IReturn<App>, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

interface AppSearchBase extends Search_1<App>
{
    Id?: number;
    IdAfter?: number;
    IdBefore?: number;
    Description?: string;
    Descriptions?: string[];
    Name?: string;
    Names?: string[];
    PagesIds?: number[];
    RolesIds?: number[];
    ScopesIds?: number[];
}

interface ApiRequestContext
{
    UserId?: number;
    ImpersonatingUserId?: number;
    SessionId?: string;
    TemporarySessionId?: string;
    ClientId?: string;
    IpAddress?: string;
    Time?: string;
    Method?: string;
    Path?: string;
    Url?: string;
}

interface AuditRecordBase extends Dto<AuditRecord>
{
    /**
    * string
    */
    // @ApiMember(Description="string", Name="Action")
    Action?: string;

    /**
    * BackgroundTask
    */
    // @ApiMember(Description="BackgroundTask", Name="BackgroundTask")
    BackgroundTask?: Reference;

    /**
    * Primary Key of BackgroundTask
    */
    // @ApiMember(Description="Primary Key of BackgroundTask", Name="BackgroundTaskId")
    BackgroundTaskId?: number;

    /**
    * DateTime?
    */
    // @ApiMember(Description="DateTime?", IsRequired=true, Name="ChangedOnDate")
    ChangedOnDate?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="Data")
    Data?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="DatabaseSessionId")
    DatabaseSessionId?: string;

    /**
    * AuditDelta
    */
    // @ApiMember(Description="AuditDelta", Name="Deltas")
    Deltas?: Reference[];

    DeltasIds?: number[];
    DeltasCount?: number;
    /**
    * int?
    */
    // @ApiMember(Description="int?", Name="EntityId")
    EntityId?: number;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="EntityType")
    EntityType?: string;

    /**
    * int?
    */
    // @ApiMember(Description="int?", Name="EntityVersion")
    EntityVersion?: number;

    /**
    * Event
    */
    // @ApiMember(Description="Event", Name="Events")
    Events?: Reference[];

    EventsIds?: number[];
    EventsCount?: number;
    /**
    * Impersonation
    */
    // @ApiMember(Description="Impersonation", Name="Impersonation")
    Impersonation?: Reference;

    /**
    * Primary Key of Impersonation
    */
    // @ApiMember(Description="Primary Key of Impersonation", Name="ImpersonationId")
    ImpersonationId?: number;

    /**
    * int?
    */
    // @ApiMember(Description="int?", Name="TargetId")
    TargetId?: number;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="TargetType")
    TargetType?: string;

    /**
    * int?
    */
    // @ApiMember(Description="int?", Name="TargetVersion")
    TargetVersion?: number;

    /**
    * User
    */
    // @ApiMember(Description="User", Name="User")
    User?: Reference;

    /**
    * Primary Key of User
    */
    // @ApiMember(Description="Primary Key of User", Name="UserId")
    UserId?: number;

    /**
    * UserSession
    */
    // @ApiMember(Description="UserSession", Name="UserSession")
    UserSession?: Reference;

    /**
    * Primary Key of UserSession
    */
    // @ApiMember(Description="Primary Key of UserSession", Name="UserSessionId")
    UserSessionId?: number;

    ApiRequestContext?: ApiRequestContext;
    /**
    * string
    */
    // @ApiMember(Description="string", Name="UserName")
    UserName?: string;
}

// @Route("/auditrecord/{Id}", "GET")
interface AuditRecord extends AuditRecordBase, IReturn<AuditRecord>, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

interface AuditRecordSearchBase extends Search_1<AuditRecord>
{
    Id?: number;
    IdAfter?: number;
    IdBefore?: number;
    Action?: string;
    Actions?: string[];
    BackgroundTask?: Reference;
    BackgroundTaskIds?: number[];
    ChangedOnDate?: string;
    ChangedOnDateAfter?: string;
    ChangedOnDateBefore?: string;
    Data?: string;
    Datas?: string[];
    DatabaseSessionId?: string;
    DatabaseSessionIds?: string[];
    DeltasIds?: number[];
    EntityId?: number;
    EntityType?: string;
    EntityTypes?: string[];
    EntityVersion?: number;
    EventsIds?: number[];
    Impersonation?: Reference;
    ImpersonationIds?: number[];
    TargetId?: number;
    TargetType?: string;
    TargetTypes?: string[];
    TargetVersion?: number;
    User?: Reference;
    UserIds?: number[];
    UserSession?: Reference;
    UserSessionIds?: number[];
    After?: string;
    Before?: string;
    EntityIds?: number[];
}

interface BackgroundTaskHistoryBase extends Dto<BackgroundTaskHistory>
{
    /**
    * int?
    */
    // @ApiMember(Description="int?", Name="Completed")
    Completed?: number;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="Data")
    Data?: string;

    /**
    * DateTime?
    */
    // @ApiMember(Description="DateTime?", Name="Ended")
    Ended?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="Errors")
    Errors?: string;

    /**
    * int?
    */
    // @ApiMember(Description="int?", Name="Failed")
    Failed?: number;

    /**
    * BackgroundTaskItem
    */
    // @ApiMember(Description="BackgroundTaskItem", Name="Items")
    Items?: Reference[];

    ItemsIds?: number[];
    ItemsCount?: number;
    /**
    * string
    */
    // @ApiMember(Description="string", Name="Logs")
    Logs?: string;

    /**
    * bool?
    */
    // @ApiMember(Description="bool?", Name="Succeeded")
    Succeeded?: boolean;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="Summary")
    Summary?: string;

    /**
    * BackgroundTask
    */
    // @ApiMember(Description="BackgroundTask", IsRequired=true, Name="Task")
    Task?: Reference;

    /**
    * Primary Key of BackgroundTask
    */
    // @ApiMember(Description="Primary Key of BackgroundTask", Name="TaskId")
    TaskId?: number;
}

// @Route("/backgroundtaskhistory/{Id}", "GET")
interface BackgroundTaskHistory extends BackgroundTaskHistoryBase, IReturn<BackgroundTaskHistory>, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

interface BackgroundTaskHistorySearchBase extends Search_1<BackgroundTaskHistory>
{
    Id?: number;
    IdAfter?: number;
    IdBefore?: number;
    Completed?: number;
    Data?: string;
    Datas?: string[];
    Ended?: string;
    EndedAfter?: string;
    EndedBefore?: string;
    Errors?: string;
    Errorss?: string[];
    Failed?: number;
    ItemsIds?: number[];
    Logs?: string;
    Logss?: string[];
    Succeeded?: boolean[];
    Summary?: string;
    Summarys?: string[];
    Task?: Reference;
    TaskIds?: number[];
}

interface ExceptionDto
{
    // @ApiMember(Name="InnerError")
    InnerError?: ExceptionDto;

    // @ApiMember(Name="Data")
    Data?: { [index:Object]: Object; };

    // @ApiMember(Name="HResult")
    HResult?: number;

    // @ApiMember(Name="HelpLink")
    HelpLink?: string;

    // @ApiMember(Name="Source")
    Source?: string;

    // @ApiMember(Name="Message")
    Message?: string;

    // @ApiMember(Name="StackTrace")
    StackTrace?: string;
}

interface BackgroundTaskBase extends Dto<BackgroundTask>
{
    /**
    * App
    */
    // @ApiMember(Description="App", IsRequired=true, Name="App")
    App?: Reference;

    /**
    * Primary Key of App
    */
    // @ApiMember(Description="Primary Key of App", Name="AppId")
    AppId?: number;

    /**
    * QueueChannel
    */
    // @ApiMember(Description="QueueChannel", Name="Channel")
    Channel?: Reference;

    /**
    * Primary Key of QueueChannel
    */
    // @ApiMember(Description="Primary Key of QueueChannel", Name="ChannelId")
    ChannelId?: number;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="Description")
    Description?: string;

    /**
    * bool
    */
    // @ApiMember(Description="bool", Name="Enabled")
    Enabled?: boolean;

    /**
    * int?
    */
    // @ApiMember(Description="int?", Name="Frequency")
    Frequency?: number;

    /**
    * int?
    */
    // @ApiMember(Description="int?", Name="HistoryRetention")
    HistoryRetention?: number;

    /**
    * BackgroundTaskItem
    */
    // @ApiMember(Description="BackgroundTaskItem", Name="Items")
    Items?: Reference[];

    ItemsIds?: number[];
    ItemsCount?: number;
    /**
    * bool
    */
    // @ApiMember(Description="bool", Name="KeepHistory")
    KeepHistory?: boolean;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="LastRunVersion")
    LastRunVersion?: string;

    /**
    * bool
    */
    // @ApiMember(Description="bool", Name="LogError")
    LogError?: boolean;

    /**
    * bool
    */
    // @ApiMember(Description="bool", Name="LogInfo")
    LogInfo?: boolean;

    /**
    * string
    */
    // @ApiMember(Description="string", IsRequired=true, Name="Name")
    Name?: string;

    /**
    * int?
    */
    // @ApiMember(Description="int?", Name="RowsToProcessPerIteration")
    RowsToProcessPerIteration?: number;

    /**
    * bool
    */
    // @ApiMember(Description="bool", Name="RunNow")
    RunNow?: boolean;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="StartAt")
    StartAt?: string;

    /**
    * BackgroundTaskHistory
    */
    // @ApiMember(Description="BackgroundTaskHistory", Name="TaskHistory")
    TaskHistory?: Reference[];

    TaskHistoryIds?: number[];
    TaskHistoryCount?: number;
    Started?: string;
    Ended?: string;
    Running?: boolean;
    CurrentReference?: Reference;
    CurrentPackage?: Reference;
    CurrentDocumentSet?: Reference;
    LastRowProcessed?: string;
    Stopped?: string;
    LastError?: ExceptionDto;
    LastStatus?: string;
}

// @Route("/backgroundtask/{Id}", "GET, PATCH, PUT")
interface BackgroundTask extends BackgroundTaskBase, IReturn<BackgroundTask>, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

interface BackgroundTaskSearchBase extends Search_1<BackgroundTask>
{
    Id?: number;
    IdAfter?: number;
    IdBefore?: number;
    App?: Reference;
    AppIds?: number[];
    Channel?: Reference;
    ChannelIds?: number[];
    Description?: string;
    Descriptions?: string[];
    Enabled?: boolean[];
    Frequency?: number;
    HistoryRetention?: number;
    ItemsIds?: number[];
    KeepHistory?: boolean[];
    LastRunVersion?: string;
    LastRunVersions?: string[];
    LogError?: boolean[];
    LogInfo?: boolean[];
    Name?: string;
    Names?: string[];
    RowsToProcessPerIteration?: number;
    RunNow?: boolean[];
    StartAt?: string;
    StartAts?: string[];
    TaskHistoryIds?: number[];
}

interface BroadcastBase extends Dto<Broadcast>
{
    /**
    * App
    */
    // @ApiMember(Description="App", IsRequired=true, Name="App")
    App?: Reference;

    /**
    * Primary Key of App
    */
    // @ApiMember(Description="Primary Key of App", Name="AppId")
    AppId?: number;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="ConfluenceId")
    ConfluenceId?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", IsRequired=true, Name="Name")
    Name?: string;

    /**
    * bool
    */
    // @ApiMember(Description="bool", Name="Reprocess")
    Reprocess?: boolean;

    /**
    * DateTime?
    */
    // @ApiMember(Description="DateTime?", Name="Reprocessed")
    Reprocessed?: string;

    /**
    * Scope
    */
    // @ApiMember(Description="Scope", Name="Scopes")
    Scopes?: Reference[];

    ScopesIds?: number[];
    ScopesCount?: number;
    /**
    * LookupTable
    */
    // @ApiMember(Description="LookupTable", Name="Status")
    Status?: Reference;

    /**
    * Primary Key of LookupTable
    */
    // @ApiMember(Description="Primary Key of LookupTable", Name="StatusId")
    StatusId?: number;

    /**
    * LookupTable
    */
    // @ApiMember(Description="LookupTable", IsRequired=true, Name="Type")
    Type?: Reference;

    /**
    * Primary Key of LookupTable
    */
    // @ApiMember(Description="Primary Key of LookupTable", Name="TypeId")
    TypeId?: number;

    History?: AuditRecord[];
}

// @Route("/broadcast/{Id}", "GET, PATCH, PUT, DELETE")
// @Route("/broadcast", "POST")
interface Broadcast extends BroadcastBase, IReturn<Broadcast>, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

interface BroadcastSearchBase extends Search_1<Broadcast>
{
    Id?: number;
    IdAfter?: number;
    IdBefore?: number;
    App?: Reference;
    AppIds?: number[];
    ConfluenceId?: string;
    ConfluenceIds?: string[];
    Name?: string;
    Names?: string[];
    Reprocess?: boolean[];
    Reprocessed?: string;
    ReprocessedAfter?: string;
    ReprocessedBefore?: string;
    ScopesIds?: number[];
    Status?: Reference;
    StatusIds?: number[];
    StatusNames?: string[];
    Type?: Reference;
    TypeIds?: number[];
    TypeNames?: string[];
}

interface CharacteristicBase extends Dto<Characteristic>
{
    /**
    * DocumentSet
    */
    // @ApiMember(Description="DocumentSet", Name="DocumentSets")
    DocumentSets?: Reference[];

    DocumentSetsIds?: number[];
    DocumentSetsCount?: number;
    /**
    * string
    */
    // @ApiMember(Description="string", IsRequired=true, Name="Name")
    Name?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="URI")
    URI?: string;
}

// @Route("/characteristic/{Id}", "GET, PATCH, PUT, DELETE")
// @Route("/characteristic", "POST")
interface Characteristic extends CharacteristicBase, IReturn<Characteristic>, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

interface CharacteristicSearchBase extends Search_1<Characteristic>
{
    Id?: number;
    IdAfter?: number;
    IdBefore?: number;
    DocumentSetsIds?: number[];
    Name?: string;
    Names?: string[];
    URI?: string;
    URIs?: string[];
}

interface ClientBase extends Dto<Client>
{
    /**
    * Locale
    */
    // @ApiMember(Description="Locale", Name="DefaultLocale")
    DefaultLocale?: Reference;

    /**
    * Primary Key of Locale
    */
    // @ApiMember(Description="Primary Key of Locale", Name="DefaultLocaleId")
    DefaultLocaleId?: number;

    /**
    * Division
    */
    // @ApiMember(Description="Division", Name="Divisions")
    Divisions?: Reference[];

    DivisionsIds?: number[];
    DivisionsCount?: number;
    /**
    * DocumentSet
    */
    // @ApiMember(Description="DocumentSet", Name="DocumentSets")
    DocumentSets?: Reference[];

    DocumentSetsIds?: number[];
    DocumentSetsCount?: number;
    /**
    * string
    */
    // @ApiMember(Description="string", IsRequired=true, Name="Name")
    Name?: string;

    /**
    * Project
    */
    // @ApiMember(Description="Project", Name="Projects")
    Projects?: Reference[];

    ProjectsIds?: number[];
    ProjectsCount?: number;
    /**
    * Role
    */
    // @ApiMember(Description="Role", IsRequired=true, Name="Role")
    Role?: Reference;

    /**
    * Primary Key of Role
    */
    // @ApiMember(Description="Primary Key of Role", Name="RoleId")
    RoleId?: number;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="SalesforceAccountId")
    SalesforceAccountId?: string;

    /**
    * Scope
    */
    // @ApiMember(Description="Scope", Name="Scopes")
    Scopes?: Reference[];

    ScopesIds?: number[];
    ScopesCount?: number;
    /**
    * JsonObject
    */
    // @ApiMember(Description="JsonObject", Name="Settings")
    Settings?: JsonObject;

    Type?: string;
    /**
    * Bindings
    */
    // @ApiMember(Description="Bindings", Name="Bindings")
    Bindings?: Reference[];

    /**
    * Users
    */
    // @ApiMember(Description="Users", Name="Users")
    Users?: Reference[];

    /**
    * List of UserIds
    */
    // @ApiMember(Description="List of UserIds", Name="UsersIds")
    UsersIds?: number[];

    /**
    * Workflows
    */
    // @ApiMember(Description="Workflows", Name="Workflows")
    Workflows?: Reference[];

    /**
    * Shares
    */
    // @ApiMember(Description="Shares", Name="Shares")
    Shares?: Reference[];
}

// @Route("/client/{Id}", "GET, PATCH, PUT, DELETE")
// @Route("/client", "POST")
interface Client extends ClientBase, IReturn<Client>, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

interface ClientSearchBase extends Search_1<Client>
{
    Id?: number;
    IdAfter?: number;
    IdBefore?: number;
    DefaultLocale?: Reference;
    DefaultLocaleIds?: number[];
    DivisionsIds?: number[];
    DocumentSetsIds?: number[];
    Name?: string;
    Names?: string[];
    ProjectsIds?: number[];
    Role?: Reference;
    RoleIds?: number[];
    SalesforceAccountId?: string;
    SalesforceAccountIds?: string[];
    ScopesIds?: number[];
    Settings?: string;
    Settingss?: string[];
}

interface NotificationSettings
{
    // @DataMember(Name="email")
    // @ApiMember(Name="email")
    Email?: boolean;

    // @DataMember(Name="slack")
    // @ApiMember(Name="slack")
    Slack?: boolean;

    // @DataMember(Name="in-app")
    // @ApiMember(Name="in-app")
    InApp?: boolean;

    // @DataMember(Name="all-environments")
    // @ApiMember(Name="all-environments")
    AllEnvironments?: boolean;
}

interface DocumentSetSettings
{
    FramedQuestion?: number;
    LibraryPackage?: number;
}

/**
* Data Export Settings
*/
// @Api(Description="Data Export Settings")
// @DataContract
interface ExportSettings
{
    // @DataMember(Name="version")
    // @ApiMember(Name="version")
    Version?: string;

    // @DataMember(Name="select-comparisons")
    // @ApiMember(Name="select-comparisons")
    SelectComparisons?: boolean;

    // @DataMember(Name="select-subgroups")
    // @ApiMember(Name="select-subgroups")
    SelectSubgroups?: boolean;

    // @DataMember(Name="subgroup-behavior")
    // @ApiMember(Name="subgroup-behavior")
    SubgroupBehavior?: string;

    // @DataMember(Name="include-dosage")
    // @ApiMember(Name="include-dosage")
    IncludeDosage?: boolean;

    // @DataMember(Name="dosage-rendering")
    // @ApiMember(Name="dosage-rendering")
    DosageRendering?: string;

    // @DataMember(Name="exclude-na")
    // @ApiMember(Name="exclude-na")
    ExcludeNa?: boolean;

    // @DataMember(Name="include-location")
    // @ApiMember(Name="include-location")
    IncludeLocation?: boolean;

    // @DataMember(Name="include-definitions")
    // @ApiMember(Name="include-definitions")
    IncludeDefinitions?: boolean;

    // @DataMember(Name="include-note")
    // @ApiMember(Name="include-note")
    IncludeNote?: boolean;

    // @DataMember(Name="include-pdf-locations")
    // @ApiMember(Name="include-pdf-locations")
    IncludePdfLocations?: boolean;

    // @DataMember(Name="include-reversed-ams")
    // @ApiMember(Name="include-reversed-ams")
    IncludeReversedAms?: boolean;

    // @DataMember(Name="include-calculated-ams")
    // @ApiMember(Name="include-calculated-ams")
    IncludeCalculatedAms?: boolean;

    // @DataMember(Name="enable-filtering")
    // @ApiMember(Name="enable-filtering")
    EnableFiltering?: boolean;

    // @DataMember(Name="includeUnanalyzable")
    // @ApiMember(Name="includeUnanalyzable")
    IncludeUnanalyzable?: boolean;
}

/**
* User Settings
*/
// @Api(Description="User Settings")
// @DataContract
interface UserSettings
{
    // @DataMember(Name="IsSI")
    // @ApiMember(Name="IsSI")
    IsSI?: boolean;

    // @DataMember(Name="FriendlyNames")
    // @ApiMember(Name="FriendlyNames")
    FriendlyNames?: boolean;

    // @DataMember(Name="TimepointUnit")
    // @ApiMember(Name="TimepointUnit")
    TimepointUnit?: string;

    // @DataMember(Name="ShowUnbound")
    // @ApiMember(Name="ShowUnbound")
    ShowUnbound?: boolean;

    // @DataMember(Name="ShowVarianceType")
    // @ApiMember(Name="ShowVarianceType")
    ShowVarianceType?: boolean;

    // @DataMember(Name="ShowFilteredTerms")
    // @ApiMember(Name="ShowFilteredTerms")
    ShowFilteredTerms?: boolean;

    // @DataMember(Name="notifications")
    // @ApiMember(Name="notifications")
    Notifications?: NotificationSettings;

    // @DataMember(Name="DocumentSets")
    // @ApiMember(Name="DocumentSets")
    DocumentSets?: { [index:number]: DocumentSetSettings; };

    // @DataMember(Name="ExportSettings")
    // @ApiMember(Name="ExportSettings")
    ExportSettings?: ExportSettings;
}

interface DivisionSettings
{
    // @DataMember(Name="user-settings")
    // @ApiMember(Name="user-settings")
    UserSettings?: UserSettings;
}

interface DivisionBase extends Dto<Division>
{
    /**
    * Client
    */
    // @ApiMember(Description="Client", IsRequired=true, Name="Client")
    Client?: Reference;

    /**
    * Primary Key of Client
    */
    // @ApiMember(Description="Primary Key of Client", Name="ClientId")
    ClientId?: number;

    /**
    * Locale
    */
    // @ApiMember(Description="Locale", Name="DefaultLocale")
    DefaultLocale?: Reference;

    /**
    * Primary Key of Locale
    */
    // @ApiMember(Description="Primary Key of Locale", Name="DefaultLocaleId")
    DefaultLocaleId?: number;

    /**
    * DocumentSet
    */
    // @ApiMember(Description="DocumentSet", Name="DocumentSets")
    DocumentSets?: Reference[];

    DocumentSetsIds?: number[];
    DocumentSetsCount?: number;
    /**
    * string
    */
    // @ApiMember(Description="string", IsRequired=true, Name="Name")
    Name?: string;

    /**
    * Role
    */
    // @ApiMember(Description="Role", IsRequired=true, Name="Role")
    Role?: Reference;

    /**
    * Primary Key of Role
    */
    // @ApiMember(Description="Primary Key of Role", Name="RoleId")
    RoleId?: number;

    /**
    * DivisionSettings
    */
    // @ApiMember(Description="DivisionSettings", Name="Settings")
    Settings?: DivisionSettings;

    /**
    * User
    */
    // @ApiMember(Description="User", Name="Users")
    Users?: Reference[];

    UsersIds?: number[];
    UsersCount?: number;
}

// @Route("/division", "POST")
// @Route("/division/{Id}", "GET, PATCH, PUT, DELETE")
interface Division extends DivisionBase, IReturn<Division>, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

interface DivisionSearchBase extends Search_1<Division>
{
    Id?: number;
    IdAfter?: number;
    IdBefore?: number;
    Client?: Reference;
    ClientIds?: number[];
    DefaultLocale?: Reference;
    DefaultLocaleIds?: number[];
    DocumentSetsIds?: number[];
    Name?: string;
    Names?: string[];
    Role?: Reference;
    RoleIds?: number[];
    Settings?: string;
    Settingss?: string[];
    UsersIds?: number[];
}

interface DocumentBase extends Dto<Document>
{
    /**
    * string
    */
    // @ApiMember(Description="string", Name="Abstract")
    Abstract?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="AccessionID")
    AccessionID?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="Acronym")
    Acronym?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="ArticleId")
    ArticleId?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="Authors")
    Authors?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="CochraneID")
    CochraneID?: string;

    /**
    * bool
    */
    // @ApiMember(Description="bool", Name="Confidential")
    Confidential?: boolean;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="CorporateAuthor")
    CorporateAuthor?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="Country")
    Country?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="CustomData")
    CustomData?: string;

    /**
    * LookupTable
    */
    // @ApiMember(Description="LookupTable", Name="DatabaseType")
    DatabaseType?: Reference;

    /**
    * Primary Key of LookupTable
    */
    // @ApiMember(Description="Primary Key of LookupTable", Name="DatabaseTypeId")
    DatabaseTypeId?: number;

    /**
    * DocumentSet
    */
    // @ApiMember(Description="DocumentSet", Name="DocumentSets")
    DocumentSets?: Reference[];

    DocumentSetsIds?: number[];
    DocumentSetsCount?: number;
    /**
    * LookupTable
    */
    // @ApiMember(Description="LookupTable", Name="DocumentType")
    DocumentType?: Reference;

    /**
    * Primary Key of LookupTable
    */
    // @ApiMember(Description="Primary Key of LookupTable", Name="DocumentTypeId")
    DocumentTypeId?: number;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="DOI")
    DOI?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="EmbaseAccessionNumber")
    EmbaseAccessionNumber?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="Emtree")
    Emtree?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="ErrataText")
    ErrataText?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="FullText")
    FullText?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="FullTextURL")
    FullTextURL?: string;

    /**
    * ImportData
    */
    // @ApiMember(Description="ImportData", Name="Import")
    Import?: Reference;

    /**
    * Primary Key of ImportData
    */
    // @ApiMember(Description="Primary Key of ImportData", Name="ImportId")
    ImportId?: number;

    /**
    * LookupTable
    */
    // @ApiMember(Description="LookupTable", Name="ImportType")
    ImportType?: Reference;

    /**
    * Primary Key of LookupTable
    */
    // @ApiMember(Description="Primary Key of LookupTable", Name="ImportTypeId")
    ImportTypeId?: number;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="Institution")
    Institution?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="ISSN")
    ISSN?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="Issue")
    Issue?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="JournalTitle")
    JournalTitle?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="LegacyModel")
    LegacyModel?: string;

    /**
    * DateTime?
    */
    // @ApiMember(Description="DateTime?", Name="LegacySync")
    LegacySync?: string;

    /**
    * LookupTable
    */
    // @ApiMember(Description="LookupTable", Name="LookupTables")
    LookupTables?: Reference[];

    LookupTablesIds?: number[];
    LookupTablesCount?: number;
    /**
    * int?
    */
    // @ApiMember(Description="int?", Name="MedlineID")
    MedlineID?: number;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="MeSH")
    MeSH?: string;

    /**
    * DocumentSet
    */
    // @ApiMember(Description="DocumentSet", Name="NonDigitizedDocumentSets")
    NonDigitizedDocumentSets?: Reference[];

    NonDigitizedDocumentSetsIds?: number[];
    NonDigitizedDocumentSetsCount?: number;
    /**
    * string
    */
    // @ApiMember(Description="string", Name="Pages")
    Pages?: string;

    /**
    * char?
    */
    // @ApiMember(Description="char?", Name="ParentChildStatus")
    ParentChildStatus?: string;

    /**
    * int?
    */
    // @ApiMember(Description="int?", Name="ParentID")
    ParentID?: number;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="PublicationDate")
    PublicationDate?: string;

    /**
    * int?
    */
    // @ApiMember(Description="int?", Name="PublicationYear")
    PublicationYear?: number;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="PubType")
    PubType?: string;

    /**
    * ReconcileDocument
    */
    // @ApiMember(Description="ReconcileDocument", Name="Reconciliation")
    Reconciliation?: Reference;

    /**
    * Primary Key of ReconcileDocument
    */
    // @ApiMember(Description="Primary Key of ReconcileDocument", Name="ReconciliationId")
    ReconciliationId?: number;

    /**
    * int?
    */
    // @ApiMember(Description="int?", Name="ReferenceStudy")
    ReferenceStudy?: number;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="SecondarySourceID")
    SecondarySourceID?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="Source")
    Source?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="SourceReferenceId")
    SourceReferenceId?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="StorageModel")
    StorageModel?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="SupplementalFiles")
    SupplementalFiles?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="TaStudyDesign")
    TaStudyDesign?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="Title")
    Title?: string;

    /**
    * short?
    */
    // @ApiMember(Description="short?", Name="TrialOutcome")
    TrialOutcome?: number;

    /**
    * VariableInstance
    */
    // @ApiMember(Description="VariableInstance", Name="VariableData")
    VariableData?: Reference[];

    VariableDataIds?: number[];
    VariableDataCount?: number;
    /**
    * string
    */
    // @ApiMember(Description="string", Name="Volume")
    Volume?: string;

    /**
    * Hashed id used for linking to the PDF version of this document
    */
    // @ApiMember(Description="Hashed id used for linking to the PDF version of this document", Name="EncryptedKbaseId")
    EncryptedKbaseId?: string;

    /**
    * First author name of all the authors listed on this document
    */
    // @ApiMember(Description="First author name of all the authors listed on this document", Name="FirstAuthor")
    FirstAuthor?: string;

    /**
    * Descriptive name of this document
    */
    // @ApiMember(Description="Descriptive name of this document", Name="Name")
    Name?: string;

    /**
    * Import/availability status of this document
    */
    // @ApiMember(Description="Import/availability status of this document", Name="Status")
    Status?: Reference;
}

// @Route("/document", "POST")
// @Route("/document/{Id}", "GET, PATCH, PUT, DELETE")
interface Document extends DocumentBase, IReturn<Document>, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

interface DocumentSearchBase extends Search_1<Document>
{
    Id?: number;
    IdAfter?: number;
    IdBefore?: number;
    Abstract?: string;
    Abstracts?: string[];
    AccessionID?: string;
    AccessionIDs?: string[];
    Acronym?: string;
    Acronyms?: string[];
    ArticleId?: string;
    ArticleIds?: string[];
    Authors?: string;
    Authorss?: string[];
    CochraneID?: string;
    CochraneIDs?: string[];
    Confidential?: boolean[];
    CorporateAuthor?: string;
    CorporateAuthors?: string[];
    Country?: string;
    Countrys?: string[];
    CustomData?: string;
    CustomDatas?: string[];
    DatabaseType?: Reference;
    DatabaseTypeIds?: number[];
    DatabaseTypeNames?: string[];
    DocumentSetsIds?: number[];
    DocumentType?: Reference;
    DocumentTypeIds?: number[];
    DocumentTypeNames?: string[];
    DOI?: string;
    DOIs?: string[];
    EmbaseAccessionNumber?: string;
    EmbaseAccessionNumbers?: string[];
    Emtree?: string;
    Emtrees?: string[];
    ErrataText?: string;
    ErrataTexts?: string[];
    FullText?: string;
    FullTexts?: string[];
    FullTextURL?: string;
    FullTextURLs?: string[];
    Import?: Reference;
    ImportIds?: number[];
    ImportType?: Reference;
    ImportTypeIds?: number[];
    ImportTypeNames?: string[];
    Institution?: string;
    Institutions?: string[];
    ISSN?: string;
    ISSNs?: string[];
    Issue?: string;
    Issues?: string[];
    JournalTitle?: string;
    JournalTitles?: string[];
    LegacyModel?: string;
    LegacyModels?: string[];
    LegacySync?: string;
    LegacySyncAfter?: string;
    LegacySyncBefore?: string;
    LookupTablesIds?: number[];
    MedlineID?: number;
    MeSH?: string;
    MeSHs?: string[];
    NonDigitizedDocumentSetsIds?: number[];
    Pages?: string;
    Pagess?: string[];
    ParentChildStatus?: string;
    ParentID?: number;
    PublicationDate?: string;
    PublicationDates?: string[];
    PublicationYear?: number;
    PubType?: string;
    PubTypes?: string[];
    Reconciliation?: Reference;
    ReconciliationIds?: number[];
    ReferenceStudy?: number;
    SecondarySourceID?: string;
    SecondarySourceIDs?: string[];
    Source?: string;
    Sources?: string[];
    SourceReferenceId?: string;
    SourceReferenceIds?: string[];
    StorageModel?: string;
    StorageModels?: string[];
    SupplementalFiles?: string;
    SupplementalFiless?: string[];
    TaStudyDesign?: string;
    TaStudyDesigns?: string[];
    Title?: string;
    Titles?: string[];
    TrialOutcome?: number;
    VariableDataIds?: number[];
    Volume?: string;
    Volumes?: string[];
    ReferenceStudies?: number[];
    StudySetIds?: number[];
    StudySetId?: number;
    DocumentSetId?: number;
    /**
    * Performs a full-text search against all PDF/article content
    */
    // @ApiMember(Description="Performs a full-text search against all PDF/article content", Name="ArticleSearch")
    ArticleSearch?: string;

    Digitized?: boolean;
}

interface DocumentSetBase extends Dto<DocumentSet>
{
    /**
    * string
    */
    // @ApiMember(Description="string", Name="AdditionalCriteria")
    AdditionalCriteria?: string;

    /**
    * Characteristic
    */
    // @ApiMember(Description="Characteristic", Name="Characteristics")
    Characteristics?: Reference[];

    CharacteristicsIds?: number[];
    CharacteristicsCount?: number;
    /**
    * Client
    */
    // @ApiMember(Description="Client", Name="Clients")
    Clients?: Reference[];

    ClientsIds?: number[];
    ClientsCount?: number;
    /**
    * Comparator
    */
    // @ApiMember(Description="Comparator", Name="Comparators")
    Comparators?: Reference[];

    ComparatorsIds?: number[];
    ComparatorsCount?: number;
    /**
    * bool
    */
    // @ApiMember(Description="bool", Name="Confidential")
    Confidential?: boolean;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="DataCollection")
    DataCollection?: string;

    /**
    * Division
    */
    // @ApiMember(Description="Division", Name="Divisions")
    Divisions?: Reference[];

    DivisionsIds?: number[];
    DivisionsCount?: number;
    /**
    * Document
    */
    // @ApiMember(Description="Document", Name="Documents")
    Documents?: Reference[];

    DocumentsIds?: number[];
    DocumentsCount?: number;
    /**
    * DocumentSet
    */
    // @ApiMember(Description="DocumentSet", Name="DocumentSets")
    DocumentSets?: Reference[];

    DocumentSetsIds?: number[];
    DocumentSetsCount?: number;
    /**
    * int?
    */
    // @ApiMember(Description="int?", Name="EvidencePortalId")
    EvidencePortalId?: number;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="ExtractionProtocol")
    ExtractionProtocol?: string;

    /**
    * int?
    */
    // @ApiMember(Description="int?", Name="FqId")
    FqId?: number;

    /**
    * int?
    */
    // @ApiMember(Description="int?", Name="FramedQuestionId")
    FramedQuestionId?: number;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="GeneralScope")
    GeneralScope?: string;

    /**
    * DocumentSetHistory
    */
    // @ApiMember(Description="DocumentSetHistory", Name="Histories")
    Histories?: Reference[];

    HistoriesIds?: number[];
    HistoriesCount?: number;
    /**
    * int?
    */
    // @ApiMember(Description="int?", Name="ImportPriority")
    ImportPriority?: number;

    /**
    * ImportData
    */
    // @ApiMember(Description="ImportData", Name="Imports")
    Imports?: Reference[];

    ImportsIds?: number[];
    ImportsCount?: number;
    /**
    * string
    */
    // @ApiMember(Description="string", Name="Indications")
    Indications?: string;

    /**
    * Intervention
    */
    // @ApiMember(Description="Intervention", Name="Interventions")
    Interventions?: Reference[];

    InterventionsIds?: number[];
    InterventionsCount?: number;
    /**
    * int?
    */
    // @ApiMember(Description="int?", Name="LibraryPackageId")
    LibraryPackageId?: number;

    /**
    * string
    */
    // @ApiMember(Description="string", IsRequired=true, Name="Name")
    Name?: string;

    /**
    * Document
    */
    // @ApiMember(Description="Document", Name="NonDigitizedDocuments")
    NonDigitizedDocuments?: Reference[];

    NonDigitizedDocumentsIds?: number[];
    NonDigitizedDocumentsCount?: number;
    /**
    * string
    */
    // @ApiMember(Description="string", Name="Notes")
    Notes?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="OriginalComparators")
    OriginalComparators?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="OriginalDatabase")
    OriginalDatabase?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="OriginalDesigns")
    OriginalDesigns?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="OriginalInterventions")
    OriginalInterventions?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="OriginalOutcomes")
    OriginalOutcomes?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="OriginalSearch")
    OriginalSearch?: string;

    /**
    * Outcome
    */
    // @ApiMember(Description="Outcome", Name="Outcomes")
    Outcomes?: Reference[];

    OutcomesIds?: number[];
    OutcomesCount?: number;
    /**
    * DocumentSet
    */
    // @ApiMember(Description="DocumentSet", Name="Owner")
    Owner?: Reference;

    /**
    * Primary Key of DocumentSet
    */
    // @ApiMember(Description="Primary Key of DocumentSet", Name="OwnerId")
    OwnerId?: number;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="Participants")
    Participants?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="PRISMA")
    PRISMA?: string;

    /**
    * Project
    */
    // @ApiMember(Description="Project", Name="Projects")
    Projects?: Reference[];

    ProjectsIds?: number[];
    ProjectsCount?: number;
    /**
    * Team
    */
    // @ApiMember(Description="Team", Name="ProjectTeam")
    ProjectTeam?: Reference;

    /**
    * Primary Key of Team
    */
    // @ApiMember(Description="Primary Key of Team", Name="ProjectTeamId")
    ProjectTeamId?: number;

    /**
    * int?
    */
    // @ApiMember(Description="int?", Name="ProtocolReferenceId")
    ProtocolReferenceId?: number;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="QUOROM")
    QUOROM?: string;

    /**
    * Scope
    */
    // @ApiMember(Description="Scope", Name="Scopes")
    Scopes?: Reference[];

    ScopesIds?: number[];
    ScopesCount?: number;
    /**
    * DateTime?
    */
    // @ApiMember(Description="DateTime?", Name="SearchEnd")
    SearchEnd?: string;

    /**
    * DateTime?
    */
    // @ApiMember(Description="DateTime?", Name="SearchStart")
    SearchStart?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="SearchStrategy")
    SearchStrategy?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="SelectionCriteria")
    SelectionCriteria?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="Settings")
    Settings?: string;

    /**
    * bool
    */
    // @ApiMember(Description="bool", Name="ShowEtw")
    ShowEtw?: boolean;

    /**
    * bool
    */
    // @ApiMember(Description="bool", Name="ShowPublicationType")
    ShowPublicationType?: boolean;

    /**
    * StatsStudySet
    */
    // @ApiMember(Description="StatsStudySet", Name="Stats")
    Stats?: Reference[];

    StatsIds?: number[];
    StatsCount?: number;
    /**
    * StudyDesign
    */
    // @ApiMember(Description="StudyDesign", Name="StudyDesigns")
    StudyDesigns?: Reference[];

    StudyDesignsIds?: number[];
    StudyDesignsCount?: number;
    /**
    * LookupTable
    */
    // @ApiMember(Description="LookupTable", Name="Type")
    Type?: Reference;

    /**
    * Primary Key of LookupTable
    */
    // @ApiMember(Description="Primary Key of LookupTable", Name="TypeId")
    TypeId?: number;

    /**
    * User
    */
    // @ApiMember(Description="User", Name="Users")
    Users?: Reference[];

    UsersIds?: number[];
    UsersCount?: number;
    Owners?: Reference[];
    /**
    * Bindings
    */
    // @ApiMember(Description="Bindings", Name="Bindings")
    Bindings?: Reference[];

    Shares?: Reference[];
    FQIDs?: string;
    /**
    * EoDs
    */
    // @ApiMember(Description="EoDs", Name="EoDs")
    EoDs?: Reference[];

    /**
    * Total Documents Count
    */
    // @ApiMember(Description="Total Documents Count", Name="TotalDocumentsCount")
    TotalDocumentsCount?: number;

    /**
    * All Project Links for Data Set
    */
    // @ApiMember(Description="All Project Links for Data Set", Name="ProjectLinks")
    ProjectLinks?: Reference[];

    /**
    * All Library Packages for Data Set
    */
    // @ApiMember(Description="All Library Packages for Data Set", Name="LibraryPackages")
    LibraryPackages?: Reference[];
}

// @Route("/documentset", "POST")
// @Route("/documentset/{Id}", "GET, PATCH, PUT, DELETE")
interface DocumentSet extends DocumentSetBase, IReturn<DocumentSet>, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

interface DocumentSetSearchBase extends Search_1<DocumentSet>
{
    Id?: number;
    IdAfter?: number;
    IdBefore?: number;
    AdditionalCriteria?: string;
    AdditionalCriterias?: string[];
    CharacteristicsIds?: number[];
    ClientsIds?: number[];
    ComparatorsIds?: number[];
    Confidential?: boolean[];
    DataCollection?: string;
    DataCollections?: string[];
    DivisionsIds?: number[];
    DocumentsIds?: number[];
    DocumentSetsIds?: number[];
    EvidencePortalId?: number;
    ExtractionProtocol?: string;
    ExtractionProtocols?: string[];
    FqId?: number;
    FramedQuestionId?: number;
    GeneralScope?: string;
    GeneralScopes?: string[];
    HistoriesIds?: number[];
    ImportPriority?: number;
    ImportsIds?: number[];
    Indications?: string;
    Indicationss?: string[];
    InterventionsIds?: number[];
    LibraryPackageId?: number;
    Name?: string;
    Names?: string[];
    NonDigitizedDocumentsIds?: number[];
    Notes?: string;
    Notess?: string[];
    OriginalComparators?: string;
    OriginalComparatorss?: string[];
    OriginalDatabase?: string;
    OriginalDatabases?: string[];
    OriginalDesigns?: string;
    OriginalDesignss?: string[];
    OriginalInterventions?: string;
    OriginalInterventionss?: string[];
    OriginalOutcomes?: string;
    OriginalOutcomess?: string[];
    OriginalSearch?: string;
    OriginalSearchs?: string[];
    OutcomesIds?: number[];
    Owner?: Reference;
    OwnerIds?: number[];
    Participants?: string;
    Participantss?: string[];
    PRISMA?: string;
    PRISMAs?: string[];
    ProjectsIds?: number[];
    ProjectTeam?: Reference;
    ProjectTeamIds?: number[];
    ProtocolReferenceId?: number;
    QUOROM?: string;
    QUOROMs?: string[];
    ScopesIds?: number[];
    SearchEnd?: string;
    SearchEndAfter?: string;
    SearchEndBefore?: string;
    SearchStart?: string;
    SearchStartAfter?: string;
    SearchStartBefore?: string;
    SearchStrategy?: string;
    SearchStrategys?: string[];
    SelectionCriteria?: string;
    SelectionCriterias?: string[];
    Settings?: string;
    Settingss?: string[];
    ShowEtw?: boolean[];
    ShowPublicationType?: boolean[];
    StatsIds?: number[];
    StudyDesignsIds?: number[];
    Type?: Reference;
    TypeIds?: number[];
    TypeNames?: string[];
    UsersIds?: number[];
    AppId?: number;
}

interface EventBase extends Dto<Event>
{
    /**
    * AuditRecord
    */
    // @ApiMember(Description="AuditRecord", IsRequired=true, Name="AuditRecord")
    AuditRecord?: Reference;

    /**
    * Primary Key of AuditRecord
    */
    // @ApiMember(Description="Primary Key of AuditRecord", Name="AuditRecordId")
    AuditRecordId?: number;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="Description")
    Description?: string;

    /**
    * DateTime?
    */
    // @ApiMember(Description="DateTime?", Name="Processed")
    Processed?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="Status")
    Status?: string;

    /**
    * Team
    */
    // @ApiMember(Description="Team", Name="Teams")
    Teams?: Reference[];

    TeamsIds?: number[];
    TeamsCount?: number;
    /**
    * Update
    */
    // @ApiMember(Description="Update", Name="Updates")
    Updates?: Reference[];

    UpdatesIds?: number[];
    UpdatesCount?: number;
    /**
    * User
    */
    // @ApiMember(Description="User", Name="Users")
    Users?: Reference[];

    UsersIds?: number[];
    UsersCount?: number;
    UserIds?: number[];
    TeamIds?: number[];
}

// @Route("/event/{Id}", "GET")
interface Event extends EventBase, IReturn<Event>, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

interface EventSearchBase extends Search_1<Event>
{
    Id?: number;
    IdAfter?: number;
    IdBefore?: number;
    AuditRecord?: Reference;
    AuditRecordIds?: number[];
    Description?: string;
    Descriptions?: string[];
    Processed?: string;
    ProcessedAfter?: string;
    ProcessedBefore?: string;
    Status?: string;
    Statuss?: string[];
    TeamsIds?: number[];
    UpdatesIds?: number[];
    UsersIds?: number[];
}

interface FeatureSetBase extends Dto<FeatureSet>
{
    /**
    * string
    */
    // @ApiMember(Description="string", Name="Description")
    Description?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", IsRequired=true, Name="Name")
    Name?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="PermissionTemplate")
    PermissionTemplate?: string;

    /**
    * Role
    */
    // @ApiMember(Description="Role", Name="Roles")
    Roles?: Reference[];

    RolesIds?: number[];
    RolesCount?: number;
}

// @Route("/featureset/{Id}", "GET, PATCH, PUT")
interface FeatureSet extends FeatureSetBase, IReturn<FeatureSet>, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

interface FeatureSetSearchBase extends Search_1<FeatureSet>
{
    Id?: number;
    IdAfter?: number;
    IdBefore?: number;
    Description?: string;
    Descriptions?: string[];
    Name?: string;
    Names?: string[];
    PermissionTemplate?: string;
    PermissionTemplates?: string[];
    RolesIds?: number[];
}

interface ImportDataBase extends Dto<ImportData>
{
    /**
    * DateTime?
    */
    // @ApiMember(Description="DateTime?", Name="CompletedOn")
    CompletedOn?: string;

    /**
    * Document
    */
    // @ApiMember(Description="Document", Name="Document")
    Document?: Reference;

    /**
    * Primary Key of Document
    */
    // @ApiMember(Description="Primary Key of Document", Name="DocumentId")
    DocumentId?: number;

    /**
    * DocumentSet
    */
    // @ApiMember(Description="DocumentSet", Name="DocumentSets")
    DocumentSets?: Reference[];

    DocumentSetsIds?: number[];
    DocumentSetsCount?: number;
    /**
    * string
    */
    // @ApiMember(Description="string", Name="ErrorData")
    ErrorData?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="ExtractUrl")
    ExtractUrl?: string;

    /**
    * bool
    */
    // @ApiMember(Description="bool", Name="HighPriority")
    HighPriority?: boolean;

    /**
    * bool
    */
    // @ApiMember(Description="bool", Name="ImportFr")
    ImportFr?: boolean;

    /**
    * LookupTable
    */
    // @ApiMember(Description="LookupTable", Name="ImportLocation")
    ImportLocation?: Reference;

    /**
    * Primary Key of LookupTable
    */
    // @ApiMember(Description="Primary Key of LookupTable", Name="ImportLocationId")
    ImportLocationId?: number;

    /**
    * bool
    */
    // @ApiMember(Description="bool", Name="ImportNewName")
    ImportNewName?: boolean;

    /**
    * bool
    */
    // @ApiMember(Description="bool", Name="ImportTable")
    ImportTable?: boolean;

    /**
    * bool
    */
    // @ApiMember(Description="bool", Name="ImportText")
    ImportText?: boolean;

    /**
    * LookupTable
    */
    // @ApiMember(Description="LookupTable", Name="ImportType")
    ImportType?: Reference;

    /**
    * Primary Key of LookupTable
    */
    // @ApiMember(Description="Primary Key of LookupTable", Name="ImportTypeId")
    ImportTypeId?: number;

    /**
    * bool
    */
    // @ApiMember(Description="bool", Name="IsLegacy")
    IsLegacy?: boolean;

    /**
    * int?
    */
    // @ApiMember(Description="int?", Name="Order")
    Order?: number;

    /**
    * int?
    */
    // @ApiMember(Description="int?", Name="ReferenceId")
    ReferenceId?: number;

    /**
    * User
    */
    // @ApiMember(Description="User", Name="RequestedBy")
    RequestedBy?: Reference;

    /**
    * Primary Key of User
    */
    // @ApiMember(Description="Primary Key of User", Name="RequestedById")
    RequestedById?: number;

    /**
    * DateTime?
    */
    // @ApiMember(Description="DateTime?", Name="RequestedOn")
    RequestedOn?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="SourceReferenceId")
    SourceReferenceId?: string;

    /**
    * DateTime?
    */
    // @ApiMember(Description="DateTime?", Name="StartedOn")
    StartedOn?: string;

    /**
    * LookupTable
    */
    // @ApiMember(Description="LookupTable", IsRequired=true, Name="Status")
    Status?: Reference;

    /**
    * Primary Key of LookupTable
    */
    // @ApiMember(Description="Primary Key of LookupTable", Name="StatusId")
    StatusId?: number;
}

// @Route("/importdata", "POST")
// @Route("/importdata/{Id}", "GET, PATCH, PUT, DELETE")
interface ImportData extends ImportDataBase, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

interface ImportDataSearchBase extends Search_1<ImportData>
{
    Id?: number;
    IdAfter?: number;
    IdBefore?: number;
    CompletedOn?: string;
    CompletedOnAfter?: string;
    CompletedOnBefore?: string;
    Document?: Reference;
    DocumentIds?: number[];
    DocumentSetsIds?: number[];
    ErrorData?: string;
    ErrorDatas?: string[];
    ExtractUrl?: string;
    ExtractUrls?: string[];
    HighPriority?: boolean[];
    ImportFr?: boolean[];
    ImportLocation?: Reference;
    ImportLocationIds?: number[];
    ImportLocationNames?: string[];
    ImportNewName?: boolean[];
    ImportTable?: boolean[];
    ImportText?: boolean[];
    ImportType?: Reference;
    ImportTypeIds?: number[];
    ImportTypeNames?: string[];
    IsLegacy?: boolean[];
    Order?: number;
    ReferenceId?: number;
    RequestedBy?: Reference;
    RequestedByIds?: number[];
    RequestedOn?: string;
    RequestedOnAfter?: string;
    RequestedOnBefore?: string;
    SourceReferenceId?: string;
    SourceReferenceIds?: string[];
    StartedOn?: string;
    StartedOnAfter?: string;
    StartedOnBefore?: string;
    Status?: Reference;
    StatusIds?: number[];
    StatusNames?: string[];
    ReferenceStudies?: number[];
    StudySetIds?: number[];
    StudySetId?: number;
    StudyId?: number;
    ReferenceStudy?: number;
}

interface InterventionBase extends Dto<Intervention>
{
    /**
    * DocumentSet
    */
    // @ApiMember(Description="DocumentSet", Name="DocumentSets")
    DocumentSets?: Reference[];

    DocumentSetsIds?: number[];
    DocumentSetsCount?: number;
    /**
    * string
    */
    // @ApiMember(Description="string", IsRequired=true, Name="Name")
    Name?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="URI")
    URI?: string;
}

// @Route("/intervention", "POST")
// @Route("/intervention/{Id}", "GET, PATCH, PUT, DELETE")
interface Intervention extends InterventionBase, IReturn<Intervention>, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

interface InterventionSearchBase extends Search_1<Intervention>
{
    Id?: number;
    IdAfter?: number;
    IdBefore?: number;
    DocumentSetsIds?: number[];
    Name?: string;
    Names?: string[];
    URI?: string;
    URIs?: string[];
}

interface Ref
{
    Id?: number;
    Name?: string;
}

interface Unit
{
    Id?: number;
    Name?: Ref;
}

interface UnitElement
{
    EqualityOperator?: string;
    Number?: number;
    Multiplier?: number;
    Unit?: Unit;
}

interface High
{
    Units?: UnitElement[];
}

interface Quantifier
{
    Gestalt?: string;
    Low?: High;
    High?: High;
}

interface Term
{
    IsDisplaySynonym?: boolean;
    IsRoot?: boolean;
    IsSubgroup?: boolean;
    SynonymId?: number;
    Quantifier?: string;
    ParsedQuantifier?: Quantifier;
}

interface Phrase
{
    Conjunction?: string;
    Terms?: Term[];
    Phrases?: Phrase[];
}

interface Bindings
{
    IsBound?: boolean;
    IsForced?: boolean;
    Phrases?: Phrase[];
}

interface LookupTableBindingBase extends Dto<LookupTableBinding>
{
    /**
    * Bindings
    */
    // @ApiMember(Description="Bindings", Name="Binding")
    Binding?: Bindings;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="BoundName")
    BoundName?: string;

    /**
    * LookupTable
    */
    // @ApiMember(Description="LookupTable", IsRequired=true, Name="LookupTable")
    LookupTable?: Reference;

    /**
    * Primary Key of LookupTable
    */
    // @ApiMember(Description="Primary Key of LookupTable", Name="LookupTableId")
    LookupTableId?: number;

    /**
    * Scope
    */
    // @ApiMember(Description="Scope", IsRequired=true, Name="Scope")
    Scope?: Reference;

    /**
    * Primary Key of Scope
    */
    // @ApiMember(Description="Primary Key of Scope", Name="ScopeId")
    ScopeId?: number;

    /**
    * TermSynonym
    */
    // @ApiMember(Description="TermSynonym", Name="Synonyms")
    Synonyms?: Reference[];

    SynonymsIds?: number[];
    SynonymsCount?: number;
    /**
    * Workflow
    */
    // @ApiMember(Description="Workflow", Name="Workflows")
    Workflows?: Reference[];

    WorkflowsIds?: number[];
    WorkflowsCount?: number;
    /**
    * Enum
    */
    // @ApiMember(Description="Enum", IsRequired=true, Name="Enum")
    Enum?: Reference;
}

// @Route("/lookuptablebinding/{Id}", "GET, PATCH, PUT, DELETE")
// @Route("/lookuptablebinding", "POST")
interface LookupTableBinding extends LookupTableBindingBase, IReturn<LookupTableBinding>, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

interface LookupTableBindingSearchBase extends Search_1<LookupTableBinding>
{
    Id?: number;
    IdAfter?: number;
    IdBefore?: number;
    Binding?: string;
    Bindings?: string[];
    BoundName?: string;
    BoundNames?: string[];
    LookupTable?: Reference;
    LookupTableIds?: number[];
    LookupTableNames?: string[];
    Scope?: Reference;
    ScopeIds?: number[];
    SynonymsIds?: number[];
    WorkflowsIds?: number[];
    EnumId?: number;
    EnumName?: string;
    StudySetId?: number;
    UserId?: number;
    ClientId?: number;
    UserIds?: number[];
    ClientIds?: number[];
    StudySetIds?: number[];
}

interface LookupTableBase extends Dto<LookupTable>
{
    /**
    * LookupTableBinding
    */
    // @ApiMember(Description="LookupTableBinding", Name="Bindings")
    Bindings?: Reference[];

    BindingsIds?: number[];
    BindingsCount?: number;
    /**
    * LookupCategory
    */
    // @ApiMember(Description="LookupCategory", Name="Categories")
    Categories?: Reference[];

    CategoriesIds?: number[];
    CategoriesCount?: number;
    /**
    * Document
    */
    // @ApiMember(Description="Document", Name="Documents")
    Documents?: Reference[];

    DocumentsIds?: number[];
    DocumentsCount?: number;
    /**
    * LookupTableEnum
    */
    // @ApiMember(Description="LookupTableEnum", IsRequired=true, Name="Enum")
    Enum?: Reference;

    /**
    * Primary Key of LookupTableEnum
    */
    // @ApiMember(Description="Primary Key of LookupTableEnum", Name="EnumId")
    EnumId?: number;

    /**
    * string
    */
    // @ApiMember(Description="string", IsRequired=true, Name="Name")
    Name?: string;

    SynonymNames?: string[];
}

// @Route("/lookuptable", "POST")
// @Route("/lookuptable/{Id}", "GET, PATCH, PUT, DELETE")
interface LookupTable extends LookupTableBase, IReturn<LookupTable>, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

interface LookupTableSearchBase extends Search_1<LookupTable>
{
    Id?: number;
    IdAfter?: number;
    IdBefore?: number;
    BindingsIds?: number[];
    CategoriesIds?: number[];
    DocumentsIds?: number[];
    Enum?: Reference;
    EnumIds?: number[];
    Name?: string;
    Names?: string[];
    LookupTableEnumId?: number;
    LookupTableEnum?: string;
    IsCharacteristic?: boolean;
    IsOutcome?: boolean;
}

interface OutcomeBase extends Dto<Outcome>
{
    /**
    * DocumentSet
    */
    // @ApiMember(Description="DocumentSet", Name="DocumentSets")
    DocumentSets?: Reference[];

    DocumentSetsIds?: number[];
    DocumentSetsCount?: number;
    /**
    * string
    */
    // @ApiMember(Description="string", IsRequired=true, Name="Name")
    Name?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="URI")
    URI?: string;
}

// @Route("/outcome", "POST")
// @Route("/outcome/{Id}", "GET, PATCH, PUT, DELETE")
interface Outcome extends OutcomeBase, IReturn<Outcome>, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

interface OutcomeSearchBase extends Search_1<Outcome>
{
    Id?: number;
    IdAfter?: number;
    IdBefore?: number;
    DocumentSetsIds?: number[];
    Name?: string;
    Names?: string[];
    URI?: string;
    URIs?: string[];
}

interface PageItem
{
    Name?: string;
    Title?: string;
    Category?: string;
    Link?: string;
    Icon?: string;
    Order?: number;
    Menu?: PageItem[];
    Description?: string;
    Hidden?: boolean;
}

interface PageBase extends Dto<Page>
{
    /**
    * App
    */
    // @ApiMember(Description="App", Name="Apps")
    Apps?: Reference[];

    AppsIds?: number[];
    AppsCount?: number;
    /**
    * string
    */
    // @ApiMember(Description="string", Name="Description")
    Description?: string;

    /**
    * Glossary
    */
    // @ApiMember(Description="Glossary", Name="Glossary")
    Glossary?: Reference[];

    GlossaryIds?: number[];
    GlossaryCount?: number;
    /**
    * Help
    */
    // @ApiMember(Description="Help", Name="Help")
    Help?: Reference[];

    HelpIds?: number[];
    HelpCount?: number;
    /**
    * string
    */
    // @ApiMember(Description="string", IsRequired=true, Name="Name")
    Name?: string;

    /**
    * Role
    */
    // @ApiMember(Description="Role", Name="Roles")
    Roles?: Reference[];

    RolesIds?: number[];
    RolesCount?: number;
    Title?: string;
    Icon?: string;
    Link?: string;
    Order?: number;
    PageItem?: PageItem;
}

// @Route("/page/{Id}", "GET, PATCH, PUT, DELETE")
// @Route("/page", "POST")
interface Page extends PageBase, IReturn<Page>, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

interface PageSearchBase extends Search_1<Page>
{
    Id?: number;
    IdAfter?: number;
    IdBefore?: number;
    AppsIds?: number[];
    Description?: string;
    Descriptions?: string[];
    GlossaryIds?: number[];
    HelpIds?: number[];
    Name?: string;
    Names?: string[];
    RolesIds?: number[];
}

interface RoleBase extends Dto<Role>
{
    /**
    * Team
    */
    // @ApiMember(Description="Team", Name="AdminTeam")
    AdminTeam?: Reference;

    /**
    * Primary Key of Team
    */
    // @ApiMember(Description="Primary Key of Team", Name="AdminTeamId")
    AdminTeamId?: number;

    /**
    * App
    */
    // @ApiMember(Description="App", Name="Apps")
    Apps?: Reference[];

    AppsIds?: number[];
    AppsCount?: number;
    /**
    * string
    */
    // @ApiMember(Description="string", Name="Description")
    Description?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="Features")
    Features?: string;

    /**
    * FeatureSet
    */
    // @ApiMember(Description="FeatureSet", Name="FeatureSets")
    FeatureSets?: Reference[];

    FeatureSetsIds?: number[];
    FeatureSetsCount?: number;
    /**
    * bool
    */
    // @ApiMember(Description="bool", Name="IsInternal")
    IsInternal?: boolean;

    /**
    * bool
    */
    // @ApiMember(Description="bool", Name="IsSuperAdmin")
    IsSuperAdmin?: boolean;

    /**
    * string
    */
    // @ApiMember(Description="string", IsRequired=true, Name="Name")
    Name?: string;

    /**
    * Page
    */
    // @ApiMember(Description="Page", Name="Pages")
    Pages?: Reference[];

    PagesIds?: number[];
    PagesCount?: number;
    /**
    * string
    */
    // @ApiMember(Description="string", Name="Permissions")
    Permissions?: string;

    /**
    * User
    */
    // @ApiMember(Description="User", Name="Users")
    Users?: Reference[];

    UsersIds?: number[];
    UsersCount?: number;
    /**
    * Summary of the role's permissions
    */
    // @ApiMember(Description="Summary of the role\'s permissions", Name="PermissionSummary")
    PermissionSummary?: string;

    AllFeatures?: boolean;
    AllPages?: boolean;
    AllDocumentSets?: boolean;
}

// @Route("/role", "POST")
// @Route("/role/{Id}", "GET, PATCH, PUT, DELETE")
interface Role extends RoleBase, IReturn<Role>, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

interface RoleSearchBase extends Search_1<Role>
{
    Id?: number;
    IdAfter?: number;
    IdBefore?: number;
    AdminTeam?: Reference;
    AdminTeamIds?: number[];
    AppsIds?: number[];
    Description?: string;
    Descriptions?: string[];
    Features?: string;
    Featuress?: string[];
    FeatureSetsIds?: number[];
    IsInternal?: boolean[];
    IsSuperAdmin?: boolean[];
    Name?: string;
    Names?: string[];
    PagesIds?: number[];
    Permissions?: string;
    Permissionss?: string[];
    UsersIds?: number[];
    Users?: Reference[];
    UsersCount?: number;
}

interface ScopeBase extends Dto<Scope>
{
    /**
    * Analysis
    */
    // @ApiMember(Description="Analysis", Name="Analyses")
    Analyses?: Reference[];

    AnalysesIds?: number[];
    AnalysesCount?: number;
    /**
    * App
    */
    // @ApiMember(Description="App", Name="App")
    App?: Reference;

    /**
    * Primary Key of App
    */
    // @ApiMember(Description="Primary Key of App", Name="AppId")
    AppId?: number;

    /**
    * LookupTableBinding
    */
    // @ApiMember(Description="LookupTableBinding", Name="Bindings")
    Bindings?: Reference[];

    BindingsIds?: number[];
    BindingsCount?: number;
    /**
    * Broadcast
    */
    // @ApiMember(Description="Broadcast", Name="Broadcasts")
    Broadcasts?: Reference[];

    BroadcastsIds?: number[];
    BroadcastsCount?: number;
    /**
    * Client
    */
    // @ApiMember(Description="Client", Name="Client")
    Client?: Reference;

    /**
    * Primary Key of Client
    */
    // @ApiMember(Description="Primary Key of Client", Name="ClientId")
    ClientId?: number;

    /**
    * bool
    */
    // @ApiMember(Description="bool", Name="Delete")
    Delete?: boolean;

    /**
    * DocumentSet
    */
    // @ApiMember(Description="DocumentSet", Name="DocumentSet")
    DocumentSet?: Reference;

    /**
    * Primary Key of DocumentSet
    */
    // @ApiMember(Description="Primary Key of DocumentSet", Name="DocumentSetId")
    DocumentSetId?: number;

    /**
    * bool
    */
    // @ApiMember(Description="bool", Name="Edit")
    Edit?: boolean;

    /**
    * FAQCategory
    */
    // @ApiMember(Description="FAQCategory", Name="FAQCategories")
    FAQCategories?: Reference[];

    FAQCategoriesIds?: number[];
    FAQCategoriesCount?: number;
    /**
    * Help
    */
    // @ApiMember(Description="Help", Name="Help")
    Help?: Reference[];

    HelpIds?: number[];
    HelpCount?: number;
    /**
    * bool
    */
    // @ApiMember(Description="bool", Name="IsGlobal")
    IsGlobal?: boolean;

    /**
    * TermSynonym
    */
    // @ApiMember(Description="TermSynonym", Name="Synonyms")
    Synonyms?: Reference[];

    SynonymsIds?: number[];
    SynonymsCount?: number;
    /**
    * Team
    */
    // @ApiMember(Description="Team", Name="Team")
    Team?: Reference;

    /**
    * Primary Key of Team
    */
    // @ApiMember(Description="Primary Key of Team", Name="TeamId")
    TeamId?: number;

    /**
    * LookupTable
    */
    // @ApiMember(Description="LookupTable", IsRequired=true, Name="Type")
    Type?: Reference;

    /**
    * Primary Key of LookupTable
    */
    // @ApiMember(Description="Primary Key of LookupTable", Name="TypeId")
    TypeId?: number;

    /**
    * User
    */
    // @ApiMember(Description="User", Name="User")
    User?: Reference;

    /**
    * Primary Key of User
    */
    // @ApiMember(Description="Primary Key of User", Name="UserId")
    UserId?: number;

    /**
    * VariableRule
    */
    // @ApiMember(Description="VariableRule", Name="VariableRules")
    VariableRules?: Reference[];

    VariableRulesIds?: number[];
    VariableRulesCount?: number;
    /**
    * bool
    */
    // @ApiMember(Description="bool", Name="View")
    View?: boolean;

    /**
    * Workflow
    */
    // @ApiMember(Description="Workflow", Name="Workflows")
    Workflows?: Reference[];

    WorkflowsIds?: number[];
    WorkflowsCount?: number;
}

// @Route("/scope/{Id}", "GET, PATCH, PUT, DELETE")
// @Route("/scope", "POST")
interface Scope extends ScopeBase, IReturn<Scope>, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

interface ScopeSearchBase extends Search_1<Scope>
{
    Id?: number;
    IdAfter?: number;
    IdBefore?: number;
    AnalysesIds?: number[];
    App?: Reference;
    AppIds?: number[];
    BindingsIds?: number[];
    BroadcastsIds?: number[];
    Client?: Reference;
    ClientIds?: number[];
    Delete?: boolean[];
    DocumentSet?: Reference;
    DocumentSetIds?: number[];
    Edit?: boolean[];
    FAQCategoriesIds?: number[];
    HelpIds?: number[];
    IsGlobal?: boolean[];
    SynonymsIds?: number[];
    Team?: Reference;
    TeamIds?: number[];
    Type?: Reference;
    TypeIds?: number[];
    TypeNames?: string[];
    User?: Reference;
    UserIds?: number[];
    VariableRulesIds?: number[];
    View?: boolean[];
    WorkflowsIds?: number[];
}

interface StatsRecordBase extends Dto<StatsRecord>
{
    /**
    * LookupTable
    */
    // @ApiMember(Description="LookupTable", IsRequired=true, Name="Name")
    Name?: Reference;

    /**
    * Primary Key of LookupTable
    */
    // @ApiMember(Description="Primary Key of LookupTable", Name="NameId")
    NameId?: number;

    /**
    * int?
    */
    // @ApiMember(Description="int?", IsRequired=true, Name="OwnerId")
    OwnerId?: number;

    /**
    * string
    */
    // @ApiMember(Description="string", IsRequired=true, Name="OwnerType")
    OwnerType?: string;

    /**
    * decimal
    */
    // @ApiMember(Description="decimal", IsRequired=true, Name="Value")
    Value?: number;
}

// @Route("/statsrecord/{Id}", "GET")
interface StatsRecord extends StatsRecordBase, IReturn<StatsRecord>, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

interface StatsRecordSearchBase extends Search_1<StatsRecord>
{
    Id?: number;
    IdAfter?: number;
    IdBefore?: number;
    Name?: Reference;
    NameIds?: number[];
    NameNames?: string[];
    OwnerId?: number;
    OwnerType?: string;
    OwnerTypes?: string[];
    Value?: number;
}

interface StatsBase extends Dto<Stats>
{
    /**
    * App
    */
    // @ApiMember(Description="App", IsRequired=true, Name="App")
    App?: Reference;

    /**
    * Primary Key of App
    */
    // @ApiMember(Description="Primary Key of App", Name="AppId")
    AppId?: number;

    /**
    * int?
    */
    // @ApiMember(Description="int?", Name="ExternalId")
    ExternalId?: number;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="ExternalType")
    ExternalType?: string;

    /**
    * int?
    */
    // @ApiMember(Description="int?", IsRequired=true, Name="ObjectId")
    ObjectId?: number;

    /**
    * string
    */
    // @ApiMember(Description="string", IsRequired=true, Name="ObjectType")
    ObjectType?: string;

    /**
    * StatsStudySet
    */
    // @ApiMember(Description="StatsStudySet", Name="StudySetStats")
    StudySetStats?: Reference;

    /**
    * Primary Key of StatsStudySet
    */
    // @ApiMember(Description="Primary Key of StatsStudySet", Name="StudySetStatsId")
    StudySetStatsId?: number;
}

// @Route("/stats/{Id}", "GET")
interface Stats extends StatsBase, IReturn<Stats>, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

interface StatsSearchBase extends Search_1<Stats>
{
    Id?: number;
    IdAfter?: number;
    IdBefore?: number;
    App?: Reference;
    AppIds?: number[];
    ExternalId?: number;
    ExternalType?: string;
    ExternalTypes?: string[];
    ObjectId?: number;
    ObjectType?: string;
    ObjectTypes?: string[];
    StudySetStats?: Reference;
    StudySetStatsIds?: number[];
}

interface StatsStudySetBase extends Dto<StatsStudySet>
{
    /**
    * int?
    */
    // @ApiMember(Description="int?", Name="BoundTerms")
    BoundTerms?: number;

    /**
    * int?
    */
    // @ApiMember(Description="int?", Name="Characteristics")
    Characteristics?: number;

    /**
    * int?
    */
    // @ApiMember(Description="int?", Name="DataPoints")
    DataPoints?: number;

    /**
    * int?
    */
    // @ApiMember(Description="int?", Name="DesignCount")
    DesignCount?: number;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="DesignList")
    DesignList?: string;

    /**
    * DocumentSet
    */
    // @ApiMember(Description="DocumentSet", IsRequired=true, Name="DocumentSet")
    DocumentSet?: Reference;

    /**
    * Primary Key of DocumentSet
    */
    // @ApiMember(Description="Primary Key of DocumentSet", Name="DocumentSetId")
    DocumentSetId?: number;

    /**
    * int?
    */
    // @ApiMember(Description="int?", Name="Interventions")
    Interventions?: number;

    /**
    * int?
    */
    // @ApiMember(Description="int?", Name="Outcomes")
    Outcomes?: number;

    /**
    * int?
    */
    // @ApiMember(Description="int?", Name="OutcomesReported")
    OutcomesReported?: number;

    /**
    * Stats
    */
    // @ApiMember(Description="Stats", IsRequired=true, Name="Stat")
    Stat?: Reference;

    /**
    * Primary Key of Stats
    */
    // @ApiMember(Description="Primary Key of Stats", Name="StatId")
    StatId?: number;

    /**
    * int?
    */
    // @ApiMember(Description="int?", Name="Studies")
    Studies?: number;

    /**
    * int?
    */
    // @ApiMember(Description="int?", Name="TypeCount")
    TypeCount?: number;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="TypeList")
    TypeList?: string;

    /**
    * int?
    */
    // @ApiMember(Description="int?", Name="UnboundTerms")
    UnboundTerms?: number;

    RecordsCount?: number;
    RecordsIds?: number;
    Records?: StatsRecord[];
}

// @Route("/statsstudyset/{Id}", "GET")
interface StatsStudySet extends StatsStudySetBase, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

interface StatsStudySetSearchBase extends Search_1<StatsStudySet>
{
    Id?: number;
    IdAfter?: number;
    IdBefore?: number;
    BoundTerms?: number;
    Characteristics?: number;
    DataPoints?: number;
    DesignCount?: number;
    DesignList?: string;
    DesignLists?: string[];
    DocumentSet?: Reference;
    DocumentSetIds?: number[];
    Interventions?: number;
    Outcomes?: number;
    OutcomesReported?: number;
    Stat?: Reference;
    StatIds?: number[];
    Studies?: number;
    TypeCount?: number;
    TypeList?: string;
    TypeLists?: string[];
    UnboundTerms?: number;
    RecordsIds?: number[];
}

interface TeamSettings
{
    // @DataMember(Name="notifications")
    // @ApiMember(Name="notifications")
    Notifications?: NotificationSettings;
}

interface TeamBase extends Dto<Team>
{
    /**
    * Role
    */
    // @ApiMember(Description="Role", Name="AdminRoles")
    AdminRoles?: Reference[];

    AdminRolesIds?: number[];
    AdminRolesCount?: number;
    /**
    * string
    */
    // @ApiMember(Description="string", Name="Description")
    Description?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="Email")
    Email?: string;

    /**
    * bool
    */
    // @ApiMember(Description="bool", Name="IsInternal")
    IsInternal?: boolean;

    /**
    * string
    */
    // @ApiMember(Description="string", IsRequired=true, Name="Name")
    Name?: string;

    /**
    * User
    */
    // @ApiMember(Description="User", IsRequired=true, Name="Owner")
    Owner?: Reference;

    /**
    * Primary Key of User
    */
    // @ApiMember(Description="Primary Key of User", Name="OwnerId")
    OwnerId?: number;

    /**
    * Scope
    */
    // @ApiMember(Description="Scope", Name="Scopes")
    Scopes?: Reference[];

    ScopesIds?: number[];
    ScopesCount?: number;
    /**
    * TeamSettings
    */
    // @ApiMember(Description="TeamSettings", Name="Settings")
    Settings?: TeamSettings;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="Slack")
    Slack?: string;

    /**
    * Update
    */
    // @ApiMember(Description="Update", Name="Updates")
    Updates?: Reference[];

    UpdatesIds?: number[];
    UpdatesCount?: number;
    /**
    * User
    */
    // @ApiMember(Description="User", Name="Users")
    Users?: Reference[];

    UsersIds?: number[];
    UsersCount?: number;
}

// @Route("/team", "POST")
// @Route("/team/{Id}", "GET, PATCH, PUT, DELETE")
interface Team extends TeamBase, IReturn<Team>, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

interface TeamSearchBase extends Search_1<Team>
{
    Id?: number;
    IdAfter?: number;
    IdBefore?: number;
    AdminRolesIds?: number[];
    Description?: string;
    Descriptions?: string[];
    Email?: string;
    Emails?: string[];
    IsInternal?: boolean[];
    Name?: string;
    Names?: string[];
    Owner?: Reference;
    OwnerIds?: number[];
    ScopesIds?: number[];
    Settings?: string;
    Settingss?: string[];
    Slack?: string;
    Slacks?: string[];
    UpdatesIds?: number[];
    UsersIds?: number[];
    UserId?: number;
}

interface TermCategoryBase extends Dto<TermCategory>
{
    /**
    * TermCategory
    */
    // @ApiMember(Description="TermCategory", Name="ParentCategory")
    ParentCategory?: Reference;

    /**
    * Primary Key of TermCategory
    */
    // @ApiMember(Description="Primary Key of TermCategory", Name="ParentCategoryId")
    ParentCategoryId?: number;

    /**
    * Scope
    */
    // @ApiMember(Description="Scope", Name="Scope")
    Scope?: Reference;

    /**
    * Primary Key of Scope
    */
    // @ApiMember(Description="Primary Key of Scope", Name="ScopeId")
    ScopeId?: number;

    /**
    * TermMaster
    */
    // @ApiMember(Description="TermMaster", Name="Terms")
    Terms?: Reference[];

    TermsIds?: number[];
    TermsCount?: number;
    Name?: Reference;
    NameId?: number;
}

// @Route("/termcategory/{Id}", "GET, PATCH, PUT, DELETE")
// @Route("/termcategory", "POST")
interface TermCategory extends TermCategoryBase, IReturn<TermCategory>, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

interface TermMasterBase extends Dto<TermMaster>
{
    /**
    * TermCategory
    */
    // @ApiMember(Description="TermCategory", Name="Categories")
    Categories?: TermCategory[];

    CategoriesIds?: number[];
    CategoriesCount?: number;
    /**
    * string
    */
    // @ApiMember(Description="string", Name="CUI")
    CUI?: string;

    /**
    * LookupTableEnum
    */
    // @ApiMember(Description="LookupTableEnum", IsRequired=true, Name="Enum")
    Enum?: Reference;

    /**
    * Primary Key of LookupTableEnum
    */
    // @ApiMember(Description="Primary Key of LookupTableEnum", Name="EnumId")
    EnumId?: number;

    /**
    * bool?
    */
    // @ApiMember(Description="bool?", Name="IsPositive")
    IsPositive?: boolean;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="MedDRA")
    MedDRA?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", IsRequired=true, Name="Name")
    Name?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="RxNorm")
    RxNorm?: string;

    /**
    * JsonObject
    */
    // @ApiMember(Description="JsonObject", Name="Settings")
    Settings?: JsonObject;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="SNOWMED")
    SNOWMED?: string;

    /**
    * TermSynonym
    */
    // @ApiMember(Description="TermSynonym", Name="Synonyms")
    Synonyms?: Reference[];

    SynonymsIds?: number[];
    SynonymsCount?: number;
    /**
    * string
    */
    // @ApiMember(Description="string", Name="TUI")
    TUI?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="URI")
    URI?: string;
}

// @Route("/termmaster", "POST")
// @Route("/termmaster/{Id}", "GET, PATCH, PUT, DELETE")
interface TermMaster extends TermMasterBase, IReturn<TermMaster>, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

interface TermMasterSearchBase extends Search_1<TermMaster>
{
    Id?: number;
    IdAfter?: number;
    IdBefore?: number;
    CategoriesIds?: number[];
    CUI?: string;
    CUIs?: string[];
    Enum?: Reference;
    EnumIds?: number[];
    IsPositive?: boolean[];
    MedDRA?: string;
    MedDRAs?: string[];
    Name?: string;
    Names?: string[];
    RxNorm?: string;
    RxNorms?: string[];
    Settings?: string;
    Settingss?: string[];
    SNOWMED?: string;
    SNOWMEDs?: string[];
    SynonymsIds?: number[];
    TUI?: string;
    TUIs?: string[];
    URI?: string;
    URIs?: string[];
    LookupTableEnumId?: number;
    ScopedToStudySetId?: number;
    UserId?: number;
}

interface TermSynonymBase extends Dto<TermSynonym>
{
    /**
    * bool
    */
    // @ApiMember(Description="bool", Name="Approved")
    Approved?: boolean;

    /**
    * LookupTableBinding
    */
    // @ApiMember(Description="LookupTableBinding", Name="Bindings")
    Bindings?: Reference[];

    BindingsIds?: number[];
    BindingsCount?: number;
    /**
    * TermMaster
    */
    // @ApiMember(Description="TermMaster", IsRequired=true, Name="Master")
    Master?: Reference;

    /**
    * Primary Key of TermMaster
    */
    // @ApiMember(Description="Primary Key of TermMaster", Name="MasterId")
    MasterId?: number;

    /**
    * bool
    */
    // @ApiMember(Description="bool", Name="Preferred")
    Preferred?: boolean;

    /**
    * Scope
    */
    // @ApiMember(Description="Scope", Name="Scope")
    Scope?: Reference;

    /**
    * Primary Key of Scope
    */
    // @ApiMember(Description="Primary Key of Scope", Name="ScopeId")
    ScopeId?: number;

    /**
    * string
    */
    // @ApiMember(Description="string", IsRequired=true, Name="Synonym")
    Synonym?: string;
}

// @Route("/termsynonym", "POST")
// @Route("/termsynonym/{Id}", "GET, PATCH, PUT, DELETE")
interface TermSynonym extends TermSynonymBase, IReturn<TermSynonym>, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

interface TermSynonymSearchBase extends Search_1<TermSynonym>
{
    Id?: number;
    IdAfter?: number;
    IdBefore?: number;
    Approved?: boolean[];
    BindingsIds?: number[];
    Master?: Reference;
    MasterIds?: number[];
    Preferred?: boolean[];
    Scope?: Reference;
    ScopeIds?: number[];
    Synonym?: string;
    Synonyms?: string[];
    LookupTableEnumId?: number;
    ScopedToStudySetId?: number;
    UserId?: number;
}

interface UserBase extends Dto<User>
{
    /**
    * string
    */
    // @ApiMember(Description="string", Name="ClientDepartment")
    ClientDepartment?: string;

    /**
    * Division
    */
    // @ApiMember(Description="Division", IsRequired=true, Name="Division")
    Division?: Reference;

    /**
    * Primary Key of Division
    */
    // @ApiMember(Description="Primary Key of Division", Name="DivisionId")
    DivisionId?: number;

    /**
    * DocumentSet
    */
    // @ApiMember(Description="DocumentSet", Name="DocumentSets")
    DocumentSets?: Reference[];

    DocumentSetsIds?: number[];
    DocumentSetsCount?: number;
    /**
    * string
    */
    // @ApiMember(Description="string", Name="Email")
    Email?: string;

    /**
    * DateTime?
    */
    // @ApiMember(Description="DateTime?", Name="ExpireDate")
    ExpireDate?: string;

    /**
    * int?
    */
    // @ApiMember(Description="int?", Name="FailedLoginCount")
    FailedLoginCount?: number;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="FirstName")
    FirstName?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="Gravatar")
    Gravatar?: string;

    /**
    * History
    */
    // @ApiMember(Description="History", Name="History")
    History?: Reference[];

    HistoryIds?: number[];
    HistoryCount?: number;
    /**
    * Impersonation
    */
    // @ApiMember(Description="Impersonation", Name="Impersonated")
    Impersonated?: Reference[];

    ImpersonatedIds?: number[];
    ImpersonatedCount?: number;
    /**
    * Impersonation
    */
    // @ApiMember(Description="Impersonation", Name="Impersonating")
    Impersonating?: Reference[];

    ImpersonatingIds?: number[];
    ImpersonatingCount?: number;
    /**
    * bool?
    */
    // @ApiMember(Description="bool?", Name="IsSystemUser")
    IsSystemUser?: boolean;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="JobTitle")
    JobTitle?: string;

    /**
    * DateTime?
    */
    // @ApiMember(Description="DateTime?", Name="LastLogin")
    LastLogin?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="LastName")
    LastName?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="LegacyUsername")
    LegacyUsername?: string;

    /**
    * Locale
    */
    // @ApiMember(Description="Locale", Name="Locale")
    Locale?: Reference;

    /**
    * Primary Key of Locale
    */
    // @ApiMember(Description="Primary Key of Locale", Name="LocaleId")
    LocaleId?: number;

    /**
    * int?
    */
    // @ApiMember(Description="int?", Name="LoginCount")
    LoginCount?: number;

    /**
    * string
    */
    // @ApiMember(Description="string", IsRequired=true, Name="Name")
    Name?: string;

    /**
    * Role
    */
    // @ApiMember(Description="Role", Name="Roles")
    Roles?: Role[];

    RolesIds?: number[];
    RolesCount?: number;
    /**
    * Scope
    */
    // @ApiMember(Description="Scope", Name="Scopes")
    Scopes?: Reference[];

    ScopesIds?: number[];
    ScopesCount?: number;
    /**
    * UserSession
    */
    // @ApiMember(Description="UserSession", Name="Sessions")
    Sessions?: Reference[];

    SessionsIds?: number[];
    SessionsCount?: number;
    /**
    * JsonObject
    */
    // @ApiMember(Description="JsonObject", Name="Settings")
    Settings?: JsonObject;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="Slack")
    Slack?: string;

    /**
    * DateTime?
    */
    // @ApiMember(Description="DateTime?", Name="StartDate")
    StartDate?: string;

    /**
    * LookupTable
    */
    // @ApiMember(Description="LookupTable", Name="Status")
    Status?: Reference;

    /**
    * Primary Key of LookupTable
    */
    // @ApiMember(Description="Primary Key of LookupTable", Name="StatusId")
    StatusId?: number;

    /**
    * Team
    */
    // @ApiMember(Description="Team", Name="Teams")
    Teams?: Reference[];

    TeamsIds?: number[];
    TeamsCount?: number;
    /**
    * TimeCard
    */
    // @ApiMember(Description="TimeCard", Name="TimeCards")
    TimeCards?: Reference[];

    TimeCardsIds?: number[];
    TimeCardsCount?: number;
    /**
    * Update
    */
    // @ApiMember(Description="Update", Name="Updates")
    Updates?: Reference[];

    UpdatesIds?: number[];
    UpdatesCount?: number;
    /**
    * UserType
    */
    // @ApiMember(Description="UserType", Name="UserType")
    UserType?: Reference;

    /**
    * Primary Key of UserType
    */
    // @ApiMember(Description="Primary Key of UserType", Name="UserTypeId")
    UserTypeId?: number;

    /**
    * Workflow
    */
    // @ApiMember(Description="Workflow", Name="Workflows")
    Workflows?: Reference[];

    WorkflowsIds?: number[];
    WorkflowsCount?: number;
    /**
    * True if the user has any role that is a Super Admin
    */
    // @ApiMember(Description="True if the user has any role that is a Super Admin", Name="IsSuperAdmin")
    IsSuperAdmin?: boolean;

    /**
    * The user's permission set
    */
    // @ApiMember(Description="The user\'s permission set", Name="Permissions")
    Permissions?: string;

    /**
    * Summary of the user's permissions
    */
    // @ApiMember(Description="Summary of the user\'s permissions", Name="PermissionSummary")
    PermissionSummary?: string;

    /**
    * The user's feature configuration
    */
    // @ApiMember(Description="The user\'s feature configuration", Name="FeatureConfig")
    FeatureConfig?: string;

    /**
    * User's password. Never returned from the API; only used when creating users or changing a user's password.
    */
    // @ApiMember(Description="User\'s password. Never returned from the API; only used when creating users or changing a user\'s password.", Name="Password")
    Password?: string;

    /**
    * Internal property for unit tests
    */
    // @ApiMember(Description="Internal property for unit tests", Name="UnitTestProperty")
    UnitTestProperty?: string;

    /**
    * Name of the client associated with the user's Division
    */
    // @ApiMember(Description="Name of the client associated with the user\'s Division", Name="ClientName")
    ClientName?: string;

    Client?: Reference;
    /**
    * Bindings
    */
    // @ApiMember(Description="Bindings", Name="Bindings")
    Bindings?: Reference[];

    /**
    * Audits
    */
    // @ApiMember(Description="Audits", Name="Audits")
    Audits?: Reference[];

    /**
    * IsInternal
    */
    // @ApiMember(Description="IsInternal", Name="IsInternal")
    IsInternal?: boolean;

    /**
    * User being impersonated
    */
    // @ApiMember(Description="User being impersonated", Name="ImpersonateUser")
    ImpersonateUser?: User;

    /**
    * User who is impersonating this user
    */
    // @ApiMember(Description="User who is impersonating this user", Name="ImpersonatedBy")
    ImpersonatedBy?: Reference;

    /**
    * All data sets assigned to or inherted by the user
    */
    // @ApiMember(Description="All data sets assigned to or inherted by the user", Name="AllDocumentSets")
    AllDocumentSets?: Reference[];

    /**
    * All teams created by the user or of which the user is a member
    */
    // @ApiMember(Description="All teams created by the user or of which the user is a member", Name="AllTeams")
    AllTeams?: Reference[];

    /**
    * All features the user inherits from the assigned roles
    */
    // @ApiMember(Description="All features the user inherits from the assigned roles", Name="Features")
    Features?: Reference[];

    /**
    * All apps the user inherits from the assigned roles
    */
    // @ApiMember(Description="All apps the user inherits from the assigned roles", Name="Apps")
    Apps?: Reference[];

    /**
    * All pages the user inherits from the assigned roles
    */
    // @ApiMember(Description="All pages the user inherits from the assigned roles", Name="Pages")
    Pages?: Reference[];

    /**
    * Roles from the legacy user store.
    */
    // @ApiMember(Description="Roles from the legacy user store.", Name="LegacyRoles")
    LegacyRoles?: string[];

    /**
    * True if the user is marked as a Test User in EVP.
    */
    // @ApiMember(Description="True if the user is marked as a Test User in EVP.", Name="IsTestUser")
    IsTestUser?: boolean;
}

// @Route("/user/{Id}", "GET, PATCH, PUT")
// @Route("/user", "POST")
interface User extends UserBase, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

interface UserSearchBase extends Search_1<User>
{
    Id?: number;
    IdAfter?: number;
    IdBefore?: number;
    ClientDepartment?: string;
    ClientDepartments?: string[];
    Division?: Reference;
    DivisionIds?: number[];
    DocumentSetsIds?: number[];
    Email?: string;
    Emails?: string[];
    ExpireDate?: string;
    ExpireDateAfter?: string;
    ExpireDateBefore?: string;
    FailedLoginCount?: number;
    FirstName?: string;
    FirstNames?: string[];
    Gravatar?: string;
    Gravatars?: string[];
    HistoryIds?: number[];
    ImpersonatedIds?: number[];
    ImpersonatingIds?: number[];
    IsSystemUser?: boolean[];
    JobTitle?: string;
    JobTitles?: string[];
    LastLogin?: string;
    LastLoginAfter?: string;
    LastLoginBefore?: string;
    LastName?: string;
    LastNames?: string[];
    LegacyUsername?: string;
    LegacyUsernames?: string[];
    Locale?: Reference;
    LocaleIds?: number[];
    LoginCount?: number;
    Name?: string;
    Names?: string[];
    RolesIds?: number[];
    ScopesIds?: number[];
    SessionsIds?: number[];
    Settings?: string;
    Settingss?: string[];
    Slack?: string;
    Slacks?: string[];
    StartDate?: string;
    StartDateAfter?: string;
    StartDateBefore?: string;
    Status?: Reference;
    StatusIds?: number[];
    StatusNames?: string[];
    TeamsIds?: number[];
    TimeCardsIds?: number[];
    UpdatesIds?: number[];
    UserType?: Reference;
    UserTypeIds?: number[];
    WorkflowsIds?: number[];
    IsInteral?: boolean;
    IsEmployee?: boolean;
}

interface WorkflowCommentBase extends Dto<WorkflowComment>
{
    /**
    * WorkflowComment
    */
    // @ApiMember(Description="WorkflowComment", Name="Children")
    Children?: Reference[];

    ChildrenIds?: number[];
    ChildrenCount?: number;
    /**
    * WorkflowComment
    */
    // @ApiMember(Description="WorkflowComment", Name="Parent")
    Parent?: Reference;

    /**
    * Primary Key of WorkflowComment
    */
    // @ApiMember(Description="Primary Key of WorkflowComment", Name="ParentId")
    ParentId?: number;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="Text")
    Text?: string;

    /**
    * User
    */
    // @ApiMember(Description="User", IsRequired=true, Name="User")
    User?: Reference;

    /**
    * Primary Key of User
    */
    // @ApiMember(Description="Primary Key of User", Name="UserId")
    UserId?: number;

    /**
    * Workflow
    */
    // @ApiMember(Description="Workflow", IsRequired=true, Name="Workflow")
    Workflow?: Reference;

    /**
    * Primary Key of Workflow
    */
    // @ApiMember(Description="Primary Key of Workflow", Name="WorkflowId")
    WorkflowId?: number;
}

// @Route("/workflowcomment", "POST")
// @Route("/workflowcomment/{Id}", "GET, PATCH, PUT, DELETE")
interface WorkflowComment extends WorkflowCommentBase, IReturn<WorkflowComment>, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

interface WorkflowCommentSearchBase extends Search_1<WorkflowComment>
{
    Id?: number;
    IdAfter?: number;
    IdBefore?: number;
    ChildrenIds?: number[];
    Parent?: Reference;
    ParentIds?: number[];
    Text?: string;
    Texts?: string[];
    User?: Reference;
    UserIds?: number[];
    Workflow?: Reference;
    WorkflowIds?: number[];
}

interface WorkflowBase extends Dto<Workflow>
{
    /**
    * LookupTableBinding
    */
    // @ApiMember(Description="LookupTableBinding", Name="Bindings")
    Bindings?: Reference[];

    BindingsIds?: number[];
    BindingsCount?: number;
    /**
    * WorkflowComment
    */
    // @ApiMember(Description="WorkflowComment", Name="Comments")
    Comments?: Reference[];

    CommentsIds?: number[];
    CommentsCount?: number;
    /**
    * string
    */
    // @ApiMember(Description="string", Name="Data")
    Data?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="Description")
    Description?: string;

    /**
    * Document
    */
    // @ApiMember(Description="Document", Name="Documents")
    Documents?: Reference[];

    DocumentsIds?: number[];
    DocumentsCount?: number;
    /**
    * DocumentSet
    */
    // @ApiMember(Description="DocumentSet", Name="DocumentSet")
    DocumentSet?: Reference;

    /**
    * Primary Key of DocumentSet
    */
    // @ApiMember(Description="Primary Key of DocumentSet", Name="DocumentSetId")
    DocumentSetId?: number;

    /**
    * string
    */
    // @ApiMember(Description="string", IsRequired=true, Name="Name")
    Name?: string;

    /**
    * Workflow
    */
    // @ApiMember(Description="Workflow", Name="Owner")
    Owner?: Reference;

    /**
    * Primary Key of Workflow
    */
    // @ApiMember(Description="Primary Key of Workflow", Name="OwnerId")
    OwnerId?: number;

    /**
    * ReconcileDocument
    */
    // @ApiMember(Description="ReconcileDocument", Name="ReconcileDocuments")
    ReconcileDocuments?: Reference[];

    ReconcileDocumentsIds?: number[];
    ReconcileDocumentsCount?: number;
    /**
    * Scope
    */
    // @ApiMember(Description="Scope", Name="Scopes")
    Scopes?: Reference[];

    ScopesIds?: number[];
    ScopesCount?: number;
    /**
    * LookupTable
    */
    // @ApiMember(Description="LookupTable", Name="Status")
    Status?: Reference;

    /**
    * Primary Key of LookupTable
    */
    // @ApiMember(Description="Primary Key of LookupTable", Name="StatusId")
    StatusId?: number;

    /**
    * Tag
    */
    // @ApiMember(Description="Tag", Name="Tags")
    Tags?: Reference[];

    TagsIds?: number[];
    TagsCount?: number;
    /**
    * WorkflowTask
    */
    // @ApiMember(Description="WorkflowTask", Name="Tasks")
    Tasks?: Reference[];

    TasksIds?: number[];
    TasksCount?: number;
    /**
    * LookupTable
    */
    // @ApiMember(Description="LookupTable", IsRequired=true, Name="Type")
    Type?: Reference;

    /**
    * Primary Key of LookupTable
    */
    // @ApiMember(Description="Primary Key of LookupTable", Name="TypeId")
    TypeId?: number;

    /**
    * User
    */
    // @ApiMember(Description="User", IsRequired=true, Name="User")
    User?: Reference;

    /**
    * Primary Key of User
    */
    // @ApiMember(Description="Primary Key of User", Name="UserId")
    UserId?: number;

    /**
    * VariableInstance
    */
    // @ApiMember(Description="VariableInstance", Name="Variables")
    Variables?: Reference[];

    VariablesIds?: number[];
    VariablesCount?: number;
    /**
    * Workflow
    */
    // @ApiMember(Description="Workflow", Name="Workflows")
    Workflows?: Reference[];

    WorkflowsIds?: number[];
    WorkflowsCount?: number;
}

// @Route("/workflow", "POST")
// @Route("/workflow/{Id}", "GET, PATCH, PUT")
interface Workflow extends WorkflowBase, IReturn<Workflow>, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

// @Route("/workflow", "POST")
// @Route("/workflow/{Id}", "GET, PATCH, PUT")
interface WorkflowDetail extends Workflow, IDto
{
    TherapeuticArea?: string;
    Disease?: string;
    DataSet?: string;
    Therapy?: string[];
}

interface WorkflowSearchBase extends Search_1<Workflow>
{
    Id?: number;
    IdAfter?: number;
    IdBefore?: number;
    BindingsIds?: number[];
    CommentsIds?: number[];
    Data?: string;
    Datas?: string[];
    Description?: string;
    Descriptions?: string[];
    DocumentsIds?: number[];
    DocumentSet?: Reference;
    DocumentSetIds?: number[];
    Name?: string;
    Names?: string[];
    Owner?: Reference;
    OwnerIds?: number[];
    ReconcileDocumentsIds?: number[];
    ScopesIds?: number[];
    Status?: Reference;
    StatusIds?: number[];
    StatusNames?: string[];
    TagsIds?: number[];
    TasksIds?: number[];
    Type?: Reference;
    TypeIds?: number[];
    TypeNames?: string[];
    User?: Reference;
    UserIds?: number[];
    VariablesIds?: number[];
    WorkflowsIds?: number[];
    DocumentSetId?: number;
}

interface Reference
{
    Id?: number;
    Name?: string;
}

interface EvidenceOnDemand
{
    ReferenceId?: number;
    UnboundName?: Reference;
    BoundName?: Reference;
    RootTerm?: string;
    FieldType?: Reference;
    TimePoints?: string;
}

interface WorkflowTaskBase extends Dto<WorkflowTask>
{
    /**
    * User
    */
    // @ApiMember(Description="User", Name="Assignee")
    Assignee?: Reference;

    /**
    * Primary Key of User
    */
    // @ApiMember(Description="Primary Key of User", Name="AssigneeId")
    AssigneeId?: number;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="Data")
    Data?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", IsRequired=true, Name="Description")
    Description?: string;

    /**
    * DateTime?
    */
    // @ApiMember(Description="DateTime?", Name="DueDate")
    DueDate?: string;

    /**
    * User
    */
    // @ApiMember(Description="User", IsRequired=true, Name="Reporter")
    Reporter?: Reference;

    /**
    * Primary Key of User
    */
    // @ApiMember(Description="Primary Key of User", Name="ReporterId")
    ReporterId?: number;

    /**
    * LookupTable
    */
    // @ApiMember(Description="LookupTable", Name="Status")
    Status?: Reference;

    /**
    * Primary Key of LookupTable
    */
    // @ApiMember(Description="Primary Key of LookupTable", Name="StatusId")
    StatusId?: number;

    /**
    * LookupTable
    */
    // @ApiMember(Description="LookupTable", IsRequired=true, Name="Type")
    Type?: Reference;

    /**
    * Primary Key of LookupTable
    */
    // @ApiMember(Description="Primary Key of LookupTable", Name="TypeId")
    TypeId?: number;

    /**
    * Workflow
    */
    // @ApiMember(Description="Workflow", IsRequired=true, Name="Workflow")
    Workflow?: Reference;

    /**
    * Primary Key of Workflow
    */
    // @ApiMember(Description="Primary Key of Workflow", Name="WorkflowId")
    WorkflowId?: number;

    EodData?: EvidenceOnDemand;
}

// @Route("/workflowtask/{Id}", "GET, PATCH, PUT, DELETE")
// @Route("/workflowtask", "POST")
interface WorkflowTask extends WorkflowTaskBase, IReturn<WorkflowTask>, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

interface WorkflowTaskSearchBase extends Search_1<WorkflowTask>
{
    Id?: number;
    IdAfter?: number;
    IdBefore?: number;
    Assignee?: Reference;
    AssigneeIds?: number[];
    Data?: string;
    Datas?: string[];
    Description?: string;
    Descriptions?: string[];
    DueDate?: string;
    DueDateAfter?: string;
    DueDateBefore?: string;
    Reporter?: Reference;
    ReporterIds?: number[];
    Status?: Reference;
    StatusIds?: number[];
    StatusNames?: string[];
    Type?: Reference;
    TypeIds?: number[];
    TypeNames?: string[];
    Workflow?: Reference;
    WorkflowIds?: number[];
}

// @DataContract
interface Route
{
    // @DataMember
    route?: string;

    // @DataMember
    verbs?: string;
}

// @DataContract
interface LegacyUrls
{
    // @DataMember
    DataLegacy?: string;

    // @DataMember
    LibraryLegacy?: string;

    // @DataMember
    LmsBackend?: string;

    // @DataMember
    Extract?: string;
}

// @DataContract
interface UrlMapping
{
    // @DataMember
    HostName?: string;

    // @DataMember
    LoginUrl?: string;
}

// @Route("/admin/settings/frontend", "GET, PATCH")
// @DataContract
interface Frontend
{
    // @DataMember(Name="BASE_API_URL")
    BaseApiUrl?: string;

    // @DataMember(Name="BASE_URL")
    BaseUrl?: string;

    // @DataMember(Name="USER_SNAP_API_KEY")
    UserSnapApiKey?: string;

    // @DataMember(Name="API_META_DATA")
    ApiMetadata?: { [index:string]: Route; };

    // @DataMember(Name="API_ROUTES")
    ApiRoutes?: { [index:string]: Route; };

    // @DataMember(Name="SEGMENT_API")
    SegmentApi?: string;

    // @DataMember
    FederateUrl?: string;

    // @DataMember
    FederateUrlPublic?: string;

    // @DataMember
    Urls?: LegacyUrls;

    // @DataMember
    UrlMappings?: UrlMapping[];
}

// @Route("/admin/settings/scheduler", "GET, PATCH")
// @DataContract
interface Scheduler
{
    // @DataMember(Name="username")
    // @ApiMember(Name="username")
    Username?: string;

    // @DataMember(Name="password")
    // @ApiMember(Name="password")
    Password?: string;
}

// @DataContract
interface ServerInfo
{
    // @DataMember(Name="ip-address", EmitDefaultValue=false)
    // @ApiMember(Name="ip-address")
    IpAddress?: string;

    // @DataMember(Name="server-name", EmitDefaultValue=false)
    // @ApiMember(Name="server-name")
    ServerName?: string;

    // @DataMember(Name="deployment-server", EmitDefaultValue=false)
    // @ApiMember(Name="deployment-server")
    DeploymentServer?: string;

    // @DataMember(Name="version", EmitDefaultValue=false)
    // @ApiMember(Name="version")
    Version?: string;
}

// @Route("/admin/settings/developer", "GET, PATCH")
// @DataContract
interface Developer
{
    // @DataMember(Name="port")
    // @ApiMember(Name="port")
    Port?: number;

    // @DataMember(Name="native-js", EmitDefaultValue=false)
    // @ApiMember(Name="native-js")
    NativeJs?: boolean;

    // @DataMember(Name="type-check", EmitDefaultValue=false)
    // @ApiMember(Name="type-check")
    TypeCheck?: boolean;

    // @DataMember(Name="instrument", EmitDefaultValue=false)
    // @ApiMember(Name="instrument")
    Instrument?: boolean;

    // @DataMember(Name="css-source-maps", EmitDefaultValue=false)
    // @ApiMember(Name="css-source-maps")
    CssSourceMaps?: boolean;

    // @DataMember(Name="dev-tool", EmitDefaultValue=false)
    // @ApiMember(Name="dev-tool")
    DevTool?: string;

    // @DataMember(Name="build-js-output", EmitDefaultValue=false)
    // @ApiMember(Name="build-js-output")
    BuildJsOutput?: string;

    // @DataMember(Name="profiling", EmitDefaultValue=false)
    // @ApiMember(Name="profiling")
    Profiling?: boolean;

    // @DataMember(Name="debug", EmitDefaultValue=false)
    // @ApiMember(Name="debug")
    Debug?: boolean;

    // @DataMember(Name="profiling-minimum_ms")
    // @ApiMember(Name="profiling-minimum_ms")
    ProfilingMinimumMs?: number;

    // @DataMember(Name="profiling-ormlite")
    // @ApiMember(Name="profiling-ormlite")
    ProfilingOrmlite?: boolean;

    // @DataMember(Name="profiling-ignored-routes")
    // @ApiMember(Name="profiling-ignored-routes")
    ProfilingIgnoredRoutes?: string[];

    // @DataMember(Name="local-dtos-ts", EmitDefaultValue=false)
    // @ApiMember(Name="local-dtos-ts")
    LocalDtosTs?: string;

    // @DataMember(Name="local-metadata-json", EmitDefaultValue=false)
    // @ApiMember(Name="local-metadata-json")
    LocalMetadataJson?: string;

    // @DataMember(Name="metadata-json-dest", EmitDefaultValue=false)
    // @ApiMember(Name="metadata-json-dest")
    MetadataJsonDest?: string;

    // @DataMember(Name="dtos-ts-dest", EmitDefaultValue=false)
    // @ApiMember(Name="dtos-ts-dest")
    DtosTsDest?: string;

    // @DataMember(Name="cors-port-exceptions")
    // @ApiMember(Name="cors-port-exceptions")
    CorsPortExceptions?: number[];

    // @DataMember(Name="cors-host-exceptions")
    // @ApiMember(Name="cors-host-exceptions")
    CorsHostExceptions?: string[];
}

// @Route("/admin/settings/search", "GET, PATCH")
// @DataContract
interface Search
{
    // @DataMember(Name="username")
    // @ApiMember(Name="username")
    Username?: string;

    // @DataMember(Name="password")
    // @ApiMember(Name="password")
    Password?: string;

    // @DataMember(Name="authentication-api")
    // @ApiMember(Name="authentication-api")
    AuthenticationApi?: string;

    // @DataMember(Name="search-api")
    // @ApiMember(Name="search-api")
    SearchApi?: string;
}

// @Route("/admin/settings/build", "GET, PATCH")
// @DataContract
interface Build
{
    // @DataMember(Name="native-js")
    // @ApiMember(Name="native-js")
    NativeJs?: boolean;

    // @DataMember(Name="dev-tool")
    // @ApiMember(Name="dev-tool")
    DevTool?: string;

    // @DataMember(Name="run-portal", EmitDefaultValue=false)
    // @ApiMember(Name="run-portal")
    RunPortal?: boolean;
}

interface Config<T>
{
}

// @DataContract
type RequestLogger = "InMemory" | "Database";

interface DocRabbitMqService
{
}

interface RabbitQueueItem
{
    Name?: string;
    State?: string;
    IdleSince?: string;
    Messages?: number;
    MessagesReady?: number;
    MessagesUnacknowledged?: number;
    MessagesPersistent?: number;
    AutoDelete?: boolean;
    ConsumerUtilisation?: Object;
    Consumers?: number;
    Durable?: boolean;
    Exclusive?: boolean;
}

interface DocFrontendSettingsService
{
}

interface DocLibraryService
{
}

interface ReferenceStatus
{
    ReferenceId?: number;
    Status?: string;
}

// @Route("/client/account")
interface Account
{
    AccountNumber?: string;
    Name?: string;
    Description?: string;
}

interface SalesforceContact
{
    Id?: string;
    Name?: string;
    Email?: string;
}

interface QueueChannelBase extends Dto<QueueChannel>
{
    /**
    * bool
    */
    // @ApiMember(Description="bool", Name="AutoDelete")
    AutoDelete?: boolean;

    /**
    * BackgroundTask
    */
    // @ApiMember(Description="BackgroundTask", Name="BackgroundTask")
    BackgroundTask?: Reference;

    /**
    * Primary Key of BackgroundTask
    */
    // @ApiMember(Description="Primary Key of BackgroundTask", Name="BackgroundTaskId")
    BackgroundTaskId?: number;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="Description")
    Description?: string;

    /**
    * bool
    */
    // @ApiMember(Description="bool", Name="Durable")
    Durable?: boolean;

    /**
    * bool
    */
    // @ApiMember(Description="bool", Name="Enabled")
    Enabled?: boolean;

    /**
    * bool
    */
    // @ApiMember(Description="bool", Name="Exclusive")
    Exclusive?: boolean;

    /**
    * string
    */
    // @ApiMember(Description="string", IsRequired=true, Name="Name")
    Name?: string;

    MessagesReceived?: number;
    MessagesProcessed?: number;
    Started?: string;
    FirstMessageReceived?: string;
    LastMessageReceived?: string;
    FirstMessageProcessed?: string;
    LastMessageProcessed?: string;
    ChannelBound?: boolean;
}

// @Route("/queuechannel/{Id}", "GET, PATCH, PUT, DELETE")
// @Route("/queuechannel", "POST")
interface QueueChannel extends QueueChannelBase, IReturn<QueueChannel>, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

interface ServiceStatus
{
    Summary?: string;
    Version?: string;
    Errors?: ConcurrentDictionary<string, ExceptionDto>;
    Queues?: QueueChannel[];
    BackgroundTasks?: BackgroundTask[];
    ProcessInfo?: JsonObject;
}

interface QueueLog
{
    Id?: number;
    // @StringLength(2147483647)
    Error?: string;

    // @StringLength(2147483647)
    Data?: string;

    Channel?: string;
    Created?: string;
}

interface Cpu
{
    // @DataMember(Name="user")
    // @ApiMember(Name="user")
    User?: number;

    // @DataMember(Name="system")
    // @ApiMember(Name="system")
    System?: number;
}

interface Memory
{
    // @DataMember(Name="rss")
    // @ApiMember(Name="rss")
    Rss?: number;

    // @DataMember(Name="heapTotal")
    // @ApiMember(Name="heapTotal")
    HeapTotal?: number;

    // @DataMember(Name="heapUsed")
    // @ApiMember(Name="heapUsed")
    HeapUsed?: number;

    // @DataMember(Name="external")
    // @ApiMember(Name="external")
    External?: number;
}

type State = "Ready";

interface IndexStatus
{
    // @DataMember(Name="name")
    // @ApiMember(Name="name")
    Name?: string;

    // @DataMember(Name="queued")
    // @ApiMember(Name="queued")
    Queued?: number;

    // @DataMember(Name="pendingRequests")
    // @ApiMember(Name="pendingRequests")
    PendingRequests?: Object[];

    // @DataMember(Name="state")
    // @ApiMember(Name="state")
    State?: State;
}

interface ClientConnections
{
    // @DataMember(Name="suspended")
    // @ApiMember(Name="suspended")
    Suspended?: number;

    // @DataMember(Name="connected")
    // @ApiMember(Name="connected")
    Connected?: number;

    // @DataMember(Name="queuedMessages")
    // @ApiMember(Name="queuedMessages")
    QueuedMessages?: number;
}

interface Db
{
    // @DataMember(Name="name")
    // @ApiMember(Name="name")
    Name?: string;

    // @DataMember(Name="bytesRead")
    // @ApiMember(Name="bytesRead")
    BytesRead?: number;

    // @DataMember(Name="bytesWritten")
    // @ApiMember(Name="bytesWritten")
    BytesWritten?: number;

    // @DataMember(Name="reads")
    // @ApiMember(Name="reads")
    Reads?: number;

    // @DataMember(Name="writes")
    // @ApiMember(Name="writes")
    Writes?: number;
}

interface SessionToProcess
{
    // @DataMember(Name="sessionId")
    // @ApiMember(Name="sessionId")
    SessionId?: string;

    // @DataMember(Name="processId")
    // @ApiMember(Name="processId")
    ProcessId?: number;
}

interface PortalStatus
{
    // @DataMember(Name="processName")
    // @ApiMember(Name="processName")
    ProcessName?: string;

    // @DataMember(Name="cpu")
    // @ApiMember(Name="cpu")
    Cpu?: Cpu;

    // @DataMember(Name="memory")
    // @ApiMember(Name="memory")
    Memory?: Memory;

    // @DataMember(Name="sinceLastMonitored")
    // @ApiMember(Name="sinceLastMonitored")
    SinceLastMonitored?: number;

    // @DataMember(Name="indexStatus")
    // @ApiMember(Name="indexStatus")
    IndexStatus?: IndexStatus[];

    // @DataMember(Name="weakValueMap")
    // @ApiMember(Name="weakValueMap")
    WeakValueMap?: boolean;

    // @DataMember(Name="lastRabbitMessage")
    // @ApiMember(Name="lastRabbitMessage")
    LastRabbitMessage?: number;

    // @DataMember(Name="amqpConnection")
    // @ApiMember(Name="amqpConnection")
    AmqpConnection?: boolean;

    // @DataMember(Name="amqpQueue")
    // @ApiMember(Name="amqpQueue")
    AmqpQueue?: string;

    // @DataMember(Name="clientConnections")
    // @ApiMember(Name="clientConnections")
    ClientConnections?: ClientConnections;

    // @DataMember(Name="outstandingRequests")
    // @ApiMember(Name="outstandingRequests")
    OutstandingRequests?: Object[];

    // @DataMember(Name="throttledRequests")
    // @ApiMember(Name="throttledRequests")
    ThrottledRequests?: Object[];

    // @DataMember(Name="incomingRequests")
    // @ApiMember(Name="incomingRequests")
    IncomingRequests?: Object[];

    // @DataMember(Name="dbs")
    // @ApiMember(Name="dbs")
    Dbs?: Db[];

    // @DataMember(Name="backgroundTasksProcessing")
    // @ApiMember(Name="backgroundTasksProcessing")
    BackgroundTasksProcessing?: number[];

    // @DataMember(Name="documentSetsToUpdate")
    // @ApiMember(Name="documentSetsToUpdate")
    DocumentSetsToUpdate?: number[];

    // @DataMember(Name="lastUpdate")
    // @ApiMember(Name="lastUpdate")
    LastUpdate?: number;

    // @DataMember(Name="pid")
    // @ApiMember(Name="pid")
    Pid?: number;

    // @DataMember(Name="sessionToProcess")
    // @ApiMember(Name="sessionToProcess")
    SessionToProcess?: SessionToProcess[];
}

interface PortalLog
{
    DateTime?: string;
    Log?: string;
}

// @Route("/admin/settings/portal", "GET, PATCH")
// @DataContract
interface Portal extends IReturn<Portal>
{
    // @DataMember(Name="port")
    // @ApiMember(Name="port")
    Port?: number;

    // @DataMember(Name="use-local-instances", EmitDefaultValue=false)
    // @ApiMember(Name="use-local-instances")
    UseLocalInstances?: boolean;

    // @DataMember(Name="wait-for-debugger", EmitDefaultValue=false)
    // @ApiMember(Name="wait-for-debugger")
    WaitForDebugger?: boolean;

    // @DataMember(Name="use-host-specific-db", EmitDefaultValue=false)
    // @ApiMember(Name="use-host-specific-db")
    UseHostSpecificDb?: boolean;

    // @DataMember(Name="max-memory", EmitDefaultValue=false)
    // @ApiMember(Name="max-memory")
    MaxMemory?: number;

    // @DataMember(Name="max-http-header-size", EmitDefaultValue=false)
    // @ApiMember(Name="max-http-header-size")
    MaxHttpHeaderSize?: number;

    // @DataMember(Name="local-cfg", EmitDefaultValue=false)
    // @ApiMember(Name="local-cfg")
    LocalCfg?: string;

    // @DataMember(Name="use-multi-process", EmitDefaultValue=false)
    // @ApiMember(Name="use-multi-process")
    UseMultiProcess?: boolean;

    // @DataMember(Name="static-file-directory")
    // @ApiMember(Name="static-file-directory")
    StaticFileDirectory?: string;

    // @DataMember(Name="monitor-timeout", EmitDefaultValue=false)
    // @ApiMember(Name="monitor-timeout")
    MonitorTimeout?: number;

    // @DataMember(Name="source-maps", EmitDefaultValue=false)
    // @ApiMember(Name="source-maps")
    SourceMaps?: string;

    // @DataMember(Name="profiling", EmitDefaultValue=false)
    // @ApiMember(Name="profiling")
    Profiling?: boolean;

    // @DataMember(Name="ignore-cache")
    // @ApiMember(Name="ignore-cache")
    IgnoreCache?: boolean;
}

interface Status extends IDto
{
    Id?: number;
    CreatorId?: number;
    Select?: string[];
    Set?: string[];
    IgnoreCache?: boolean;
    API?: ServiceStatus;
    Q?: ServiceStatus;
    RabbitErrors?: QueueLog[];
    Scheduler?: ServiceStatus;
    RabbitQueues?: RabbitQueueItem[];
    Portal?: Portal;
    Errors?: ExceptionDto[];
}

interface DocSharingService
{
}

interface AnalysisAccessedBase extends Dto<AnalysisAccessed>
{
    /**
    * int?
    */
    // @ApiMember(Description="int?", IsRequired=true, Name="AccessCount")
    AccessCount?: number;

    /**
    * Analysis
    */
    // @ApiMember(Description="Analysis", IsRequired=true, Name="Analysis")
    Analysis?: Reference;

    /**
    * Primary Key of Analysis
    */
    // @ApiMember(Description="Primary Key of Analysis", Name="AnalysisId")
    AnalysisId?: number;

    /**
    * string
    */
    // @ApiMember(Description="string", IsRequired=true, Name="App")
    App?: string;

    /**
    * User
    */
    // @ApiMember(Description="User", IsRequired=true, Name="Owner")
    Owner?: Reference;

    /**
    * Primary Key of User
    */
    // @ApiMember(Description="Primary Key of User", Name="OwnerId")
    OwnerId?: number;
}

// @Route("/analysisaccessed/{Id}", "GET, PATCH, PUT, DELETE")
// @Route("/analysisaccessed", "POST")
interface AnalysisAccessed extends AnalysisAccessedBase, IReturn<AnalysisAccessed>, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

interface AnalysisAccessedSearchBase extends Search_1<AnalysisAccessed>
{
    Id?: number;
    IdAfter?: number;
    IdBefore?: number;
    AccessCount?: number;
    Analysis?: Reference;
    AnalysisIds?: number[];
    App?: string;
    Apps?: string[];
    Owner?: Reference;
    OwnerIds?: number[];
}

interface AnalysisBase extends Dto<Analysis>
{
    /**
    * string
    */
    // @ApiMember(Description="string", IsRequired=true, Name="Name")
    Name?: string;

    /**
    * Scope
    */
    // @ApiMember(Description="Scope", Name="Scopes")
    Scopes?: Reference[];

    ScopesIds?: number[];
    ScopesCount?: number;
    /**
    * JsonObject
    */
    // @ApiMember(Description="JsonObject", Name="Selections")
    Selections?: JsonObject;

    /**
    * User
    */
    // @ApiMember(Description="User", IsRequired=true, Name="User")
    User?: Reference;

    /**
    * Primary Key of User
    */
    // @ApiMember(Description="Primary Key of User", Name="UserId")
    UserId?: number;
}

// @Route("/analysis/{Id}", "GET, PATCH, PUT, DELETE")
// @Route("/analysis", "POST")
interface Analysis extends AnalysisBase, IReturn<Analysis>, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

interface AnalysisSearchBase extends Search_1<Analysis>
{
    Id?: number;
    IdAfter?: number;
    IdBefore?: number;
    Name?: string;
    Names?: string[];
    ScopesIds?: number[];
    Selections?: string;
    Selectionss?: string[];
    User?: Reference;
    UserIds?: number[];
}

type OnRemoveAction = "Default" | "Deny" | "Cascade" | "Clear" | "None";

// @DataContract
type DataType = "UNKNOWN" | "BOOL" | "BOOL_NULLABLE" | "CHAR" | "CHAR_NULLABLE" | "DATETIME" | "DATETIME_NULLABLE" | "DECIMAL" | "DECIMAL_NULLABLE" | "INT" | "INT_NULLABLE" | "SHORT" | "SHORT_NULLABLE" | "STRING" | "STRING_NULLABLE" | "ENUM" | "ENUM_NULLABLE" | "STRUCTURE" | "RELATIONSHIP" | "RELATIONSHIPS";

// @DataContract
type UiType = "BUTTON" | "EMAIL" | "ICON" | "PASSWORD" | "PERMISSIONS" | "TABLE" | "WYSIWYG";

interface DataPropertyBase extends Dto<DataProperty>
{
    /**
    * bool
    */
    // @ApiMember(Description="bool", Name="AutoCreateMissing")
    AutoCreateMissing?: boolean;

    /**
    * DataProperty
    */
    // @ApiMember(Description="DataProperty", Name="Children")
    Children?: Reference[];

    ChildrenIds?: number[];
    ChildrenCount?: number;
    /**
    * DataClass
    */
    // @ApiMember(Description="DataClass", IsRequired=true, Name="Class")
    Class?: Reference;

    /**
    * Primary Key of DataClass
    */
    // @ApiMember(Description="Primary Key of DataClass", Name="ClassId")
    ClassId?: number;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="Description")
    Description?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="DisplayName")
    DisplayName?: string;

    /**
    * bool
    */
    // @ApiMember(Description="bool", Name="IsAllowAddInForm")
    IsAllowAddInForm?: boolean;

    /**
    * bool
    */
    // @ApiMember(Description="bool", Name="IsAllowCreateInForm")
    IsAllowCreateInForm?: boolean;

    /**
    * bool
    */
    // @ApiMember(Description="bool", Name="IsAllowEditInForm")
    IsAllowEditInForm?: boolean;

    /**
    * bool
    */
    // @ApiMember(Description="bool", Name="IsAllowFreeText")
    IsAllowFreeText?: boolean;

    /**
    * bool
    */
    // @ApiMember(Description="bool", Name="IsAllowRemoveInForm")
    IsAllowRemoveInForm?: boolean;

    /**
    * bool
    */
    // @ApiMember(Description="bool", Name="IsAudited")
    IsAudited?: boolean;

    /**
    * bool
    */
    // @ApiMember(Description="bool", Name="IsDisplayInForm")
    IsDisplayInForm?: boolean;

    /**
    * bool
    */
    // @ApiMember(Description="bool", Name="IsDisplayInGrid")
    IsDisplayInGrid?: boolean;

    /**
    * bool
    */
    // @ApiMember(Description="bool", Name="IsEditColumn")
    IsEditColumn?: boolean;

    /**
    * bool
    */
    // @ApiMember(Description="bool", Name="IsInsertOnly")
    IsInsertOnly?: boolean;

    /**
    * bool
    */
    // @ApiMember(Description="bool", Name="IsJSON")
    IsJSON?: boolean;

    /**
    * bool
    */
    // @ApiMember(Description="bool", Name="IsLazy")
    IsLazy?: boolean;

    /**
    * bool
    */
    // @ApiMember(Description="bool", Name="IsNullOnUpgrade")
    IsNullOnUpgrade?: boolean;

    /**
    * bool
    */
    // @ApiMember(Description="bool", Name="IsReadOnly")
    IsReadOnly?: boolean;

    /**
    * bool
    */
    // @ApiMember(Description="bool", Name="IsRelationship")
    IsRelationship?: boolean;

    /**
    * bool
    */
    // @ApiMember(Description="bool", Name="IsRequired")
    IsRequired?: boolean;

    /**
    * bool
    */
    // @ApiMember(Description="bool", Name="IsRequiredInForm")
    IsRequiredInForm?: boolean;

    /**
    * bool
    */
    // @ApiMember(Description="bool", Name="IsVirtual")
    IsVirtual?: boolean;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="JsonType")
    JsonType?: string;

    /**
    * LookupTableEnum
    */
    // @ApiMember(Description="LookupTableEnum", Name="LookupTableEnum")
    LookupTableEnum?: Reference;

    /**
    * Primary Key of LookupTableEnum
    */
    // @ApiMember(Description="Primary Key of LookupTableEnum", Name="LookupTableEnumId")
    LookupTableEnumId?: number;

    /**
    * string
    */
    // @ApiMember(Description="string", IsRequired=true, Name="Name")
    Name?: string;

    /**
    * int?
    */
    // @ApiMember(Description="int?", Name="Order")
    Order?: number;

    /**
    * DataProperty
    */
    // @ApiMember(Description="DataProperty", Name="Owner")
    Owner?: Reference;

    /**
    * Primary Key of DataProperty
    */
    // @ApiMember(Description="Primary Key of DataProperty", Name="OwnerId")
    OwnerId?: number;

    /**
    * int?
    */
    // @ApiMember(Description="int?", Name="Precision")
    Precision?: number;

    /**
    * OnRemoveAction?
    */
    // @ApiMember(Description="OnRemoveAction?", Name="RelationshipOnOwnerRemove")
    RelationshipOnOwnerRemove?: OnRemoveAction;

    /**
    * OnRemoveAction?
    */
    // @ApiMember(Description="OnRemoveAction?", Name="RelationshipOnTargetRemove")
    RelationshipOnTargetRemove?: OnRemoveAction;

    /**
    * DataProperty
    */
    // @ApiMember(Description="DataProperty", Name="RelationshipPairTo")
    RelationshipPairTo?: Reference;

    /**
    * Primary Key of DataProperty
    */
    // @ApiMember(Description="Primary Key of DataProperty", Name="RelationshipPairToId")
    RelationshipPairToId?: number;

    /**
    * int?
    */
    // @ApiMember(Description="int?", Name="Scale")
    Scale?: number;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="SetDefaultValue")
    SetDefaultValue?: string;

    /**
    * DataTab
    */
    // @ApiMember(Description="DataTab", Name="Tab")
    Tab?: Reference;

    /**
    * Primary Key of DataTab
    */
    // @ApiMember(Description="Primary Key of DataTab", Name="TabId")
    TabId?: number;

    /**
    * DataClass
    */
    // @ApiMember(Description="DataClass", Name="Target")
    Target?: Reference;

    /**
    * Primary Key of DataClass
    */
    // @ApiMember(Description="Primary Key of DataClass", Name="TargetId")
    TargetId?: number;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="TargetAlias")
    TargetAlias?: string;

    /**
    * DataType?
    */
    // @ApiMember(Description="DataType?", Name="Type")
    Type?: DataType;

    /**
    * UiType?
    */
    // @ApiMember(Description="UiType?", Name="UIType")
    UIType?: UiType;
}

// @Route("/dataproperty/{Id}", "GET, PATCH, PUT")
interface DataProperty extends DataPropertyBase, IReturn<DataProperty>, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

interface DataTabBase extends Dto<DataTab>
{
    /**
    * DataClass
    */
    // @ApiMember(Description="DataClass", IsRequired=true, Name="Class")
    Class?: Reference;

    /**
    * Primary Key of DataClass
    */
    // @ApiMember(Description="Primary Key of DataClass", Name="ClassId")
    ClassId?: number;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="Description")
    Description?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", IsRequired=true, Name="Name")
    Name?: string;

    /**
    * int?
    */
    // @ApiMember(Description="int?", Name="Order")
    Order?: number;
}

// @Route("/datatab/{Id}", "GET, PATCH, PUT")
interface DataTab extends DataTabBase, IReturn<DataTab>, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

interface DataClassBase extends Dto<DataClass>
{
    /**
    * bool
    */
    // @ApiMember(Description="bool", Name="AllowDelete")
    AllowDelete?: boolean;

    /**
    * bool
    */
    // @ApiMember(Description="bool", Name="AllSelectByDefault")
    AllSelectByDefault?: boolean;

    /**
    * int?
    */
    // @ApiMember(Description="int?", Name="CacheDuration")
    CacheDuration?: number;

    /**
    * int?
    */
    // @ApiMember(Description="int?", IsRequired=true, Name="ClassId")
    ClassId?: number;

    /**
    * DataProperty
    */
    // @ApiMember(Description="DataProperty", Name="CustomCollections")
    CustomCollections?: Reference[];

    CustomCollectionsIds?: number[];
    CustomCollectionsCount?: number;
    /**
    * bool
    */
    // @ApiMember(Description="bool", Name="DELETE")
    DELETE?: boolean;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="Description")
    Description?: string;

    /**
    * DataProperty
    */
    // @ApiMember(Description="DataProperty", Name="DontFlattenProperties")
    DontFlattenProperties?: Reference[];

    DontFlattenPropertiesIds?: number[];
    DontFlattenPropertiesCount?: number;
    /**
    * string
    */
    // @ApiMember(Description="string", Name="DtoSuffix")
    DtoSuffix?: string;

    /**
    * bool
    */
    // @ApiMember(Description="bool", Name="FlattenReferences")
    FlattenReferences?: boolean;

    /**
    * bool
    */
    // @ApiMember(Description="bool", Name="GET")
    GET?: boolean;

    /**
    * DataProperty
    */
    // @ApiMember(Description="DataProperty", Name="IgnoreProps")
    IgnoreProps?: Reference[];

    IgnorePropsIds?: number[];
    IgnorePropsCount?: number;
    /**
    * bool
    */
    // @ApiMember(Description="bool", Name="IsInsertOnly")
    IsInsertOnly?: boolean;

    /**
    * bool
    */
    // @ApiMember(Description="bool", Name="IsReadOnly")
    IsReadOnly?: boolean;

    /**
    * string
    */
    // @ApiMember(Description="string", IsRequired=true, Name="Name")
    Name?: string;

    /**
    * bool
    */
    // @ApiMember(Description="bool", Name="PATCH")
    PATCH?: boolean;

    /**
    * bool
    */
    // @ApiMember(Description="bool", Name="POST")
    POST?: boolean;

    /**
    * DataProperty
    */
    // @ApiMember(Description="DataProperty", Name="Properties")
    Properties?: DataProperty[];

    PropertiesIds?: number[];
    PropertiesCount?: number;
    /**
    * bool
    */
    // @ApiMember(Description="bool", Name="PUT")
    PUT?: boolean;

    /**
    * DataTab
    */
    // @ApiMember(Description="DataTab", Name="Tabs")
    Tabs?: DataTab[];

    TabsIds?: number[];
    TabsCount?: number;
}

// @Route("/dataclass/{Id}", "GET, PATCH, PUT")
interface DataClass extends DataClassBase, IReturn<DataClass>, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

interface DataClassSearchBase extends Search_1<DataClass>
{
    Id?: number;
    IdAfter?: number;
    IdBefore?: number;
    AllowDelete?: boolean[];
    AllSelectByDefault?: boolean[];
    CacheDuration?: number;
    ClassId?: number;
    CustomCollectionsIds?: number[];
    DELETE?: boolean[];
    Description?: string;
    Descriptions?: string[];
    DontFlattenPropertiesIds?: number[];
    DtoSuffix?: string;
    DtoSuffixs?: string[];
    FlattenReferences?: boolean[];
    GET?: boolean[];
    IgnorePropsIds?: number[];
    IsInsertOnly?: boolean[];
    IsReadOnly?: boolean[];
    Name?: string;
    Names?: string[];
    PATCH?: boolean[];
    POST?: boolean[];
    PropertiesIds?: number[];
    PUT?: boolean[];
    TabsIds?: number[];
}

interface DataPropertySearchBase extends Search_1<DataProperty>
{
    Id?: number;
    IdAfter?: number;
    IdBefore?: number;
    AutoCreateMissing?: boolean[];
    ChildrenIds?: number[];
    Class?: Reference;
    ClassIds?: number[];
    Description?: string;
    Descriptions?: string[];
    DisplayName?: string;
    DisplayNames?: string[];
    IsAllowAddInForm?: boolean[];
    IsAllowCreateInForm?: boolean[];
    IsAllowEditInForm?: boolean[];
    IsAllowFreeText?: boolean[];
    IsAllowRemoveInForm?: boolean[];
    IsAudited?: boolean[];
    IsDisplayInForm?: boolean[];
    IsDisplayInGrid?: boolean[];
    IsEditColumn?: boolean[];
    IsInsertOnly?: boolean[];
    IsJSON?: boolean[];
    IsLazy?: boolean[];
    IsNullOnUpgrade?: boolean[];
    IsReadOnly?: boolean[];
    IsRelationship?: boolean[];
    IsRequired?: boolean[];
    IsRequiredInForm?: boolean[];
    IsVirtual?: boolean[];
    JsonType?: string;
    JsonTypes?: string[];
    LookupTableEnum?: Reference;
    LookupTableEnumIds?: number[];
    Name?: string;
    Names?: string[];
    Order?: number;
    Owner?: Reference;
    OwnerIds?: number[];
    Precision?: number;
    RelationshipOnOwnerRemove?: OnRemoveAction;
    RelationshipOnTargetRemove?: OnRemoveAction;
    RelationshipPairTo?: Reference;
    RelationshipPairToIds?: number[];
    Scale?: number;
    SetDefaultValue?: string;
    SetDefaultValues?: string[];
    Tab?: Reference;
    TabIds?: number[];
    Target?: Reference;
    TargetIds?: number[];
    TargetAlias?: string;
    TargetAliass?: string[];
    Type?: DataType;
    UIType?: UiType;
}

interface DataTabSearchBase extends Search_1<DataTab>
{
    Id?: number;
    IdAfter?: number;
    IdBefore?: number;
    Class?: Reference;
    ClassIds?: number[];
    Description?: string;
    Descriptions?: string[];
    Name?: string;
    Names?: string[];
    Order?: number;
}

interface FAQCategoryBase extends Dto<FAQCategory>
{
    /**
    * Client
    */
    // @ApiMember(Description="Client", Name="Client")
    Client?: Reference;

    /**
    * Primary Key of Client
    */
    // @ApiMember(Description="Primary Key of Client", Name="ClientId")
    ClientId?: number;

    /**
    * Image
    */
    // @ApiMember(Description="Image", Name="Image")
    Image?: Reference;

    /**
    * Primary Key of Image
    */
    // @ApiMember(Description="Primary Key of Image", Name="ImageId")
    ImageId?: number;

    /**
    * string
    */
    // @ApiMember(Description="string", IsRequired=true, Name="Name")
    Name?: string;

    /**
    * FAQCategory
    */
    // @ApiMember(Description="FAQCategory", Name="ParentCategory")
    ParentCategory?: Reference;

    /**
    * Primary Key of FAQCategory
    */
    // @ApiMember(Description="Primary Key of FAQCategory", Name="ParentCategoryId")
    ParentCategoryId?: number;

    /**
    * Scope
    */
    // @ApiMember(Description="Scope", Name="Scopes")
    Scopes?: Reference[];

    ScopesIds?: number[];
    ScopesCount?: number;
    /**
    * JsonObject
    */
    // @ApiMember(Description="JsonObject", Name="Settings")
    Settings?: JsonObject;
}

// @Route("/faqcategory/{Id}", "GET, PATCH, PUT, DELETE")
// @Route("/faqcategory", "POST")
interface FAQCategory extends FAQCategoryBase, IReturn<FAQCategory>, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

interface FAQCategorySearchBase extends Search_1<FAQCategory>
{
    Id?: number;
    IdAfter?: number;
    IdBefore?: number;
    Client?: Reference;
    ClientIds?: number[];
    Image?: Reference;
    ImageIds?: number[];
    Name?: string;
    Names?: string[];
    ParentCategory?: Reference;
    ParentCategoryIds?: number[];
    ScopesIds?: number[];
    Settings?: string;
    Settingss?: string[];
}

interface FavoriteBase extends Dto<Favorite>
{
    /**
    * Analysis
    */
    // @ApiMember(Description="Analysis", IsRequired=true, Name="Analysis")
    Analysis?: Reference;

    /**
    * Primary Key of Analysis
    */
    // @ApiMember(Description="Primary Key of Analysis", Name="AnalysisId")
    AnalysisId?: number;

    /**
    * string
    */
    // @ApiMember(Description="string", IsRequired=true, Name="App")
    App?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="Description")
    Description?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="Name")
    Name?: string;

    /**
    * User
    */
    // @ApiMember(Description="User", IsRequired=true, Name="Owner")
    Owner?: Reference;

    /**
    * Primary Key of User
    */
    // @ApiMember(Description="Primary Key of User", Name="OwnerId")
    OwnerId?: number;
}

// @Route("/favorite", "POST")
// @Route("/favorite/{Id}", "GET, PATCH, PUT, DELETE")
interface Favorite extends FavoriteBase, IReturn<Favorite>, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

interface FavoriteSearchBase extends Search_1<Favorite>
{
    Id?: number;
    IdAfter?: number;
    IdBefore?: number;
    Analysis?: Reference;
    AnalysisIds?: number[];
    App?: string;
    Apps?: string[];
    Description?: string;
    Descriptions?: string[];
    Name?: string;
    Names?: string[];
    Owner?: Reference;
    OwnerIds?: number[];
}

interface ImageBase extends Dto<Image>
{
    /**
    * string
    */
    // @ApiMember(Description="string", Name="Contents")
    Contents?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", IsRequired=true, Name="Name")
    Name?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", IsRequired=true, Name="Type")
    Type?: string;
}

// @Route("/image", "POST")
// @Route("/image/{Id}", "GET, PATCH, PUT, DELETE")
interface Image extends ImageBase, IReturn<Image>, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

interface ImageSearchBase extends Search_1<Image>
{
    Id?: number;
    IdAfter?: number;
    IdBefore?: number;
    Contents?: string;
    Contentss?: string[];
    Name?: string;
    Names?: string[];
    Type?: string;
    Types?: string[];
}

type ReconciliationStatusEnm = "MATCHED" | "MULTIPLE_MATCHES" | "NO_MATCH" | "ONE_MATCH";

interface ReconcileDocumentBase extends Dto<ReconcileDocument>
{
    /**
    * string
    */
    // @ApiMember(Description="string", Name="ArticleId")
    ArticleId?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="ArticleLink")
    ArticleLink?: string;

    /**
    * User
    */
    // @ApiMember(Description="User", Name="Assignee")
    Assignee?: Reference;

    /**
    * Primary Key of User
    */
    // @ApiMember(Description="Primary Key of User", Name="AssigneeId")
    AssigneeId?: number;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="Data")
    Data?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", IsRequired=true, Name="Description")
    Description?: string;

    /**
    * Document
    */
    // @ApiMember(Description="Document", Name="Document")
    Document?: Reference;

    /**
    * Primary Key of Document
    */
    // @ApiMember(Description="Primary Key of Document", Name="DocumentId")
    DocumentId?: number;

    /**
    * DateTime?
    */
    // @ApiMember(Description="DateTime?", Name="DueDate")
    DueDate?: string;

    /**
    * int?
    */
    // @ApiMember(Description="int?", Name="Matches")
    Matches?: number;

    /**
    * User
    */
    // @ApiMember(Description="User", IsRequired=true, Name="Reporter")
    Reporter?: Reference;

    /**
    * Primary Key of User
    */
    // @ApiMember(Description="Primary Key of User", Name="ReporterId")
    ReporterId?: number;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="SearchLink")
    SearchLink?: string;

    /**
    * ReconciliationStatusEnm?
    */
    // @ApiMember(Description="ReconciliationStatusEnm?", Name="Status")
    Status?: ReconciliationStatusEnm;

    /**
    * Workflow
    */
    // @ApiMember(Description="Workflow", IsRequired=true, Name="Workflow")
    Workflow?: Reference;

    /**
    * Primary Key of Workflow
    */
    // @ApiMember(Description="Primary Key of Workflow", Name="WorkflowId")
    WorkflowId?: number;
}

// @Route("/reconciledocument", "POST")
// @Route("/reconciledocument/{Id}", "GET, PATCH, PUT, DELETE")
interface ReconcileDocument extends ReconcileDocumentBase, IReturn<ReconcileDocument>, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

interface ReconcileDocumentSearchBase extends Search_1<ReconcileDocument>
{
    Id?: number;
    IdAfter?: number;
    IdBefore?: number;
    ArticleId?: string;
    ArticleIds?: string[];
    ArticleLink?: string;
    ArticleLinks?: string[];
    Assignee?: Reference;
    AssigneeIds?: number[];
    Data?: string;
    Datas?: string[];
    Description?: string;
    Descriptions?: string[];
    Document?: Reference;
    DocumentIds?: number[];
    DueDate?: string;
    DueDateAfter?: string;
    DueDateBefore?: string;
    Matches?: number;
    Reporter?: Reference;
    ReporterIds?: number[];
    SearchLink?: string;
    SearchLinks?: string[];
    Status?: ReconciliationStatusEnm;
    Workflow?: Reference;
    WorkflowIds?: number[];
}

interface IDtoType
{
    Gestalt?: string;
    ValueType?: string;
}

interface TypeDateTime extends IDtoType
{
    Gestalt?: string;
    DateDay?: number;
    DateMonth?: number;
    DateTime?: string;
    DateYear?: number;
}

interface UnitsBase extends Dto<UnitsDto>
{
}

interface UnitOfMeasureBase extends Dto<UnitOfMeasure>
{
    /**
    * UnitOfMeasure
    */
    // @ApiMember(Description="UnitOfMeasure", Name="AliasOf")
    AliasOf?: Reference;

    /**
    * Primary Key of UnitOfMeasure
    */
    // @ApiMember(Description="Primary Key of UnitOfMeasure", Name="AliasOfId")
    AliasOfId?: number;

    /**
    * bool
    */
    // @ApiMember(Description="bool", Name="IsSI")
    IsSI?: boolean;

    /**
    * LookupTable
    */
    // @ApiMember(Description="LookupTable", IsRequired=true, Name="Name")
    Name?: Reference;

    /**
    * Primary Key of LookupTable
    */
    // @ApiMember(Description="Primary Key of LookupTable", Name="NameId")
    NameId?: number;

    /**
    * LookupTable
    */
    // @ApiMember(Description="LookupTable", IsRequired=true, Name="Type")
    Type?: Reference;

    /**
    * Primary Key of LookupTable
    */
    // @ApiMember(Description="Primary Key of LookupTable", Name="TypeId")
    TypeId?: number;

    /**
    * LookupTable
    */
    // @ApiMember(Description="LookupTable", Name="Unit")
    Unit?: Reference;

    /**
    * Primary Key of LookupTable
    */
    // @ApiMember(Description="Primary Key of LookupTable", Name="UnitId")
    UnitId?: number;
}

// @Route("/unitofmeasure", "POST")
// @Route("/unitofmeasure/{Id}", "GET, PATCH, PUT, DELETE")
interface UnitOfMeasure extends UnitOfMeasureBase, IReturn<UnitOfMeasure>, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

interface UnitValueBase extends Dto<UnitValue>
{
    /**
    * LookupTable
    */
    // @ApiMember(Description="LookupTable", Name="EqualityOperator")
    EqualityOperator?: Reference;

    /**
    * Primary Key of LookupTable
    */
    // @ApiMember(Description="Primary Key of LookupTable", Name="EqualityOperatorId")
    EqualityOperatorId?: number;

    /**
    * int?
    */
    // @ApiMember(Description="int?", Name="Multiplier")
    Multiplier?: number;

    /**
    * decimal?
    */
    // @ApiMember(Description="decimal?", Name="Number")
    Number?: number;

    /**
    * int?
    */
    // @ApiMember(Description="int?", Name="Order")
    Order?: number;

    /**
    * UnitOfMeasure
    */
    // @ApiMember(Description="UnitOfMeasure", IsRequired=true, Name="Unit")
    Unit?: UnitOfMeasure;

    /**
    * Primary Key of UnitOfMeasure
    */
    // @ApiMember(Description="Primary Key of UnitOfMeasure", Name="UnitId")
    UnitId?: number;
}

interface UnitValue extends UnitValueBase, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];

    Owners?: Reference[];
    OwnersCount?: number;
    OwnersIds?: number;
}

interface UnitsDto extends UnitsBase, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];

    Units?: UnitValue[];
    UnitsCount?: number;
    UnitsIds?: number;
    IsUnknown?: boolean;
}

interface TypeUnitsRange extends IDtoType
{
    Gestalt?: string;
    High?: UnitsDto;
    Low?: UnitsDto;
}

interface TypeDecimal extends IDtoType
{
    Gestalt?: string;
    Bottom?: number;
    Decimal?: number;
    EqualityOperator?: Reference;
    Top?: number;
}

interface TypeDecimalRange extends IDtoType
{
    Gestalt?: string;
    High?: TypeDecimal;
    Low?: TypeDecimal;
}

interface TypeUnits extends IDtoType
{
    IsUnknown?: boolean;
    Gestalt?: string;
    Units?: UnitsDto;
}

interface MeanRangeValueBase extends Dto<MeanRangeValue>
{
    /**
    * LookupTable
    */
    // @ApiMember(Description="LookupTable", Name="MeanVarianceType")
    MeanVarianceType?: Reference;

    /**
    * Primary Key of LookupTable
    */
    // @ApiMember(Description="Primary Key of LookupTable", Name="MeanVarianceTypeId")
    MeanVarianceTypeId?: number;

    /**
    * Units
    */
    // @ApiMember(Description="Units", Name="MidSpread")
    MidSpread?: TypeUnits;

    /**
    * int?
    */
    // @ApiMember(Description="int?", Name="Order")
    Order?: number;

    /**
    * MeanRanges
    */
    // @ApiMember(Description="MeanRanges", Name="Owners")
    Owners?: MeanRanges[];

    OwnersIds?: number[];
    OwnersCount?: number;
    /**
    * decimal?
    */
    // @ApiMember(Description="decimal?", Name="Percent")
    Percent?: number;

    /**
    * decimal?
    */
    // @ApiMember(Description="decimal?", Name="PercentLow")
    PercentLow?: number;

    /**
    * UnitsRange
    */
    // @ApiMember(Description="UnitsRange", Name="Range")
    Range?: TypeUnitsRange;

    /**
    * LookupTable
    */
    // @ApiMember(Description="LookupTable", IsRequired=true, Name="Type")
    Type?: Reference;

    /**
    * Primary Key of LookupTable
    */
    // @ApiMember(Description="Primary Key of LookupTable", Name="TypeId")
    TypeId?: number;
}

interface MeanRangeValue extends MeanRangeValueBase, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

interface MeanRangesBase extends Dto<MeanRanges>
{
    RangesCount?: number;
    RangesIds?: number;
    Ranges?: MeanRangeValue[];
}

interface MeanRanges extends MeanRangesBase, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

interface MeanVarianceValueBase extends Dto<MeanVarianceValue>
{
    /**
    * Units
    */
    // @ApiMember(Description="Units", Name="MeanVariance")
    MeanVariance?: TypeUnits;

    /**
    * UnitsRange
    */
    // @ApiMember(Description="UnitsRange", Name="MeanVarianceRange")
    MeanVarianceRange?: TypeUnitsRange;

    /**
    * LookupTable
    */
    // @ApiMember(Description="LookupTable", IsRequired=true, Name="MeanVarianceType")
    MeanVarianceType?: Reference;

    /**
    * Primary Key of LookupTable
    */
    // @ApiMember(Description="Primary Key of LookupTable", Name="MeanVarianceTypeId")
    MeanVarianceTypeId?: number;

    /**
    * int?
    */
    // @ApiMember(Description="int?", Name="Order")
    Order?: number;

    /**
    * MeanVariances
    */
    // @ApiMember(Description="MeanVariances", Name="Owners")
    Owners?: MeanVariances[];

    OwnersIds?: number[];
    OwnersCount?: number;
}

interface MeanVarianceValue extends MeanVarianceValueBase, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

interface MeanVariancesBase extends Dto<MeanVariances>
{
    VariancesCount?: number;
    VariancesIds?: number;
    Variances?: MeanVarianceValue[];
}

interface MeanVariances extends MeanVariancesBase, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

interface TypeMeanBase extends IDtoType
{
    Gestalt?: string;
    MeanCalculationType?: Reference;
    MeanVariable?: UnitsDto;
    MeanVariableType?: Reference;
    MeanVariableValueRange?: TypeUnitsRange;
    MeanVariance?: number;
    MeanVarianceType?: Reference;
    MeanVarianceValueRange?: TypeDecimalRange;
    Ranges?: MeanRanges;
    Variances?: MeanVariances;
}

interface TypeUnitValue extends IDtoType
{
    Gestalt?: string;
    EqualityOperator?: Reference;
    Multiplier?: number;
    Number?: number;
    Unit?: UnitOfMeasure;
}

interface TypeUnitRange extends IDtoType
{
    Gestalt?: string;
    High?: TypeUnitValue;
    Low?: TypeUnitValue;
    Type?: Reference;
}

interface TypeTimepoint extends IDtoType
{
    Gestalt?: string;
    Description?: string;
    DescriptionHigh?: string;
    IsAbsolute?: boolean;
    MeanValue?: TypeMeanBase;
    SingleValue?: TypeUnitValue;
    TotalValue?: TypeUnitRange;
    Type?: Reference;
}

interface TypeInterval extends IDtoType
{
    Gestalt?: string;
    CalendarDateEnd?: TypeDateTime;
    CalendarDateStart?: TypeDateTime;
    CalendarType?: string;
    FollowUp?: TypeTimepoint;
    TimeOfDay?: TypeTimepoint;
}

interface AttributeIntervalBase extends Dto<AttributeInterval>
{
    /**
    * Interval
    */
    // @ApiMember(Description="Interval", IsRequired=true, Name="Interval")
    Interval?: TypeInterval;
}

// @Route("/attributeinterval", "POST")
// @Route("/attributeinterval/{Id}", "GET, PATCH, PUT, DELETE")
interface AttributeInterval extends AttributeIntervalBase, IReturn<AttributeInterval>, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

interface AttributeIntervalSearchBase extends Search_1<AttributeInterval>
{
    Id?: number;
    IdAfter?: number;
    IdBefore?: number;
    Interval?: TypeInterval;
}

interface BoundTerm
{
    BoundTermLabel?: string;
    BoundTermUri?: string;
}

interface DtoAttributeQualifier extends IDto
{
    // @ApiMember(ExcludeInSchema=true, Name="Gestalt")
    Gestalt?: string;

    // @ApiMember(ExcludeInSchema=true, Name="Id")
    Id?: number;

    CreatorId?: number;
    // @ApiMember(ExcludeInSchema=true, Name="VersionNo")
    VersionNo?: number;

    IgnoreCache?: boolean;
    /**
    * Units
    */
    // @ApiMember(Description="Units", IsRequired=true, Name="High")
    High?: UnitsDto;

    /**
    * Units
    */
    // @ApiMember(Description="Units", Name="Low")
    Low?: UnitsDto;

    Select?: string[];
    Set?: string[];
}

// @Route("/attributequalifier/{Id}", "PATCH")
// @Route("/attributequalifier/{Id}", "PUT")
// @Route("/profile/attributequalifier/{Id}", "PATCH")
// @Route("/profile/attributequalifier/{Id}", "DELETE")
// @Route("/profile/attributequalifier/{Id}", "PUT")
// @Route("/attributequalifier/{Id}", "DELETE")
// @Route("/attributequalifier", "POST")
// @Route("/profile/attributequalifier", "POST")
interface AttributeQualifier extends DtoAttributeQualifier, IDto
{
}

interface DtoPropertySet extends IDto
{
    // @ApiMember(ExcludeInSchema=true, Name="Gestalt")
    Gestalt?: string;

    // @ApiMember(ExcludeInSchema=true, Name="Id")
    Id?: number;

    CreatorId?: number;
    IgnoreCache?: boolean;
    // @ApiMember(ExcludeInSchema=true, Name="VersionNo")
    VersionNo?: number;

    /**
    * SourceDocument
    */
    // @ApiMember(Description="SourceDocument", IsRequired=true, Name="Source")
    Source?: Reference;

    /**
    * int
    */
    // @ApiMember(Description="int", IsRequired=true, Name="ValueId")
    ValueId?: number;

    Select?: string[];
    Set?: string[];
}

interface PropertySet extends DtoPropertySet, IDto
{
    Left?: Attribute[];
    Right?: Attribute[];
    Value?: Attribute;
}

interface DtoExternalKey extends IDto
{
    // @ApiMember(ExcludeInSchema=true, Name="Gestalt")
    Gestalt?: string;

    // @ApiMember(ExcludeInSchema=true, Name="Id")
    Id?: number;

    CreatorId?: number;
    // @ApiMember(ExcludeInSchema=true, Name="VersionNo")
    VersionNo?: number;

    // @ApiMember(Name="Created")
    Created?: string;

    // @ApiMember(Name="Updated")
    Updated?: string;

    IgnoreCache?: boolean;
    /**
    * LookupTable
    */
    // @ApiMember(Description="LookupTable", IsRequired=true, Name="Enum")
    Enum?: Reference;

    /**
    * Primary Key of LookupTable
    */
    // @ApiMember(Description="Primary Key of LookupTable", Name="EnumId")
    EnumId?: number;

    /**
    * int
    */
    // @ApiMember(Description="int", IsRequired=true, Name="Fk")
    Fk?: number;

    Select?: string[];
    Set?: string[];
}

// @Route("/externalkey", "POST")
// @Route("/externalkey/{Id}", "GET, PATCH, PUT, DELETE")
// @Route("/profile/externalkey", "POST")
// @Route("/profile/externalkey/{Id}", "GET, PATCH, PUT, DELETE")
interface ExternalKey extends DtoExternalKey, IDto
{
    Select?: string[];
}

interface DtoSourceDocument extends IDto
{
    // @ApiMember(ExcludeInSchema=true, Name="Gestalt")
    Gestalt?: string;

    // @ApiMember(ExcludeInSchema=true, Name="Id")
    Id?: number;

    CreatorId?: number;
    IgnoreCache?: boolean;
    // @ApiMember(ExcludeInSchema=true, Name="VersionNo")
    VersionNo?: number;

    /**
    * ExternalKey
    */
    // @ApiMember(Description="ExternalKey", Name="Association")
    Association?: ExternalKey;

    /**
    * LookupTable
    */
    // @ApiMember(Description="LookupTable", IsRequired=true, Name="Category")
    Category?: Reference;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="Footer")
    Footer?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="Header")
    Header?: string;

    /**
    * LookupTable
    */
    // @ApiMember(Description="LookupTable", IsRequired=true, Name="Name")
    Name?: Reference;

    /**
    * int
    */
    // @ApiMember(Description="int", IsRequired=true, Name="Order")
    Order?: number;

    /**
    * int
    */
    // @ApiMember(Description="int", Name="PageNo")
    PageNo?: number;

    /**
    * PropertySet
    */
    // @ApiMember(Description="PropertySet", Name="PropertySets")
    PropertySets?: PropertySet[];

    Select?: string[];
    Set?: string[];
}

interface UnitFlat
{
    Number?: number;
    Unit?: string;
    Operator?: string;
    Per?: UnitFlat;
}

interface ValueRangeFlat
{
    Type?: string;
    Low?: number;
    LowUnit?: UnitFlat;
    High?: number;
    HighUnit?: UnitFlat;
    CI?: number;
    CILow?: number;
}

interface PropertySetFlat
{
    LeftOwners?: number[];
    RightOwners?: number[];
    LeftGroups?: number[];
    RightGroups?: number[];
}

interface UnitValueFlat extends UnitFlat
{
    Type?: string;
    Gestalt?: string;
    Description?: string;
    DescriptionHigh?: string;
    Range?: ValueRangeFlat;
}

interface ValueFlat
{
    Id?: number;
    Type?: string;
    Number?: number;
    Bool?: boolean;
    Unit?: string;
    Name?: string;
    String?: string;
    Percent?: number;
    N?: number;
    VariableType?: string;
    MeanVariance?: number;
    VarianceType?: string;
    Ranges?: ValueRangeFlat[];
    PValue?: number;
    PropertyValue?: string;
    PropertySet?: PropertySetFlat;
    CustomInterval?: UnitValueFlat;
    AttributeId?: number;
    Owner?: number;
    OwnerType?: number;
    Properties?: { [index:string]: ValueFlat; };
}

interface AttributeLabelFlat
{
    Id?: number;
    AttributeId?: number;
    Label?: string;
    FieldName?: string;
    LabelId?: number;
    FieldNameId?: number;
}

interface SourceDocument extends DtoSourceDocument, IDto
{
    Attributes?: ValueFlat[];
    AttributeLabels?: AttributeLabelFlat[];
    PropertySetsValues?: ValueFlat[];
}

interface TypePValue extends IDtoType
{
    Gestalt?: string;
    EqualityOperator?: Reference;
    Significance?: Reference;
    Value?: number;
}

interface TypeAssociationMeasure extends IDtoType
{
    Gestalt?: string;
    AdjustedDescription?: Reference;
    AM?: Reference;
    AmValue?: number;
    AmValueUnits?: UnitsDto;
    DegreesOfFreedom?: number;
    IsAdjusted?: boolean;
    PersonCount?: Reference;
    PooledSd?: number;
    PValue?: TypePValue;
    Ranges?: MeanRanges;
    StatisticalTestName?: string;
    StatisticalTestValue?: number;
    Variance?: number;
    VarianceType?: Reference;
}

interface TypeBoolean extends IDtoType
{
    Gestalt?: string;
    Boolean?: boolean;
}

interface TypeCalendarDate extends IDtoType
{
    Gestalt?: string;
    CalendarDateEnd?: TypeDateTime;
    CalendarDateStart?: TypeDateTime;
    CalendarType?: string;
}

interface TypeCalendarDates extends IDtoType
{
    CalendarDates?: TypeCalendarDate[];
    Gestalt?: string;
}

interface TypeContact extends IDtoType
{
    Gestalt?: string;
    Affiliation?: string;
    Degrees?: string;
    Email?: string;
    FirstName?: string;
    LastName?: string;
    MiddleName?: string;
    Name?: string;
    Organization?: string;
    Phone?: string;
    PhoneExt?: string;
    Role?: string;
    Title?: string;
    Type?: string;
}

interface TypeDateTimeRange extends IDtoType
{
    Gestalt?: string;
    From?: TypeDateTime;
    To?: TypeDateTime;
}

interface TypeDesignNestedStudyIdLink extends IDtoType
{
    Gestalt?: string;
    Nested?: string;
    StudyIdLink?: string;
}

interface TypeInteger extends IDtoType
{
    Gestalt?: string;
    EqualityOperator?: Reference;
    Integer?: number;
}

interface TypeEventCounts extends IDtoType
{
    Gestalt?: string;
    Events?: TypeInteger;
    SubjectsAffected?: TypeInteger;
    SubjectsAtRisk?: TypeInteger;
}

interface TypeFacility extends IDtoType
{
    Gestalt?: string;
    City?: Reference;
    Country?: Reference;
    Name?: string;
    Address?: string;
    State?: Reference;
    Zip?: string;
}

interface TypeFixedDoseIntervention extends IDtoType
{
    Gestalt?: string;
    DoseConcentration?: TypeUnitValue;
    Intervention?: Reference;
}

interface TypeFlag extends IDtoType
{
    Gestalt?: string;
    CreatedDate?: string;
    DpName?: string;
    DpValue?: string;
    FlagState?: string;
    FlagType?: Reference;
    UserId?: string;
    UserName?: string;
}

interface TypeFunding extends IDtoType
{
    Gestalt?: string;
    FundingInstitution?: Reference;
    FundingType?: Reference;
    InstitutionType?: Reference;
}

interface TypeImportError extends IDtoType
{
    Gestalt?: string;
    ErrorType?: string;
    ErrorPriority?: string;
    ErrorMsg?: string;
    BadData?: string;
    SourceName?: string;
    MoreInfo?: string;
}

interface TypeImportErrors extends IDtoType
{
    ImportErrors?: TypeImportError[];
    Gestalt?: string;
}

interface TypeTimepoints extends IDtoType
{
    Timepoints?: TypeTimepoint[];
    Gestalt?: string;
}

interface TypeIntervals extends IDtoType
{
    Gestalt?: string;
    CalendarDates?: TypeCalendarDates;
    FollowUps?: TypeTimepoints;
    TimeOfDays?: TypeTimepoints;
}

interface TypeLookup extends IDtoType
{
    Gestalt?: string;
    Value?: LookupTable;
}

interface TypeMemo extends IDtoType
{
    Gestalt?: string;
    Memo?: string;
}

interface TypeParticipant extends IDtoType
{
    Gestalt?: string;
    Number?: TypeInteger;
    Percent?: TypeDecimal;
    Ranges?: MeanRanges;
}

interface TypeNPersons extends IDtoType
{
    Gestalt?: string;
    MeanVariance?: number;
    MeanVarianceType?: Reference;
    MeanVarianceValueRange?: TypeDecimalRange;
    NumberEvents?: TypeInteger;
    Participants?: TypeParticipant;
    PrevalenceType?: Reference;
    Ranges?: MeanRanges;
    Rate?: TypeUnitValue;
    Variances?: MeanVariances;
}

interface TypeParticipants extends IDtoType
{
    Gestalt?: string;
    Female?: TypeParticipant;
    Male?: TypeParticipant;
    Total?: number;
    Unknown?: TypeParticipant;
}

interface TypePopulationAnalyzed extends IDtoType
{
    Gestalt?: string;
    Scope?: Reference;
    Units?: Reference;
    N?: TypeInteger;
}

interface TypeRate extends IDtoType
{
    Gestalt?: string;
    CountAlternate?: TypeDecimal;
    CumulativeIncidenceRateField?: Reference;
    CumulativeIncidenceRateType?: Reference;
    CumulativeMeanVariance?: number;
    CumulativeMeanVarianceType?: Reference;
    CumulativeMeanVarianceValueRange?: TypeDecimalRange;
    CumulativeRanges?: MeanRanges;
    CumulativeRate?: TypeUnitValue;
    CumulativeVariances?: MeanVariances;
    IncidenceRateField?: Reference;
    IncidenceRateType?: Reference;
    MeanVariance?: number;
    MeanVarianceType?: Reference;
    MeanVarianceValueRange?: TypeDecimalRange;
    NumberAlternate?: TypeDecimal;
    NumberEvents?: TypeInteger;
    Participants?: TypeParticipant;
    Ranges?: MeanRanges;
    Rate?: TypeUnitValue;
    TotalPersonTime?: TypeDecimal;
    TotalPersonTimeValue?: TypeUnitValue;
    Variances?: MeanVariances;
}

interface TypeSettingLocation extends IDtoType
{
    Gestalt?: string;
    Mean?: TypeMeanBase;
    Miscellaneous?: string;
    NumberPercentage?: TypeParticipant;
    SettingLocationName?: Reference;
    SettingLocationType?: Reference;
}

interface TypeSettingLocationTotal extends IDtoType
{
    Gestalt?: string;
    Mean?: TypeMeanBase;
    Miscellaneous?: string;
    NumberPercentage?: TypeParticipant;
    SettingLocation?: string;
    Total?: TypeInteger;
}

interface TypeStudyDoc extends IDtoType
{
    Gestalt?: string;
    DocId?: string;
    DocType?: string;
    DocUrl?: string;
    DocComment?: string;
}

interface TypeStudyObjective extends IDtoType
{
    Gestalt?: string;
    AppliedTo?: string;
    Objective?: Reference;
    ObjectiveDescription?: string;
}

interface TypeStudyReference extends IDtoType
{
    Gestalt?: string;
    Citation?: string;
    PmId?: string;
    Type?: string;
}

interface TypeSubgroupDescriptor extends IDtoType
{
    AttributeId?: number;
    CellId?: string;
    Gestalt?: string;
    Attribute?: Attribute;
    PrespecifiedType?: string;
    SubgroupCategoryName?: Reference;
    SubgroupName?: Reference;
    SubgroupType?: string;
    SubgroupValue?: string;
    TableGraphFigureName?: string;
}

interface TypeSubmissionInfo extends IDtoType
{
    Gestalt?: string;
    SubmissionReleaseDate?: TypeDateTime;
    SubmissionUnreleaseDate?: TypeDateTime;
    SubmissionResetDate?: TypeDateTime;
    SubmissionMCPReleaseN?: string;
}

interface TypeUncollectedValue extends IDtoType
{
    Gestalt?: string;
    FieldType?: Reference;
    Intervals?: TypeIntervals;
    IsCharacteristic?: boolean;
    IsOutcome?: boolean;
    IsRequested?: boolean;
    Stats?: number;
    TimePoints?: number;
}

interface TypeYesNoNa extends IDtoType
{
    Gestalt?: string;
    YesNoNa?: Reference;
}

interface AttributeBase extends Dto<Attribute>
{
    /**
    * LookupTable
    */
    // @ApiMember(Description="LookupTable", IsRequired=true, Name="AttributeName")
    AttributeName?: Reference;

    /**
    * Primary Key of LookupTable
    */
    // @ApiMember(Description="Primary Key of LookupTable", Name="AttributeNameId")
    AttributeNameId?: number;

    /**
    * LookupTable
    */
    // @ApiMember(Description="LookupTable", Name="AttributeType")
    AttributeType?: Reference;

    /**
    * Primary Key of LookupTable
    */
    // @ApiMember(Description="Primary Key of LookupTable", Name="AttributeTypeId")
    AttributeTypeId?: number;

    /**
    * AttributeInterval
    */
    // @ApiMember(Description="AttributeInterval", IsRequired=true, Name="Interval")
    Interval?: AttributeInterval;

    /**
    * Primary Key of AttributeInterval
    */
    // @ApiMember(Description="Primary Key of AttributeInterval", Name="IntervalId")
    IntervalId?: number;

    /**
    * bool
    */
    // @ApiMember(Description="bool", Name="IsCharacteristic")
    IsCharacteristic?: boolean;

    /**
    * bool
    */
    // @ApiMember(Description="bool", Name="IsOutcome")
    IsOutcome?: boolean;

    /**
    * bool?
    */
    // @ApiMember(Description="bool?", Name="IsPositive")
    IsPositive?: boolean;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="UniqueKey")
    UniqueKey?: string;

    BoundTerms?: BoundTerm[];
    Qualifier?: AttributeQualifier;
    SetIsBound?: boolean;
    LinkedValueId?: number;
    AttributeKey?: string;
    ValueTypeId?: number;
    SubgroupKey?: string;
    PropertySets?: PropertySet[];
    MeanBaseValue?: TypeMeanBase;
    ValueType?: string;
    Source?: SourceDocument;
    Row?: number;
    Column?: number;
    N?: number;
    Sequence?: number;
    Label?: UnitOfMeasure;
    IsPropertySetValue?: boolean;
    ArmPopulation?: string;
    ArmPopulationType?: string;
    CustomInterval?: TypeInterval;
    IsCrossover?: boolean;
    NonSymmetricalCi?: boolean;
    Status?: string;
    WithinGroupPval?: TypePValue;
    AssociationMeasureValue?: TypeAssociationMeasure;
    BooleanValue?: TypeBoolean;
    CalendarDateValue?: TypeCalendarDate;
    CalendarDatesValue?: TypeCalendarDates;
    ContactValue?: TypeContact;
    DateTimeValue?: TypeDateTime;
    DateTimeRangeValue?: TypeDateTimeRange;
    DecimalValue?: TypeDecimal;
    DecimalRangeValue?: TypeDecimalRange;
    DesignNestedStudyIdLinkValue?: TypeDesignNestedStudyIdLink;
    EventCountsValue?: TypeEventCounts;
    FacilityValue?: TypeFacility;
    FixedDoseInterventionValue?: TypeFixedDoseIntervention;
    FlagValue?: TypeFlag;
    FundingValue?: TypeFunding;
    ImportErrorValue?: TypeImportError;
    ImportErrorsValue?: TypeImportErrors;
    IntegerValue?: TypeInteger;
    IntervalValue?: TypeInterval;
    IntervalsValue?: TypeIntervals;
    LookupValue?: TypeLookup;
    MemoValue?: TypeMemo;
    NPersonsValue?: TypeNPersons;
    ParticipantValue?: TypeParticipant;
    ParticipantsValue?: TypeParticipants;
    PopulationAnalyzedValue?: TypePopulationAnalyzed;
    PValueValue?: TypePValue;
    RateValue?: TypeRate;
    SettingLocationValue?: TypeSettingLocation;
    SettingLocationTotalValue?: TypeSettingLocationTotal;
    StudyDocValue?: TypeStudyDoc;
    StudyObjectiveValue?: TypeStudyObjective;
    StudyReferenceValue?: TypeStudyReference;
    SubgroupDescriptorValue?: TypeSubgroupDescriptor;
    SubmissionInfoValue?: TypeSubmissionInfo;
    TimepointValue?: TypeTimepoint;
    TimepointsValue?: TypeTimepoints;
    UncollectedValueValue?: TypeUncollectedValue;
    UnitRangeValue?: TypeUnitRange;
    UnitsValue?: TypeUnits;
    UnitsRangeValue?: TypeUnitsRange;
    UnitValueValue?: TypeUnitValue;
    YesNoNaValue?: TypeYesNoNa;
}

// @Route("/attribute", "POST")
// @Route("/attribute/{Id}", "GET, PATCH, PUT, DELETE")
interface Attribute extends AttributeBase, IReturn<Attribute>, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

interface AttributeSearchBase extends Search_1<Attribute>
{
    Id?: number;
    IdAfter?: number;
    IdBefore?: number;
    AttributeName?: Reference;
    AttributeNameIds?: number[];
    AttributeNameNames?: string[];
    AttributeType?: Reference;
    AttributeTypeIds?: number[];
    AttributeTypeNames?: string[];
    Interval?: Reference;
    IntervalIds?: number[];
    IsCharacteristic?: boolean[];
    IsOutcome?: boolean[];
    IsPositive?: boolean[];
    UniqueKey?: string;
    UniqueKeys?: string[];
    ValueType?: Reference;
    ValueTypeIds?: number[];
}

interface AuditDeltaBase extends Dto<AuditDelta>
{
    /**
    * AuditRecord
    */
    // @ApiMember(Description="AuditRecord", IsRequired=true, Name="Audit")
    Audit?: Reference;

    /**
    * Primary Key of AuditRecord
    */
    // @ApiMember(Description="Primary Key of AuditRecord", Name="AuditId")
    AuditId?: number;

    /**
    * string
    */
    // @ApiMember(Description="string", IsRequired=true, Name="Delta")
    Delta?: string;
}

// @Route("/auditdelta/{Id}", "GET")
// @Route("/auditdelta", "POST")
interface AuditDelta extends AuditDeltaBase, IReturn<AuditDelta>, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

interface AuditDeltaSearchBase extends Search_1<AuditDelta>
{
    Id?: number;
    IdAfter?: number;
    IdBefore?: number;
    Audit?: Reference;
    AuditIds?: number[];
    Delta?: string;
    Deltas?: string[];
}

interface DatabaseVersionBase extends Dto<DatabaseVersion>
{
    /**
    * string
    */
    // @ApiMember(Description="string", Name="DatabaseState")
    DatabaseState?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="Description")
    Description?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="Release")
    Release?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", IsRequired=true, Name="VersionName")
    VersionName?: string;
}

// @Route("/databaseversion/{Id}", "GET")
interface DatabaseVersion extends DatabaseVersionBase, IReturn<DatabaseVersion>, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

interface DatabaseVersionSearchBase extends Search_1<DatabaseVersion>
{
    Id?: number;
    IdAfter?: number;
    IdBefore?: number;
    DatabaseState?: string;
    DatabaseStates?: string[];
    Description?: string;
    Descriptions?: string[];
    Release?: string;
    Releases?: string[];
    VersionName?: string;
    VersionNames?: string[];
}

interface DateTimeBase extends Dto<DateTimeDto>
{
    /**
    * int?
    */
    // @ApiMember(Description="int?", Name="DateDay")
    DateDay?: number;

    /**
    * int?
    */
    // @ApiMember(Description="int?", Name="DateMonth")
    DateMonth?: number;

    /**
    * DateTime?
    */
    // @ApiMember(Description="DateTime?", Name="DateTime")
    DateTime?: string;

    /**
    * int?
    */
    // @ApiMember(Description="int?", Name="DateYear")
    DateYear?: number;
}

// @Route("/datetime/{Id}", "GET, PATCH, PUT, DELETE")
// @Route("/datetime", "POST")
interface DateTimeDto extends DateTimeBase, IReturn<DateTimeDto>, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

interface DateTimeSearchBase extends Search_1<DateTimeDto>
{
    Id?: number;
    IdAfter?: number;
    IdBefore?: number;
    DateDay?: number;
    DateMonth?: number;
    DateTime?: string;
    DateTimeAfter?: string;
    DateTimeBefore?: string;
    DateYear?: number;
}

interface DocumentSetHistoryBase extends Dto<DocumentSetHistory>
{
    /**
    * DocumentSet
    */
    // @ApiMember(Description="DocumentSet", IsRequired=true, Name="DocumentSet")
    DocumentSet?: Reference;

    /**
    * Primary Key of DocumentSet
    */
    // @ApiMember(Description="Primary Key of DocumentSet", Name="DocumentSetId")
    DocumentSetId?: number;

    /**
    * int?
    */
    // @ApiMember(Description="int?", Name="EvidencePortalID")
    EvidencePortalID?: number;

    /**
    * int?
    */
    // @ApiMember(Description="int?", Name="FqId")
    FqId?: number;

    /**
    * int?
    */
    // @ApiMember(Description="int?", Name="StudyCount")
    StudyCount?: number;

    /**
    * int?
    */
    // @ApiMember(Description="int?", Name="StudyCountFQ")
    StudyCountFQ?: number;
}

// @Route("/documentsethistory/{Id}", "GET")
interface DocumentSetHistory extends DocumentSetHistoryBase, IReturn<DocumentSetHistory>, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

interface DocumentSetHistorySearchBase extends Search_1<DocumentSetHistory>
{
    Id?: number;
    IdAfter?: number;
    IdBefore?: number;
    DocumentSet?: Reference;
    DocumentSetIds?: number[];
    EvidencePortalID?: number;
    FqId?: number;
    StudyCount?: number;
    StudyCountFQ?: number;
}

interface SlackAttachmentField
{
    IsShort?: boolean;
    Title?: string;
    Value?: string;
}

type SlackAttachmentActionStyle = "Default" | "Primary" | "Danger";

interface SlackAttachmentAction
{
    Name?: string;
    Text?: string;
    Style?: SlackAttachmentActionStyle;
    Type?: string;
    Value?: string;
}

interface LoggingAttachment
{
    Fallback?: string;
    ColorHex?: string;
    PreText?: string;
    AuthorName?: string;
    AuthorLink?: string;
    AuthorIcon?: string;
    Title?: string;
    TitleLink?: string;
    Text?: string;
    Fields?: IList<SlackAttachmentField>;
    CallbackId?: string;
    Actions?: IList<SlackAttachmentAction>;
    ImageUrl?: string;
    ThumbUrl?: string;
    MarkdownIn?: string[];
}

interface GlossaryBase extends Dto<Glossary>
{
    /**
    * string
    */
    // @ApiMember(Description="string", Name="Definition")
    Definition?: string;

    /**
    * LookupTableEnum
    */
    // @ApiMember(Description="LookupTableEnum", IsRequired=true, Name="Enum")
    Enum?: Reference;

    /**
    * Primary Key of LookupTableEnum
    */
    // @ApiMember(Description="Primary Key of LookupTableEnum", Name="EnumId")
    EnumId?: number;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="Icon")
    Icon?: string;

    /**
    * Page
    */
    // @ApiMember(Description="Page", Name="Page")
    Page?: Reference;

    /**
    * Primary Key of Page
    */
    // @ApiMember(Description="Primary Key of Page", Name="PageId")
    PageId?: number;

    /**
    * TermMaster
    */
    // @ApiMember(Description="TermMaster", IsRequired=true, Name="Term")
    Term?: Reference;

    /**
    * Primary Key of TermMaster
    */
    // @ApiMember(Description="Primary Key of TermMaster", Name="TermId")
    TermId?: number;
}

// @Route("/glossary/{Id}", "GET, PATCH, PUT, DELETE")
// @Route("/glossary", "POST")
interface Glossary extends GlossaryBase, IReturn<Glossary>, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

interface GlossarySearchBase extends Search_1<Glossary>
{
    Id?: number;
    IdAfter?: number;
    IdBefore?: number;
    Definition?: string;
    Definitions?: string[];
    Enum?: Reference;
    EnumIds?: number[];
    Icon?: string;
    Icons?: string[];
    Page?: Reference;
    PageIds?: number[];
    Term?: Reference;
    TermIds?: number[];
}

interface HelpBase extends Dto<Help>
{
    /**
    * string
    */
    // @ApiMember(Description="string", Name="ConfluenceId")
    ConfluenceId?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="Description")
    Description?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="Icon")
    Icon?: string;

    /**
    * int?
    */
    // @ApiMember(Description="int?", Name="Order")
    Order?: number;

    /**
    * Page
    */
    // @ApiMember(Description="Page", Name="Pages")
    Pages?: Reference[];

    PagesIds?: number[];
    PagesCount?: number;
    /**
    * Scope
    */
    // @ApiMember(Description="Scope", Name="Scopes")
    Scopes?: Reference[];

    ScopesIds?: number[];
    ScopesCount?: number;
    /**
    * string
    */
    // @ApiMember(Description="string", IsRequired=true, Name="Title")
    Title?: string;

    /**
    * LookupTable
    */
    // @ApiMember(Description="LookupTable", Name="Type")
    Type?: Reference;

    /**
    * Primary Key of LookupTable
    */
    // @ApiMember(Description="Primary Key of LookupTable", Name="TypeId")
    TypeId?: number;
}

// @Route("/help", "POST")
// @Route("/help/{Id}", "GET, PATCH, PUT, DELETE")
interface Help extends HelpBase, IReturn<Help>, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

interface HelpSearchBase extends Search_1<Help>
{
    Id?: number;
    IdAfter?: number;
    IdBefore?: number;
    ConfluenceId?: string;
    ConfluenceIds?: string[];
    Description?: string;
    Descriptions?: string[];
    Icon?: string;
    Icons?: string[];
    Order?: number;
    PagesIds?: number[];
    ScopesIds?: number[];
    Title?: string;
    Titles?: string[];
    Type?: Reference;
    TypeIds?: number[];
    TypeNames?: string[];
}

interface HistoryBase extends Dto<History>
{
    /**
    * App
    */
    // @ApiMember(Description="App", Name="App")
    App?: Reference;

    /**
    * Primary Key of App
    */
    // @ApiMember(Description="Primary Key of App", Name="AppId")
    AppId?: number;

    /**
    * DocumentSet
    */
    // @ApiMember(Description="DocumentSet", Name="DocumentSet")
    DocumentSet?: Reference;

    /**
    * Primary Key of DocumentSet
    */
    // @ApiMember(Description="Primary Key of DocumentSet", Name="DocumentSetId")
    DocumentSetId?: number;

    /**
    * Impersonation
    */
    // @ApiMember(Description="Impersonation", Name="Impersonation")
    Impersonation?: Reference;

    /**
    * Primary Key of Impersonation
    */
    // @ApiMember(Description="Primary Key of Impersonation", Name="ImpersonationId")
    ImpersonationId?: number;

    /**
    * Page
    */
    // @ApiMember(Description="Page", Name="Page")
    Page?: Reference;

    /**
    * Primary Key of Page
    */
    // @ApiMember(Description="Primary Key of Page", Name="PageId")
    PageId?: number;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="URL")
    URL?: string;

    /**
    * User
    */
    // @ApiMember(Description="User", IsRequired=true, Name="User")
    User?: Reference;

    /**
    * Primary Key of User
    */
    // @ApiMember(Description="Primary Key of User", Name="UserId")
    UserId?: number;

    /**
    * UserSession
    */
    // @ApiMember(Description="UserSession", Name="UserSession")
    UserSession?: Reference;

    /**
    * Primary Key of UserSession
    */
    // @ApiMember(Description="Primary Key of UserSession", Name="UserSessionId")
    UserSessionId?: number;

    /**
    * Workflow
    */
    // @ApiMember(Description="Workflow", Name="Workflow")
    Workflow?: Reference;

    /**
    * Primary Key of Workflow
    */
    // @ApiMember(Description="Primary Key of Workflow", Name="WorkflowId")
    WorkflowId?: number;
}

// @Route("/history", "POST")
// @Route("/history/{Id}", "GET")
interface History extends HistoryBase, IReturn<History>, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

interface HistorySearchBase extends Search_1<History>
{
    Id?: number;
    IdAfter?: number;
    IdBefore?: number;
    App?: Reference;
    AppIds?: number[];
    DocumentSet?: Reference;
    DocumentSetIds?: number[];
    Impersonation?: Reference;
    ImpersonationIds?: number[];
    Page?: Reference;
    PageIds?: number[];
    URL?: string;
    URLs?: string[];
    User?: Reference;
    UserIds?: number[];
    UserSession?: Reference;
    UserSessionIds?: number[];
    Workflow?: Reference;
    WorkflowIds?: number[];
}

interface TimePointBase extends Dto<TimePoint>
{
    /**
    * bool
    */
    // @ApiMember(Description="bool", Name="IsAbsolute")
    IsAbsolute?: boolean;

    /**
    * MeanBase
    */
    // @ApiMember(Description="MeanBase", Name="MeanValue")
    MeanValue?: TypeMeanBase;

    /**
    * UnitValue
    */
    // @ApiMember(Description="UnitValue", Name="SingleValue")
    SingleValue?: TypeUnitValue;

    /**
    * UnitRange
    */
    // @ApiMember(Description="UnitRange", Name="TotalValue")
    TotalValue?: TypeUnitRange;

    /**
    * LookupTable
    */
    // @ApiMember(Description="LookupTable", Name="Type")
    Type?: Reference;

    /**
    * Primary Key of LookupTable
    */
    // @ApiMember(Description="Primary Key of LookupTable", Name="TypeId")
    TypeId?: number;
}

// @Route("/timepoint/{Id}", "GET")
interface TimePoint extends TimePointBase, IReturn<TimePoint>, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

interface IntervalBase extends Dto<Interval>
{
    /**
    * DateTime
    */
    // @ApiMember(Description="DateTime", Name="CalendarDateEnd")
    CalendarDateEnd?: DateTimeDto;

    /**
    * Primary Key of DateTime
    */
    // @ApiMember(Description="Primary Key of DateTime", Name="CalendarDateEndId")
    CalendarDateEndId?: number;

    /**
    * DateTime
    */
    // @ApiMember(Description="DateTime", Name="CalendarDateStart")
    CalendarDateStart?: DateTimeDto;

    /**
    * Primary Key of DateTime
    */
    // @ApiMember(Description="Primary Key of DateTime", Name="CalendarDateStartId")
    CalendarDateStartId?: number;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="CalendarType")
    CalendarType?: string;

    /**
    * TimePoint
    */
    // @ApiMember(Description="TimePoint", Name="FollowUp")
    FollowUp?: TimePoint;

    /**
    * Primary Key of TimePoint
    */
    // @ApiMember(Description="Primary Key of TimePoint", Name="FollowUpId")
    FollowUpId?: number;

    /**
    * TimePoint
    */
    // @ApiMember(Description="TimePoint", Name="TimeOfDay")
    TimeOfDay?: TimePoint;

    /**
    * Primary Key of TimePoint
    */
    // @ApiMember(Description="Primary Key of TimePoint", Name="TimeOfDayId")
    TimeOfDayId?: number;
}

// @Route("/interval/{Id}", "GET, PATCH, PUT, DELETE")
// @Route("/interval", "POST")
interface Interval extends IntervalBase, IReturn<Interval>, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

interface IntervalSearchBase extends Search_1<Interval>
{
    Id?: number;
    IdAfter?: number;
    IdBefore?: number;
    CalendarDateEnd?: Reference;
    CalendarDateEndIds?: number[];
    CalendarDateStart?: Reference;
    CalendarDateStartIds?: number[];
    CalendarType?: string;
    CalendarTypes?: string[];
    FollowUp?: Reference;
    FollowUpIds?: number[];
    TimeOfDay?: Reference;
    TimeOfDayIds?: number[];
}

interface JunctionBase extends Dto<Junction>
{
    /**
    * Junction
    */
    // @ApiMember(Description="Junction", Name="Children")
    Children?: Reference[];

    ChildrenIds?: number[];
    ChildrenCount?: number;
    /**
    * string
    */
    // @ApiMember(Description="string", Name="Data")
    Data?: string;

    /**
    * int?
    */
    // @ApiMember(Description="int?", Name="OwnerId")
    OwnerId?: number;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="OwnerType")
    OwnerType?: string;

    /**
    * Junction
    */
    // @ApiMember(Description="Junction", Name="Parent")
    Parent?: Reference;

    /**
    * Primary Key of Junction
    */
    // @ApiMember(Description="Primary Key of Junction", Name="ParentId")
    ParentId?: number;

    /**
    * int?
    */
    // @ApiMember(Description="int?", Name="TargetId")
    TargetId?: number;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="TargetType")
    TargetType?: string;

    /**
    * LookupTable
    */
    // @ApiMember(Description="LookupTable", IsRequired=true, Name="Type")
    Type?: Reference;

    /**
    * Primary Key of LookupTable
    */
    // @ApiMember(Description="Primary Key of LookupTable", Name="TypeId")
    TypeId?: number;

    /**
    * User
    */
    // @ApiMember(Description="User", IsRequired=true, Name="User")
    User?: Reference;

    /**
    * Primary Key of User
    */
    // @ApiMember(Description="Primary Key of User", Name="UserId")
    UserId?: number;
}

// @Route("/junction/{Id}", "GET, PATCH, PUT, DELETE")
// @Route("/junction", "POST")
interface Junction extends JunctionBase, IReturn<Junction>, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

interface JunctionSearchBase extends Search_1<Junction>
{
    Id?: number;
    IdAfter?: number;
    IdBefore?: number;
    ChildrenIds?: number[];
    Data?: string;
    Datas?: string[];
    OwnerId?: number;
    OwnerType?: string;
    OwnerTypes?: string[];
    Parent?: Reference;
    ParentIds?: number[];
    TargetId?: number;
    TargetType?: string;
    TargetTypes?: string[];
    Type?: Reference;
    TypeIds?: number[];
    TypeNames?: string[];
    User?: Reference;
    UserIds?: number[];
}

interface Location
{
    GeonameId?: number;
    Capital?: string;
    Languages?: Language[];
    CountryFlag?: string;
    CountryFlagEmoji?: string;
    CountryFlagEmojiUnicode?: string;
    CallingCode?: number;
    IsEu?: boolean;
    Lat?: number;
    Lng?: number;
}

interface TimeZone
{
    Id?: string;
    CurrentTime?: string;
    GmtOffset?: number;
    Code?: string;
    IsDaylightSaving?: boolean;
    DstOffset?: number;
    RawOffset?: number;
    Status?: string;
    TimeZoneId?: string;
    TimeZoneName?: string;
}

interface Currency
{
    Code?: string;
    Name?: string;
    Plural?: string;
    Symbol?: string;
    SymbolNative?: string;
}

interface Connection
{
    Asn?: number;
    Isp?: string;
}

interface AddressComponent
{
    LongName?: string;
    ShortName?: string;
    Types?: string[];
}

interface Bounds
{
    Northeast?: Location;
    Southwest?: Location;
}

interface Geometry
{
    Location?: Location;
    LocationType?: string;
    Viewport?: Bounds;
    Bounds?: Bounds;
}

interface Result
{
    AddressComponents?: AddressComponent[];
    FormattedAddress?: string;
    Geometry?: Geometry;
    PlaceId?: string;
    Types?: string[];
}

interface LocationResults
{
    Results?: Result[];
    Status?: string;
}

interface IpData
{
    Ip?: string;
    Type?: string;
    ContinentCode?: string;
    ContinentName?: string;
    CountryCode?: string;
    CountryName?: string;
    RegionCode?: string;
    RegionName?: string;
    City?: string;
    Zip?: string;
    Latitude?: number;
    Longitude?: number;
    Location?: Location;
    TimeZone?: TimeZone;
    Currency?: Currency;
    Connection?: Connection;
    LocationResults?: LocationResults;
}

interface LocaleLookupBase extends Dto<LocaleLookup>
{
    /**
    * IpData
    */
    // @ApiMember(Description="IpData", Name="Data")
    Data?: IpData;

    /**
    * string
    */
    // @ApiMember(Description="string", IsRequired=true, Name="IpAddress")
    IpAddress?: string;

    /**
    * Locale
    */
    // @ApiMember(Description="Locale", IsRequired=true, Name="Locale")
    Locale?: Reference;

    /**
    * Primary Key of Locale
    */
    // @ApiMember(Description="Primary Key of Locale", Name="LocaleId")
    LocaleId?: number;
}

// @Route("/localelookup/{Id}", "GET")
// @Route("/localelookup", "POST")
interface LocaleLookup extends LocaleLookupBase, IReturn<LocaleLookup>, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

interface LocaleLookupSearchBase extends Search_1<LocaleLookup>
{
    Id?: number;
    IdAfter?: number;
    IdBefore?: number;
    Data?: string;
    Datas?: string[];
    IpAddress?: string;
    IpAddresss?: string[];
    Locale?: Reference;
    LocaleIds?: number[];
}

interface LocaleBase extends Dto<Locale>
{
    /**
    * string
    */
    // @ApiMember(Description="string", IsRequired=true, Name="Country")
    Country?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", IsRequired=true, Name="Language")
    Language?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", IsRequired=true, Name="TimeZone")
    TimeZone?: string;
}

// @Route("/locale", "POST")
// @Route("/locale/{Id}", "GET")
interface Locale extends LocaleBase, IReturn<Locale>, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

interface LocaleSearchBase extends Search_1<Locale>
{
    Id?: number;
    IdAfter?: number;
    IdBefore?: number;
    Country?: string;
    Countrys?: string[];
    Language?: string;
    Languages?: string[];
    TimeZone?: string;
    TimeZones?: string[];
}

interface LookupCategoryBase extends Dto<LookupCategory>
{
    /**
    * string
    */
    // @ApiMember(Description="string", IsRequired=true, Name="Category")
    Category?: string;

    /**
    * LookupTableEnum
    */
    // @ApiMember(Description="LookupTableEnum", IsRequired=true, Name="Enum")
    Enum?: Reference;

    /**
    * Primary Key of LookupTableEnum
    */
    // @ApiMember(Description="Primary Key of LookupTableEnum", Name="EnumId")
    EnumId?: number;

    /**
    * LookupTable
    */
    // @ApiMember(Description="LookupTable", Name="Lookups")
    Lookups?: Reference[];

    LookupsIds?: number[];
    LookupsCount?: number;
    /**
    * LookupCategory
    */
    // @ApiMember(Description="LookupCategory", Name="ParentCategory")
    ParentCategory?: Reference;

    /**
    * Primary Key of LookupCategory
    */
    // @ApiMember(Description="Primary Key of LookupCategory", Name="ParentCategoryId")
    ParentCategoryId?: number;
}

// @Route("/lookupcategory/{Id}", "GET, PATCH, PUT, DELETE")
// @Route("/lookupcategory", "POST")
interface LookupCategory extends LookupCategoryBase, IReturn<LookupCategory>, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

interface LookupCategorySearchBase extends Search_1<LookupCategory>
{
    Id?: number;
    IdAfter?: number;
    IdBefore?: number;
    Category?: string;
    Categorys?: string[];
    Enum?: Reference;
    EnumIds?: number[];
    LookupsIds?: number[];
    ParentCategory?: Reference;
    ParentCategoryIds?: number[];
}

interface LookupTableEnumBase extends Dto<LookupTableEnum>
{
    /**
    * bool
    */
    // @ApiMember(Description="bool", Name="IsBindable")
    IsBindable?: boolean;

    /**
    * bool
    */
    // @ApiMember(Description="bool", Name="IsGlobal")
    IsGlobal?: boolean;

    /**
    * string
    */
    // @ApiMember(Description="string", IsRequired=true, Name="Name")
    Name?: string;
}

// @Route("/lookuptableenum/{Id}", "GET, PATCH, PUT, DELETE")
// @Route("/lookuptableenum", "POST")
interface LookupTableEnum extends LookupTableEnumBase, IReturn<LookupTableEnum>, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

interface LookupTableEnumSearchBase extends Search_1<LookupTableEnum>
{
    Id?: number;
    IdAfter?: number;
    IdBefore?: number;
    IsBindable?: boolean[];
    IsGlobal?: boolean[];
    Name?: string;
    Names?: string[];
}

interface QueueChannelSearchBase extends Search_1<QueueChannel>
{
    Id?: number;
    IdAfter?: number;
    IdBefore?: number;
    AutoDelete?: boolean[];
    BackgroundTask?: Reference;
    BackgroundTaskIds?: number[];
    Description?: string;
    Descriptions?: string[];
    Durable?: boolean[];
    Enabled?: boolean[];
    Exclusive?: boolean[];
    Name?: string;
    Names?: string[];
}

interface ReleaseStatusBase extends Dto<ReleaseStatus>
{
    /**
    * string
    */
    // @ApiMember(Description="string", IsRequired=true, Name="Branch")
    Branch?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", IsRequired=true, Name="Release")
    Release?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", IsRequired=true, Name="Server")
    Server?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", IsRequired=true, Name="URL")
    URL?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", IsRequired=true, Name="Version")
    Version?: string;
}

// @Route("/releasestatus", "POST")
// @Route("/releasestatus/{Id}", "GET, PATCH, PUT, DELETE")
interface ReleaseStatus extends ReleaseStatusBase, IReturn<ReleaseStatus>, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

interface ReleaseStatusSearchBase extends Search_1<ReleaseStatus>
{
    Id?: number;
    IdAfter?: number;
    IdBefore?: number;
    Branch?: string;
    Branchs?: string[];
    Release?: string;
    Releases?: string[];
    Server?: string;
    Servers?: string[];
    URL?: string;
    URLs?: string[];
    Version?: string;
    Versions?: string[];
}

interface TagBase extends Dto<Tag>
{
    /**
    * string
    */
    // @ApiMember(Description="string", IsRequired=true, Name="Name")
    Name?: string;

    /**
    * Workflow
    */
    // @ApiMember(Description="Workflow", Name="Workflows")
    Workflows?: Reference[];

    WorkflowsIds?: number[];
    WorkflowsCount?: number;
}

// @Route("/tag", "POST")
// @Route("/tag/{Id}", "GET, DELETE")
interface Tag extends TagBase, IReturn<Tag>, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

interface TagSearchBase extends Search_1<Tag>
{
    Id?: number;
    IdAfter?: number;
    IdBefore?: number;
    Name?: string;
    Names?: string[];
    WorkflowsIds?: number[];
}

interface TermCategorySearchBase extends Search_1<TermCategory>
{
    Id?: number;
    IdAfter?: number;
    IdBefore?: number;
    ParentCategory?: Reference;
    ParentCategoryIds?: number[];
    Scope?: Reference;
    ScopeIds?: number[];
    TermsIds?: number[];
    Name?: Reference;
    NameIds?: number[];
    NameNames?: string[];
}

interface TimeCardBase extends Dto<TimeCard>
{
    /**
    * string
    */
    // @ApiMember(Description="string", Name="Description")
    Description?: string;

    /**
    * Document
    */
    // @ApiMember(Description="Document", Name="Document")
    Document?: Reference;

    /**
    * Primary Key of Document
    */
    // @ApiMember(Description="Primary Key of Document", Name="DocumentId")
    DocumentId?: number;

    /**
    * DateTime?
    */
    // @ApiMember(Description="DateTime?", IsRequired=true, Name="End")
    End?: string;

    /**
    * Project
    */
    // @ApiMember(Description="Project", Name="Project")
    Project?: Reference;

    /**
    * Primary Key of Project
    */
    // @ApiMember(Description="Primary Key of Project", Name="ProjectId")
    ProjectId?: number;

    /**
    * int?
    */
    // @ApiMember(Description="int?", Name="ReferenceId")
    ReferenceId?: number;

    /**
    * DateTime?
    */
    // @ApiMember(Description="DateTime?", IsRequired=true, Name="Start")
    Start?: string;

    /**
    * LookupTable
    */
    // @ApiMember(Description="LookupTable", Name="Status")
    Status?: Reference;

    /**
    * Primary Key of LookupTable
    */
    // @ApiMember(Description="Primary Key of LookupTable", Name="StatusId")
    StatusId?: number;

    /**
    * User
    */
    // @ApiMember(Description="User", IsRequired=true, Name="User")
    User?: Reference;

    /**
    * Primary Key of User
    */
    // @ApiMember(Description="Primary Key of User", Name="UserId")
    UserId?: number;

    /**
    * LookupTable
    */
    // @ApiMember(Description="LookupTable", Name="WorkType")
    WorkType?: Reference;

    /**
    * Primary Key of LookupTable
    */
    // @ApiMember(Description="Primary Key of LookupTable", Name="WorkTypeId")
    WorkTypeId?: number;
}

// @Route("/timecard/{Id}", "GET, PATCH, PUT, DELETE")
// @Route("/timecard", "POST")
interface TimeCard extends TimeCardBase, IReturn<TimeCard>, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

interface TimeCardSearchBase extends Search_1<TimeCard>
{
    Id?: number;
    IdAfter?: number;
    IdBefore?: number;
    Description?: string;
    Descriptions?: string[];
    Document?: Reference;
    DocumentIds?: number[];
    End?: string;
    EndAfter?: string;
    EndBefore?: string;
    Project?: Reference;
    ProjectIds?: number[];
    ReferenceId?: number;
    Start?: string;
    StartAfter?: string;
    StartBefore?: string;
    Status?: Reference;
    StatusIds?: number[];
    StatusNames?: string[];
    User?: Reference;
    UserIds?: number[];
    WorkType?: Reference;
    WorkTypeIds?: number[];
    WorkTypeNames?: string[];
}

interface TimePointSearchBase extends Search_1<TimePoint>
{
    Id?: number;
    IdAfter?: number;
    IdBefore?: number;
    IsAbsolute?: boolean[];
    MeanValue?: TypeMeanBase;
    SingleValue?: TypeUnitValue;
    TotalValue?: TypeUnitRange;
    Type?: Reference;
    TypeIds?: number[];
    TypeNames?: string[];
}

interface UnitConversionRulesBase extends Dto<UnitConversionRules>
{
    /**
    * UnitOfMeasure
    */
    // @ApiMember(Description="UnitOfMeasure", IsRequired=true, Name="DestinationUnit")
    DestinationUnit?: Reference;

    /**
    * Primary Key of UnitOfMeasure
    */
    // @ApiMember(Description="Primary Key of UnitOfMeasure", Name="DestinationUnitId")
    DestinationUnitId?: number;

    /**
    * bool
    */
    // @ApiMember(Description="bool", Name="IsDefault")
    IsDefault?: boolean;

    /**
    * bool
    */
    // @ApiMember(Description="bool", Name="IsDestinationSi")
    IsDestinationSi?: boolean;

    /**
    * TermMaster
    */
    // @ApiMember(Description="TermMaster", Name="ModifierTerm")
    ModifierTerm?: Reference;

    /**
    * Primary Key of TermMaster
    */
    // @ApiMember(Description="Primary Key of TermMaster", Name="ModifierTermId")
    ModifierTermId?: number;

    /**
    * decimal
    */
    // @ApiMember(Description="decimal", IsRequired=true, Name="Multiplier")
    Multiplier?: number;

    /**
    * LookupTable
    */
    // @ApiMember(Description="LookupTable", Name="Parent")
    Parent?: Reference;

    /**
    * Primary Key of LookupTable
    */
    // @ApiMember(Description="Primary Key of LookupTable", Name="ParentId")
    ParentId?: number;

    /**
    * TermMaster
    */
    // @ApiMember(Description="TermMaster", Name="RootTerm")
    RootTerm?: Reference;

    /**
    * Primary Key of TermMaster
    */
    // @ApiMember(Description="Primary Key of TermMaster", Name="RootTermId")
    RootTermId?: number;

    /**
    * UnitOfMeasure
    */
    // @ApiMember(Description="UnitOfMeasure", IsRequired=true, Name="SourceUnit")
    SourceUnit?: Reference;

    /**
    * Primary Key of UnitOfMeasure
    */
    // @ApiMember(Description="Primary Key of UnitOfMeasure", Name="SourceUnitId")
    SourceUnitId?: number;
}

// @Route("/unitconversionrules", "POST")
// @Route("/unitconversionrules/{Id}", "GET, PATCH, PUT, DELETE")
interface UnitConversionRules extends UnitConversionRulesBase, IReturn<UnitConversionRules>, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

interface UnitConversionRulesSearchBase extends Search_1<UnitConversionRules>
{
    Id?: number;
    IdAfter?: number;
    IdBefore?: number;
    DestinationUnit?: Reference;
    DestinationUnitIds?: number[];
    IsDefault?: boolean[];
    IsDestinationSi?: boolean[];
    ModifierTerm?: Reference;
    ModifierTermIds?: number[];
    Multiplier?: number;
    Parent?: Reference;
    ParentIds?: number[];
    ParentNames?: string[];
    RootTerm?: Reference;
    RootTermIds?: number[];
    SourceUnit?: Reference;
    SourceUnitIds?: number[];
}

interface UnitOfMeasureSearchBase extends Search_1<UnitOfMeasure>
{
    Id?: number;
    IdAfter?: number;
    IdBefore?: number;
    AliasOf?: Reference;
    AliasOfIds?: number[];
    IsSI?: boolean[];
    Name?: Reference;
    NameIds?: number[];
    NameNames?: string[];
    Type?: Reference;
    TypeIds?: number[];
    TypeNames?: string[];
    Unit?: Reference;
    UnitIds?: number[];
    UnitNames?: string[];
}

interface UpdateBase extends Dto<Update>
{
    /**
    * string
    */
    // @ApiMember(Description="string", Name="Body")
    Body?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="DeliveryStatus")
    DeliveryStatus?: string;

    /**
    * int?
    */
    // @ApiMember(Description="int?", Name="EmailAttempts")
    EmailAttempts?: number;

    /**
    * DateTime?
    */
    // @ApiMember(Description="DateTime?", Name="EmailSent")
    EmailSent?: string;

    /**
    * Event
    */
    // @ApiMember(Description="Event", Name="Events")
    Events?: Reference[];

    EventsIds?: number[];
    EventsCount?: number;
    /**
    * string
    */
    // @ApiMember(Description="string", Name="Link")
    Link?: string;

    /**
    * int?
    */
    // @ApiMember(Description="int?", Name="Priority")
    Priority?: number;

    /**
    * DateTime?
    */
    // @ApiMember(Description="DateTime?", Name="Read")
    Read?: string;

    /**
    * DateTime?
    */
    // @ApiMember(Description="DateTime?", Name="SlackSent")
    SlackSent?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="Subject")
    Subject?: string;

    /**
    * Team
    */
    // @ApiMember(Description="Team", Name="Team")
    Team?: Reference;

    /**
    * Primary Key of Team
    */
    // @ApiMember(Description="Primary Key of Team", Name="TeamId")
    TeamId?: number;

    /**
    * User
    */
    // @ApiMember(Description="User", Name="User")
    User?: Reference;

    /**
    * Primary Key of User
    */
    // @ApiMember(Description="Primary Key of User", Name="UserId")
    UserId?: number;
}

// @Route("/update/{Id}", "GET")
// @Route("/update", "POST")
interface Update extends UpdateBase, IReturn<Update>, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

interface UpdateSearchBase extends Search_1<Update>
{
    Id?: number;
    IdAfter?: number;
    IdBefore?: number;
    Body?: string;
    Bodys?: string[];
    DeliveryStatus?: string;
    DeliveryStatuss?: string[];
    EmailAttempts?: number;
    EmailSent?: string;
    EmailSentAfter?: string;
    EmailSentBefore?: string;
    EventsIds?: number[];
    Link?: string;
    Links?: string[];
    Priority?: number;
    Read?: string;
    ReadAfter?: string;
    ReadBefore?: string;
    SlackSent?: string;
    SlackSentAfter?: string;
    SlackSentBefore?: string;
    Subject?: string;
    Subjects?: string[];
    Team?: Reference;
    TeamIds?: number[];
    User?: Reference;
    UserIds?: number[];
}

interface UserRequestBase extends Dto<UserRequest>
{
    /**
    * App
    */
    // @ApiMember(Description="App", Name="App")
    App?: Reference;

    /**
    * Primary Key of App
    */
    // @ApiMember(Description="Primary Key of App", Name="AppId")
    AppId?: number;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="Method")
    Method?: string;

    /**
    * Page
    */
    // @ApiMember(Description="Page", Name="Page")
    Page?: Reference;

    /**
    * Primary Key of Page
    */
    // @ApiMember(Description="Primary Key of Page", Name="PageId")
    PageId?: number;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="Path")
    Path?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="URL")
    URL?: string;

    /**
    * UserSession
    */
    // @ApiMember(Description="UserSession", IsRequired=true, Name="UserSession")
    UserSession?: Reference;

    /**
    * Primary Key of UserSession
    */
    // @ApiMember(Description="Primary Key of UserSession", Name="UserSessionId")
    UserSessionId?: number;
}

// @Route("/userrequest/{Id}", "GET")
interface UserRequest extends UserRequestBase, IReturn<UserRequest>, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

interface UserRequestSearchBase extends Search_1<UserRequest>
{
    Id?: number;
    IdAfter?: number;
    IdBefore?: number;
    App?: Reference;
    AppIds?: number[];
    Method?: string;
    Methods?: string[];
    Page?: Reference;
    PageIds?: number[];
    Path?: string;
    Paths?: string[];
    URL?: string;
    URLs?: string[];
    UserSession?: Reference;
    UserSessionIds?: number[];
}

interface UserSessionBase extends Dto<UserSession>
{
    /**
    * string
    */
    // @ApiMember(Description="string", Name="ClientId")
    ClientId?: string;

    /**
    * int?
    */
    // @ApiMember(Description="int?", Name="Hits")
    Hits?: number;

    /**
    * Impersonation
    */
    // @ApiMember(Description="Impersonation", Name="Impersonations")
    Impersonations?: Reference[];

    ImpersonationsIds?: number[];
    ImpersonationsCount?: number;
    /**
    * string
    */
    // @ApiMember(Description="string", Name="IpAddress")
    IpAddress?: string;

    /**
    * UserRequest
    */
    // @ApiMember(Description="UserRequest", Name="Requests")
    Requests?: Reference[];

    RequestsIds?: number[];
    RequestsCount?: number;
    /**
    * string
    */
    // @ApiMember(Description="string", Name="SessionId")
    SessionId?: string;

    /**
    * string
    */
    // @ApiMember(Description="string", Name="TemporarySessionId")
    TemporarySessionId?: string;

    /**
    * User
    */
    // @ApiMember(Description="User", IsRequired=true, Name="User")
    User?: Reference;

    /**
    * Primary Key of User
    */
    // @ApiMember(Description="Primary Key of User", Name="UserId")
    UserId?: number;

    /**
    * History
    */
    // @ApiMember(Description="History", Name="UserHistory")
    UserHistory?: Reference[];

    UserHistoryIds?: number[];
    UserHistoryCount?: number;
}

// @Route("/usersession/{Id}", "GET")
interface UserSession extends UserSessionBase, IReturn<UserSession>, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

interface UserSessionSearchBase extends Search_1<UserSession>
{
    Id?: number;
    IdAfter?: number;
    IdBefore?: number;
    ClientId?: string;
    ClientIds?: string[];
    Hits?: number;
    ImpersonationsIds?: number[];
    IpAddress?: string;
    IpAddresss?: string[];
    RequestsIds?: number[];
    SessionId?: string;
    SessionIds?: string[];
    TemporarySessionId?: string;
    TemporarySessionIds?: string[];
    User?: Reference;
    UserIds?: number[];
    UserHistoryIds?: number[];
}

interface UserTypeBase extends Dto<UserType>
{
    /**
    * LookupTable
    */
    // @ApiMember(Description="LookupTable", Name="PayrollStatus")
    PayrollStatus?: Reference;

    /**
    * Primary Key of LookupTable
    */
    // @ApiMember(Description="Primary Key of LookupTable", Name="PayrollStatusId")
    PayrollStatusId?: number;

    /**
    * LookupTable
    */
    // @ApiMember(Description="LookupTable", Name="PayrollType")
    PayrollType?: Reference;

    /**
    * Primary Key of LookupTable
    */
    // @ApiMember(Description="Primary Key of LookupTable", Name="PayrollTypeId")
    PayrollTypeId?: number;

    /**
    * LookupTable
    */
    // @ApiMember(Description="LookupTable", IsRequired=true, Name="Type")
    Type?: Reference;

    /**
    * Primary Key of LookupTable
    */
    // @ApiMember(Description="Primary Key of LookupTable", Name="TypeId")
    TypeId?: number;

    /**
    * User
    */
    // @ApiMember(Description="User", Name="Users")
    Users?: Reference[];

    UsersIds?: number[];
    UsersCount?: number;
}

// @Route("/usertype/{Id}", "GET, PATCH, PUT, DELETE")
// @Route("/usertype", "POST")
interface UserType extends UserTypeBase, IReturn<UserType>, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

interface UserTypeSearchBase extends Search_1<UserType>
{
    Id?: number;
    IdAfter?: number;
    IdBefore?: number;
    PayrollStatus?: Reference;
    PayrollStatusIds?: number[];
    PayrollStatusNames?: string[];
    PayrollType?: Reference;
    PayrollTypeIds?: number[];
    PayrollTypeNames?: string[];
    Type?: Reference;
    TypeIds?: number[];
    TypeNames?: string[];
    UsersIds?: number[];
}

interface ValueTypeBase extends Dto<ValueType>
{
    /**
    * LookupTable
    */
    // @ApiMember(Description="LookupTable", Name="FieldType")
    FieldType?: Reference;

    /**
    * Primary Key of LookupTable
    */
    // @ApiMember(Description="Primary Key of LookupTable", Name="FieldTypeId")
    FieldTypeId?: number;

    /**
    * LookupTable
    */
    // @ApiMember(Description="LookupTable", IsRequired=true, Name="Name")
    Name?: Reference;

    /**
    * Primary Key of LookupTable
    */
    // @ApiMember(Description="Primary Key of LookupTable", Name="NameId")
    NameId?: number;
}

// @Route("/valuetype/{Id}", "GET")
interface ValueType extends ValueTypeBase, IReturn<ValueType>, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

interface ValueTypeSearchBase extends Search_1<ValueType>
{
    Id?: number;
    IdAfter?: number;
    IdBefore?: number;
    FieldType?: Reference;
    FieldTypeIds?: number[];
    FieldTypeNames?: string[];
    Name?: Reference;
    NameIds?: number[];
    NameNames?: string[];
}

interface VariableInstanceBase extends Dto<VariableInstance>
{
    /**
    * string
    */
    // @ApiMember(Description="string", Name="Data")
    Data?: string;

    /**
    * Document
    */
    // @ApiMember(Description="Document", IsRequired=true, Name="Document")
    Document?: Reference;

    /**
    * Primary Key of Document
    */
    // @ApiMember(Description="Primary Key of Document", Name="DocumentId")
    DocumentId?: number;

    /**
    * VariableRule
    */
    // @ApiMember(Description="VariableRule", IsRequired=true, Name="Rule")
    Rule?: Reference;

    /**
    * Primary Key of VariableRule
    */
    // @ApiMember(Description="Primary Key of VariableRule", Name="RuleId")
    RuleId?: number;

    /**
    * Workflow
    */
    // @ApiMember(Description="Workflow", Name="Workflows")
    Workflows?: Reference[];

    WorkflowsIds?: number[];
    WorkflowsCount?: number;
}

// @Route("/variableinstance", "POST")
// @Route("/variableinstance/{Id}", "GET, PATCH, PUT, DELETE")
interface VariableInstance extends VariableInstanceBase, IReturn<VariableInstance>, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

interface VariableInstanceSearchBase extends Search_1<VariableInstance>
{
    Id?: number;
    IdAfter?: number;
    IdBefore?: number;
    Data?: string;
    Datas?: string[];
    Document?: Reference;
    DocumentIds?: number[];
    Rule?: Reference;
    RuleIds?: number[];
    WorkflowsIds?: number[];
}

interface VariableRuleBase extends Dto<VariableRule>
{
    /**
    * VariableRule
    */
    // @ApiMember(Description="VariableRule", Name="Children")
    Children?: Reference[];

    ChildrenIds?: number[];
    ChildrenCount?: number;
    /**
    * string
    */
    // @ApiMember(Description="string", Name="Definition")
    Definition?: string;

    /**
    * VariableInstance
    */
    // @ApiMember(Description="VariableInstance", Name="Instances")
    Instances?: Reference[];

    InstancesIds?: number[];
    InstancesCount?: number;
    /**
    * string
    */
    // @ApiMember(Description="string", IsRequired=true, Name="Name")
    Name?: string;

    /**
    * VariableRule
    */
    // @ApiMember(Description="VariableRule", Name="Owner")
    Owner?: Reference;

    /**
    * Primary Key of VariableRule
    */
    // @ApiMember(Description="Primary Key of VariableRule", Name="OwnerId")
    OwnerId?: number;

    /**
    * LookupTable
    */
    // @ApiMember(Description="LookupTable", IsRequired=true, Name="Rule")
    Rule?: Reference;

    /**
    * Primary Key of LookupTable
    */
    // @ApiMember(Description="Primary Key of LookupTable", Name="RuleId")
    RuleId?: number;

    /**
    * Scope
    */
    // @ApiMember(Description="Scope", Name="Scopes")
    Scopes?: Reference[];

    ScopesIds?: number[];
    ScopesCount?: number;
    /**
    * LookupTable
    */
    // @ApiMember(Description="LookupTable", IsRequired=true, Name="Type")
    Type?: Reference;

    /**
    * Primary Key of LookupTable
    */
    // @ApiMember(Description="Primary Key of LookupTable", Name="TypeId")
    TypeId?: number;
}

// @Route("/variablerule/{Id}", "GET, PATCH, PUT, DELETE")
// @Route("/variablerule", "POST")
interface VariableRule extends VariableRuleBase, IReturn<VariableRule>, IDto
{
    /**
    * The list of fields to include in the response
    */
    // @ApiMember(AllowMultiple=true, Description="The list of fields to include in the response", IsRequired=true, Name="Select")
    Select?: string[];

    /**
    * Deprecated. Use Select instead.
    */
    // @ApiMember(AllowMultiple=true, Description="Deprecated. Use Select instead.", Name="VisibleFields")
    VisibleFields?: string[];
}

interface VariableRuleSearchBase extends Search_1<VariableRule>
{
    Id?: number;
    IdAfter?: number;
    IdBefore?: number;
    ChildrenIds?: number[];
    Definition?: string;
    Definitions?: string[];
    InstancesIds?: number[];
    Name?: string;
    Names?: string[];
    Owner?: Reference;
    OwnerIds?: number[];
    Rule?: Reference;
    RuleIds?: number[];
    RuleNames?: string[];
    ScopesIds?: number[];
    Type?: Reference;
    TypeIds?: number[];
    TypeNames?: string[];
}

interface UserSelect
{
    UserName?: string;
    Select?: string[];
}

interface SearchSummary
{
    Description?: string;
    Count?: number;
    Value?: string;
    DataSource?: string;
}

interface SearchRecord
{
    Id?: string;
    Description?: string;
}

interface PhraseSynonym
{
    TermOrder?: number;
    SynonymId?: number;
    Synonym?: string;
    TermMasterId?: number;
    TermMaster?: string;
    IsDisplaySynonym?: boolean;
    IsRoot?: boolean;
}

interface PhraseShort
{
    LookupPhraseId?: number;
    Conjunction?: string;
    PhraseOrder?: number;
    Synonyms?: PhraseSynonym[];
}

interface Concept
{
    LookupTableId?: number;
    IsBound?: boolean;
    UnboundName?: string;
    AttributeName?: string;
    Interval?: string;
    BoundName?: string;
    Class?: string;
    OutcomeRank?: string;
    Category?: string;
    Qualifier?: string;
    Phrases?: PhraseShort[];
}

interface FederatePlatform
{
    Name?: string;
    Url?: string;
    Environments?: FederatePlatform[];
}

interface DocServiceBase
{
}

interface Portal
{
    Status?: PortalStatus[];
    Logs?: PortalLog[];
}

interface Language
{
    Code?: string;
    Name?: string;
    Native?: string;
}

// @Route("/extractimport/errorreport", "POST")
interface ExtractImportErrorReport extends IReturn<ExtractImportErrorReport>
{
    ExtractJson?: string;
    HighPriorityErrors?: ImportError[];
    LowPriorityErrors?: ImportError[];
    DisplayHighPriorityErrors?: string;
    DisplayLowPriorityErrors?: string;
}

// @Route("/extractimport/protocol", "POST")
interface ExtractProtocolImport extends IReturn<ExtractProtocolImport>
{
    ExtractProtocolJson?: string;
    DocumentSetId?: number;
    Errors?: string[];
}

// @DataContract
interface QueryResponse<T>
{
    // @DataMember(Order=1)
    Offset?: number;

    // @DataMember(Order=2)
    Total?: number;

    // @DataMember(Order=3)
    Results?: T[];

    // @DataMember(Order=4)
    Meta?: { [index:string]: string; };

    // @DataMember(Order=5)
    ResponseStatus?: ResponseStatus;
}

// @Route("/document/exists", "GET")
interface DocumentExists extends IReturn<DocumentExists>
{
    ReferenceStudy?: number;
    DocumentId?: number;
    SourceReferenceId?: string;
    ImportType?: Reference;
    FoundDocumentId?: number;
}

interface DocumentSetLibUpdateInfo
{
    DocumentSetId?: number;
    TotalReferences?: number;
    TotalApprovedImportReferences?: number;
    TotalPackages?: number;
    InsertedReferenceIds?: number[];
    RemovedReferenceIds?: number[];
    AddedReferenceIds?: number[];
    QueuedDocumentReferenceIds?: number[];
    RemovedDocumentReferenceIds?: number[];
    AddedDocumentReferenceIds?: number[];
    ErrorMessages?: string[];
}

// @Route("/user/currentuser")
interface CurrentUser extends UserBase, IReturn<CurrentUser>, IDto
{
    UserName?: string;
    SessionId?: string;
    Select?: string[];
}

// @Route("/user/currentaccess")
interface CurrentUserAccess extends IReturn<CurrentUserAccess>
{
    SessionId?: string;
    Id?: number;
    ClientId?: number;
    HasStudySet?: boolean;
    Apps?: string[];
    Roles?: string[];
    Features?: string[];
    HasDashboard?: boolean;
}

// @Route("/user/importlegacy")
interface ImportLegacy extends IReturn<ImportLegacy>
{
    legacyUsername?: string;
    importSucceeded?: boolean;
}

// @Route("/admin/sessions")
interface Sessions extends Dto<Sessions>, IReturn<Sessions>, IDto
{
    Select?: string[];
}

// @Route("/admin/sessions/{SessionId}")
interface GetSession extends Dto<GetSession>, IReturn<GetSession>, IDto
{
    SessionId?: string;
    Select?: string[];
}

// @Route("/admin/settings/logging", "GET, PATCH")
// @DataContract
interface Logging extends IReturn<Logging>
{
    // @DataMember(Name="slack")
    // @ApiMember(Name="slack")
    Slack?: string;

    // @DataMember(Name="nlog")
    // @ApiMember(Name="nlog")
    NLog?: string;

    // @DataMember(Name="event-log")
    EventLog?: string;

    // @DataMember(Name="database")
    Database?: string;

    // @DataMember(Name="stackify")
    // @ApiMember(Name="stackify")
    Stackify?: string;

    // @DataMember(Name="segment")
    // @ApiMember(Name="segment")
    Segment?: string;

    // @DataMember(Name="slack-channel")
    // @ApiMember(Name="slack-channel")
    SlackChannel?: string;

    // @DataMember(Name="show-full-exceptions")
    // @ApiMember(Name="show-full-exceptions")
    ShowFullExceptions?: boolean;

    // @DataMember(Name="verbose-api-logging")
    // @ApiMember(Name="verbose-api-logging")
    VerboseApiLogging?: boolean;

    // @DataMember(Name="enable-request-body-tracking")
    // @ApiMember(Name="enable-request-body-tracking")
    EnableRequestBodyTracking?: boolean;

    // @DataMember(Name="enable-error-tracking")
    // @ApiMember(Name="enable-error-tracking")
    EnableErrorTracking?: boolean;

    // @DataMember(Name="enable-response-tracking")
    // @ApiMember(Name="enable-response-tracking")
    EnableResponseTracking?: boolean;

    // @DataMember(Name="enable-session-tracking")
    // @ApiMember(Name="enable-session-tracking")
    EnableSessionTracking?: boolean;

    // @DataMember(Name="enable-request-logging")
    // @ApiMember(Name="enable-request-logging")
    EnableRequestLogging?: boolean;

    // @DataMember(Name="enable-api-debug")
    // @ApiMember(Name="enable-api-debug")
    EnableApiDebug?: boolean;

    // @DataMember(Name="request-logger")
    // @ApiMember(Name="request-logger")
    Logger?: RequestLogger;

    // @DataMember(Name="include-server-info")
    // @ApiMember(Name="include-server-info")
    IncludeServerInfo?: boolean;

    // @DataMember(Name="log-unhandled-exceptions")
    // @ApiMember(Name="log-unhandled-exceptions")
    LogUnhandledExceptions?: boolean;
}

// @Route("/admin/settings/queue", "GET, PATCH")
// @DataContract
interface Q extends IReturn<Q>
{
    // @DataMember(Name="rq-host")
    // @ApiMember(Name="rq-host")
    RqHost?: string;

    // @DataMember(Name="rq-port")
    // @ApiMember(Name="rq-port")
    RqPort?: number;

    // @DataMember(Name="admin-port")
    // @ApiMember(Name="admin-port")
    AdminPort?: number;

    // @DataMember(Name="rq-reconnect")
    // @ApiMember(Name="rq-reconnect")
    RqReconnect?: boolean;

    // @DataMember(Name="username")
    // @ApiMember(Name="username")
    Username?: string;

    // @DataMember(Name="password")
    // @ApiMember(Name="password")
    Password?: string;

    // @DataMember(Name="rq-queue-name")
    // @ApiMember(Name="rq-queue-name")
    RqQueueName?: string;

    // @DataMember(Name="ampq-disabled")
    // @ApiMember(Name="ampq-disabled")
    AmpqDisabled?: boolean;
}

// @Route("/admin/settings/iplookup", "GET, PATCH")
// @DataContract
interface IpLookup extends IReturn<IpLookup>
{
    // @DataMember(Name="api-key")
    // @ApiMember(Name="api-key")
    ApiKey?: string;

    // @DataMember(Name="api-url")
    // @ApiMember(Name="api-url")
    ApiUrl?: string;

    // @DataMember(Name="time-zone-url")
    // @ApiMember(Name="time-zone-url")
    TimeZoneUrl?: string;

    // @DataMember(Name="location-url")
    // @ApiMember(Name="location-url")
    LocationUrl?: string;

    // @DataMember(Name="google-api-key")
    // @ApiMember(Name="google-api-key")
    GoogleApiKey?: string;
}

// @Route("/admin/settings/database", "GET, PATCH")
// @DataContract
interface Database extends IReturn<Database>
{
    // @DataMember(Name="configuration-name")
    // @ApiMember(Name="configuration-name")
    ConfigurationName?: string;

    // @DataMember(Name="upgrade-mode")
    // @ApiMember(Name="upgrade-mode")
    UpgradeMode?: string;

    // @DataMember(Name="type")
    // @ApiMember(Name="type")
    Type?: string;

    // @DataMember(Name="db-name")
    // @ApiMember(Name="db-name")
    DbName?: string;

    // @DataMember(Name="ip-address")
    // @ApiMember(Name="ip-address")
    IpAddress?: string;

    // @DataMember(Name="connection-timeout")
    // @ApiMember(Name="connection-timeout")
    ConnectionTimeout?: number;

    // @DataMember(Name="command-timeout")
    // @ApiMember(Name="command-timeout")
    CommandTimeout?: number;

    // @DataMember(Name="ormlite-command-timeout")
    // @ApiMember(Name="ormlite-command-timeout")
    OrmLiteCommandTimeout?: number;

    // @DataMember(Name="integrated-security")
    // @ApiMember(Name="integrated-security")
    IntegratedSecurity?: boolean;

    // @DataMember(Name="multiple-active-result-sets")
    // @ApiMember(Name="multiple-active-result-sets")
    MultipleActiveResultSets?: boolean;

    // @DataMember(Name="sql-server-version")
    // @ApiMember(Name="sql-server-version")
    SqlServerVersion?: number;
}

// @Route("/admin/settings/atlassian", "GET, PATCH")
// @DataContract
interface Atlassian extends IReturn<Atlassian>
{
    // @DataMember(Name="crowd-api")
    // @ApiMember(Name="crowd-api")
    CrowdApi?: string;

    // @DataMember(Name="crowd-app")
    // @ApiMember(Name="crowd-app")
    CrowdApp?: string;

    // @DataMember(Name="crowd-pass")
    // @ApiMember(Name="crowd-pass")
    CrowdPass?: string;

    // @DataMember(Name="jira-url")
    // @ApiMember(Name="jira-url")
    JiraUrl?: string;

    // @DataMember(Name="jira-username")
    // @ApiMember(Name="jira-username")
    JiraUsername?: string;

    // @DataMember(Name="jira-password")
    // @ApiMember(Name="jira-password")
    JiraPassword?: string;

    // @DataMember(Name="ignore-usernames")
    // @ApiMember(Name="ignore-usernames")
    IgnoreUsernames?: string[];
}

// @Route("/admin/settings/salesforce", "GET, PATCH")
// @DataContract
interface Salesforce extends IReturn<Salesforce>
{
    // @DataMember(Name="client-id")
    // @ApiMember(Name="client-id")
    ClientId?: string;

    // @DataMember(Name="client-key")
    // @ApiMember(Name="client-key")
    ClientKey?: string;

    // @DataMember(Name="username")
    // @ApiMember(Name="username")
    Username?: string;

    // @DataMember(Name="password")
    // @ApiMember(Name="password")
    Password?: string;

    // @DataMember(Name="url")
    // @ApiMember(Name="url")
    Url?: string;

    // @DataMember(Name="authentication-url")
    // @ApiMember(Name="authentication-url")
    AuthenticationUrl?: string;

    // @DataMember(Name="api-version")
    // @ApiMember(Name="api-version")
    ApiVersion?: string;

    // @DataMember(Name="session-expiration")
    // @ApiMember(Name="session-expiration")
    SessionExpiration?: number;

    // @DataMember(Name="authentication-retries")
    // @ApiMember(Name="authentication-retries")
    AuthenticationRetries?: number;
}

// @Route("/admin/settings/schema", "GET, PATCH")
// @DataContract
interface Schema extends IReturn<Schema>
{
    // @DataMember(Name="default")
    // @ApiMember(Name="default")
    Default?: string;

    // @DataMember(Name="nhanes")
    // @ApiMember(Name="nhanes")
    Nhanes?: string;

    // @DataMember(Name="legacy")
    // @ApiMember(Name="legacy")
    Legacy?: string;

    // @DataMember(Name="audit")
    // @ApiMember(Name="audit")
    Audit?: string;

    // @DataMember(Name="library")
    // @ApiMember(Name="library")
    Library?: string;

    // @DataMember(Name="label")
    // @ApiMember(Name="label")
    Label?: string;

    // @DataMember(Name="uk-label")
    // @ApiMember(Name="uk-label")
    UkLabel?: string;

    // @DataMember(Name="legacy-db-name")
    // @ApiMember(Name="legacy-db-name")
    LegacyDbName?: string;

    // @DataMember(Name="library-db-name")
    // @ApiMember(Name="library-db-name")
    LibraryDbName?: string;

    // @DataMember(Name="nhanes-db-name")
    // @ApiMember(Name="nhanes-db-name")
    NhanesDbName?: string;

    // @DataMember(Name="label-db-name")
    // @ApiMember(Name="label-db-name")
    LabelDbName?: string;

    // @DataMember(Name="uk-label-db-name")
    // @ApiMember(Name="uk-label-db-name")
    UkLabelDbName?: string;

    // @DataMember(Name="audit-db-name")
    // @ApiMember(Name="audit-db-name")
    AuditDbName?: string;

    // @DataMember(Name="full-text-db-name")
    // @ApiMember(Name="full-text-db-name")
    FullTextDbName?: string;

    // @DataMember(Name="cache_db_name")
    // @ApiMember(Name="cache_db_name")
    CacheDbName?: string;
}

// @Route("/admin/settings/email", "GET, PATCH")
// @DataContract
interface Email extends IReturn<Email>
{
    // @DataMember(Name="enabled")
    // @ApiMember(Name="enabled")
    Enabled?: boolean;

    // @DataMember(Name="retry-on-failure")
    // @ApiMember(Name="retry-on-failure")
    RetryOnFailure?: number;

    /**
    * An optional email address to use for all outgoing emails
    */
    // @DataMember(Name="global-email-override")
    // @ApiMember(Description="An optional email address to use for all outgoing emails", Name="global-email-override")
    GlobalOverride?: string;

    // @DataMember(Name="from")
    // @ApiMember(Name="from")
    From?: string;

    // @DataMember(Name="display-name")
    // @ApiMember(Name="display-name")
    DisplayName?: string;

    // @DataMember(Name="to")
    // @ApiMember(Name="to")
    To?: string[];

    // @DataMember(Name="studyset-history-to")
    // @ApiMember(Name="studyset-history-to")
    StudySetHistoryTo?: string[];

    // @DataMember(Name="smtp-username")
    // @ApiMember(Name="smtp-username")
    SmtpUsername?: string;

    // @DataMember(Name="smtp-password")
    // @ApiMember(Name="smtp-password")
    SmtpPassword?: string;

    // @DataMember(Name="smtp-host")
    // @ApiMember(Name="smtp-host")
    SmtpHost?: string;

    // @DataMember(Name="smtp-port")
    // @ApiMember(Name="smtp-port")
    SmtpPort?: number;
}

// @Route("/admin/settings/paths", "GET, PATCH")
// @DataContract
interface Paths extends IReturn<Paths>
{
    // @DataMember(Name="base-url")
    // @ApiMember(Name="base-url")
    BaseUrl?: string;

    // @DataMember(Name="launch-url")
    // @ApiMember(Name="launch-url")
    LaunchUrl?: string;

    // @DataMember(Name="federate-url")
    // @ApiMember(Name="federate-url")
    FederateUrl?: string;

    // @DataMember(Name="federate-site")
    // @ApiMember(Name="federate-site")
    FederateSite?: string;

    // @DataMember(Name="full-text-path")
    // @ApiMember(Name="full-text-path")
    FullTextPath?: string;

    // @DataMember(Name="reference-files-path")
    // @ApiMember(Name="reference-files-path")
    ReferenceFilesPath?: string;

    // @DataMember(Name="extract-url")
    // @ApiMember(Name="extract-url")
    ExtractUrl?: string;

    // @DataMember(Name="scheduler-url")
    // @ApiMember(Name="scheduler-url")
    SchedulerUrl?: string;

    // @DataMember(Name="q-url")
    // @ApiMember(Name="q-url")
    QUrl?: string;

    // @DataMember(Name="portal-url")
    // @ApiMember(Name="portal-url")
    PortalUrl?: string;

    // @DataMember(Name="internal-meta-url")
    // @ApiMember(Name="internal-meta-url")
    InternalMetaUrl?: string;

    // @DataMember(Name="external-meta-url")
    // @ApiMember(Name="external-meta-url")
    ExternalMetaUrl?: string;

    // @DataMember(Name="analysis-cluster-url")
    // @ApiMember(Name="analysis-cluster-url")
    AnalysisClusterUrl?: string;

    // @DataMember(Name="analysis-cluster-api-token")
    // @ApiMember(Name="analysis-cluster-api-token")
    AnalysisClusterApiToken?: string;
}

// @Route("/admin/settings/slack", "GET, PATCH")
// @DataContract
interface Slack extends IReturn<Slack>
{
    // @DataMember(Name="api-key")
    // @ApiMember(Name="api-key")
    ApiKey?: string;

    // @DataMember(Name="web-hook")
    // @ApiMember(Name="web-hook")
    Webhook?: string;

    // @DataMember(Name="bot-name")
    // @ApiMember(Name="bot-name")
    BotName?: string;

    /**
    * An optional slack user or channel to use for all outgoing messages
    */
    // @DataMember(Name="enabled")
    // @ApiMember(Description="An optional slack user or channel to use for all outgoing messages", Name="enabled")
    Enabled?: boolean;

    // @DataMember(Name="global-override")
    // @ApiMember(Name="global-override")
    GlobalOverride?: string;

    /**
    * An optional catch-all channel for any slack communication which fails to find a correct user or channel
    */
    // @DataMember(Name="failure-channel")
    // @ApiMember(Description="An optional catch-all channel for any slack communication which fails to find a correct user or channel", Name="failure-channel")
    FailureChannel?: string;
}

// @Route("/admin/settings/bioportal", "GET, PATCH")
// @DataContract
interface BioPortal extends IReturn<BioPortal>
{
    // @DataMember(Name="api-key")
    // @ApiMember(Name="api-key")
    ApiKey?: string;

    // @DataMember(Name="semantic-types")
    // @ApiMember(AllowMultiple=true, Name="semantic-types")
    SemanticTypes?: string;
}

// @Route("/admin/settings/api", "GET, PATCH")
// @DataContract
interface API extends IReturn<API>
{
    // @DataMember(Name="allowed-content-headers")
    // @ApiMember(Name="allowed-content-headers")
    AllowedContentHeaders?: string[];

    // @DataMember(Name="expose-content-headers")
    // @ApiMember(Name="expose-content-headers")
    ExposeContentHeaders?: string[];
}

// @Route("/admin/settings/features", "GET, PATCH")
// @DataContract
interface Features extends IReturn<Features>
{
    // @DataMember(Name="enable-impersonation")
    // @ApiMember(Name="enable-impersonation")
    EnableImpersonation?: boolean;

    // @DataMember(Name="enable-audit")
    // @ApiMember(Name="enable-audit")
    EnableAudit?: boolean;
}

// @Route("/admin/settings/extract", "GET, PATCH")
// @DataContract
interface Extract extends IReturn<Extract>
{
    // @DataMember(Name="username")
    // @ApiMember(Name="username")
    Username?: string;

    // @DataMember(Name="password")
    // @ApiMember(Name="password")
    Password?: string;

    // @DataMember(Name="notifications-api")
    // @ApiMember(Name="notifications-api")
    NotificationsApi?: string;

    // @DataMember(Name="retry-attempts")
    // @ApiMember(Name="retry-attempts")
    RetryAttempts?: number;
}

// @Route("/admin/settings", "GET")
// @DataContract
interface Settings extends Config<Settings>, IReturn<Settings>
{
    // @DataMember(Name="client-settings")
    // @ApiMember(Name="client-settings")
    ClientSettings?: Frontend;

    // @DataMember(Name="version")
    // @ApiMember(Name="version")
    Version?: number;

    // @DataMember(Name="cookie-domain")
    // @ApiMember(Name="cookie-domain")
    CookieDomain?: string;

    // @DataMember(Name="system-username")
    // @ApiMember(Name="system-username")
    SystemUsername?: string;

    // @DataMember(Name="system-password")
    // @ApiMember(Name="system-password")
    SystemPassword?: string;

    // @DataMember(Name="session-timeout")
    // @ApiMember(Name="session-timeout")
    SessionTimeout?: number;

    // @DataMember(Name="environment")
    // @ApiMember(Name="environment")
    Environment?: string;

    // @DataMember(Name="logging", EmitDefaultValue=false)
    // @ApiMember(Name="logging")
    Logging?: Logging;

    // @DataMember(Name="q")
    // @ApiMember(Name="q")
    Q?: Q;

    // @DataMember(Name="scheduler")
    // @ApiMember(Name="scheduler")
    Scheduler?: Scheduler;

    // @DataMember(Name="ip-lookup")
    // @ApiMember(Name="ip-lookup")
    IpLookup?: IpLookup;

    // @DataMember(Name="database")
    // @ApiMember(Name="database")
    Database?: Database;

    // @DataMember(Name="atlassian")
    // @ApiMember(Name="atlassian")
    Atlassian?: Atlassian;

    // @DataMember(Name="salesforce")
    // @ApiMember(Name="salesforce")
    Salesforce?: Salesforce;

    // @DataMember(Name="schema")
    // @ApiMember(Name="schema")
    Schema?: Schema;

    // @DataMember(Name="email")
    // @ApiMember(Name="email")
    Email?: Email;

    // @DataMember(Name="paths")
    // @ApiMember(Name="paths")
    Paths?: Paths;

    // @DataMember(Name="slack")
    // @ApiMember(Name="slack")
    Slack?: Slack;

    // @DataMember(Name="bio-portal")
    // @ApiMember(Name="bio-portal")
    BioPortal?: BioPortal;

    // @DataMember(Name="api")
    // @ApiMember(Name="api")
    Api?: API;

    // @DataMember(Name="portal")
    // @ApiMember(Name="portal")
    Portal?: Portal;

    // @DataMember(Name="features")
    // @ApiMember(Name="features")
    Features?: Features;

    // @DataMember(Name="extract")
    // @ApiMember(Name="extract")
    Extract?: Extract;

    // @DataMember(Name="server-info")
    // @ApiMember(Name="server-info")
    ServerInfo?: ServerInfo;

    // @DataMember(Name="developer")
    // @ApiMember(Name="developer")
    Developer?: Developer;

    // @DataMember(Name="search")
    // @ApiMember(Name="search")
    Search?: Search;

    // @DataMember(Name="build")
    // @ApiMember(Name="build")
    Build?: Build;
}

// @Route("/fqreferencestatus", "POST")
// @Route("/fqreferencestatus/{FqId}/{ReferenceId}", "GET")
interface LibraryFqReferenceStatus extends IReturn<LibraryFqReferenceStatus>
{
    FqId?: number;
    ReferenceId?: number;
    Status?: string;
    LastStatusChangedUserId?: number;
    ReasonRejected?: string;
    ReasonRejectedFreeText?: string;
}

// @Route("/framedquestion/{Id}", "GET")
interface FramedQuestion
{
    Id?: number;
    Name?: string;
    DocSearchSignal?: string;
    SortOrder?: number;
    IsVisible?: boolean;
    References?: ReferenceStatus[];
}

// @Route("/librarypackage/{Id}", "GET")
// @Route("/librarypackage", "POST")
interface LibraryPackage extends IReturn<LibraryPackage>
{
    Id?: number;
    Name?: string;
    FramedQuestions?: FramedQuestion[];
    ShowClone?: boolean;
    ShowExternalFullTextUrl?: boolean;
    ShowRejectedReferences?: boolean;
    AllowClientRejectedReferences?: boolean;
    PDFProtected?: boolean;
    AllowPublicNotes?: boolean;
    NotifySiteAdminOnAddNote?: boolean;
    FramedQuestionAltText?: string;
    CYOFQAltText?: string;
    AbstractAltText?: string;
    GAWebPropertyID?: string;
    QuoromFQID?: number;
    ShowClientRejectedReferences?: boolean;
    ShowQuoromChart?: boolean;
    ShowDigitizedStudies?: boolean;
    MergeRCT?: boolean;
    ShowIsDigitizedColumn?: boolean;
    DownloadFullTextAsAuthorTitleFormat?: boolean;
    RenameFullTextTo?: string;
}

// @Route("/libraryratings/{Id}", "GET")
// @Route("/libraryratings", "POST")
interface LibraryRating extends IReturn<LibraryRating>
{
    Id?: number;
    UserId?: number;
    FirstName?: string;
    LastName?: string;
    ClientName?: string;
    ReferenceId?: number;
    FramedQuestionId?: number;
    PackageId?: number;
    Rating?: string;
    ReasonRejected?: string;
}

// @Route("/librarynote", "DELETE")
// @Route("/librarynote/{Id}", "GET")
// @Route("/librarynote/{Id}", "DELETE")
// @Route("/librarynote", "POST")
interface LibraryNote extends IReturn<LibraryNote>
{
    Id?: number;
    NoteDate?: string;
    Note?: string;
    ReferenceId?: number;
    UserId?: number;
    User?: User;
    DateRead?: string;
    IsPublic?: boolean;
}

// @Route("/libraryfavorites", "POST")
// @Route("/libraryfavorites/{UserId}", "GET")
// @Route("/libraryfavorites", "DELETE")
interface LibraryFavorite extends IReturn<LibraryFavorite>
{
    UserId?: number;
    LegacyPackageId?: number;
    ReferenceId?: number;
}

// @Route("/error/{Id}", "GET, PATCH, PUT, POST")
// @Route("/error", "GET, PATCH, PUT, POST")
// @Route("/profile/error", "GET, PATCH, PUT, POST")
// @Api()
// @DataContract
interface Error extends IReturn<Error>
{
    /**
    * App
    */
    // @DataMember
    // @ApiMember(Description="App", Name="App")
    App?: Reference;

    /**
    * Primary Key of App
    */
    // @DataMember
    // @ApiMember(Description="Primary Key of App", Name="AppId")
    AppId?: number;

    /**
    * LookupTable
    */
    // @DataMember
    // @ApiMember(Description="LookupTable", Name="BackgroundTask")
    BackgroundTask?: Reference;

    /**
    * Primary Key of LookupTable
    */
    // @DataMember
    // @ApiMember(Description="Primary Key of LookupTable", Name="BackgroundTaskId")
    BackgroundTaskId?: number;

    /**
    * DateTime?
    */
    // @DataMember
    // @ApiMember(Description="DateTime?", IsRequired=true, Name="DateTime")
    DateTime?: string;

    /**
    * DocumentSet
    */
    // @DataMember
    // @ApiMember(Description="DocumentSet", Name="DocumentSet")
    DocumentSet?: Reference;

    /**
    * Primary Key of DocumentSet
    */
    // @DataMember
    // @ApiMember(Description="Primary Key of DocumentSet", Name="DocumentSetId")
    DocumentSetId?: number;

    /**
    * JsonObject
    */
    // @DataMember(Name="ErrorData")
    // @ApiMember(Description="JsonObject", Name="ErrorData")
    ErrorData?: JsonObject;

    /**
    * string
    */
    // @DataMember
    // @ApiMember(Description="string", IsRequired=true, Name="Message")
    Message?: string;

    /**
    * Page
    */
    // @DataMember
    // @ApiMember(Description="Page", Name="Page")
    Page?: Reference;

    /**
    * Primary Key of Page
    */
    // @DataMember
    // @ApiMember(Description="Primary Key of Page", Name="PageId")
    PageId?: number;

    /**
    * string
    */
    // @DataMember
    // @ApiMember(Description="string", Name="URL")
    URL?: string;

    /**
    * User
    */
    // @DataMember
    // @ApiMember(Description="User", IsRequired=true, Name="User")
    User?: Reference;

    /**
    * Primary Key of User
    */
    // @DataMember
    // @ApiMember(Description="Primary Key of User", Name="UserId")
    UserId?: number;

    /**
    * UserSession
    */
    // @DataMember
    // @ApiMember(Description="UserSession", Name="UserSession")
    UserSession?: Reference;

    /**
    * Primary Key of UserSession
    */
    // @DataMember
    // @ApiMember(Description="Primary Key of UserSession", Name="UserSessionId")
    UserSessionId?: number;

    // @DataMember
    // @ApiMember()
    Exception?: ExceptionDto;

    // @DataMember
    // @ApiMember()
    Attachments?: LoggingAttachment[];
}

// @Route("/analysis/bayesian")
interface Bayesian extends IReturn<Bayesian>
{
    ResultJson?: string;
    data?: string;
    options?: string;
    rawData?: string;
}

// @Route("/analysis/meta")
interface Meta extends IReturn<Meta>
{
    Session?: string;
    Location?: string;
    Package?: string;
    ExternalMetaUrl?: string;
    ResultJson?: string;
    data?: string;
    options?: string;
    rawData?: string;
}

// @Route("/analysis/netmeta")
interface NetMeta extends IReturn<NetMeta>
{
    Session?: string;
    Location?: string;
    ExternalMetaUrl?: string;
    ResultJson?: string;
    data?: string;
    options?: string;
    rawData?: string;
}

// @Route("/analysis/cohort")
interface Cohort extends IReturn<Cohort>
{
    Session?: string;
    Location?: string;
    ExternalMetaUrl?: string;
    ResultJson?: string;
    data?: string;
    options?: string;
    rawData?: string;
}

// @Route("/federate/platform")
interface GetPlatforms extends IReturn<GetPlatforms>
{
    AllPlatforms?: FederatePlatform[];
    CurrentUserPlatforms?: FederatePlatform[];
    UserId?: number;
    Username?: string;
}

interface UniqueId extends IDto
{
    Id?: number;
    CreatorId?: number;
    Select?: string[];
    Set?: string[];
    IgnoreCache?: boolean;
    UniqueIds?: string[];
}

// @Route("/version")
interface CurrentVersion extends IReturn<CurrentVersion>
{
    Version?: string;
    Name?: string;
}

// @DataContract
interface AuthenticateResponse extends IHasSessionId, IHasBearerToken
{
    // @DataMember(Order=1)
    UserId?: string;

    // @DataMember(Order=2)
    SessionId?: string;

    // @DataMember(Order=3)
    UserName?: string;

    // @DataMember(Order=4)
    DisplayName?: string;

    // @DataMember(Order=5)
    ReferrerUrl?: string;

    // @DataMember(Order=6)
    BearerToken?: string;

    // @DataMember(Order=7)
    RefreshToken?: string;

    // @DataMember(Order=8)
    ResponseStatus?: ResponseStatus;

    // @DataMember(Order=9)
    Meta?: { [index:string]: string; };
}

// @DataContract
interface AssignRolesResponse
{
    // @DataMember(Order=1)
    AllRoles?: string[];

    // @DataMember(Order=2)
    AllPermissions?: string[];

    // @DataMember(Order=3)
    ResponseStatus?: ResponseStatus;
}

// @DataContract
interface UnAssignRolesResponse
{
    // @DataMember(Order=1)
    AllRoles?: string[];

    // @DataMember(Order=2)
    AllPermissions?: string[];

    // @DataMember(Order=3)
    ResponseStatus?: ResponseStatus;
}

// @Route("/backgroundtaskitem", "GET")
// @Route("/backgroundtaskitem/version", "GET, POST")
// @Route("/backgroundtaskitem/search", "GET, POST, DELETE")
interface BackgroundTaskItemSearch extends BackgroundTaskItemSearchBase, IReturn<BackgroundTaskItem[]>
{
}

// @Route("/backgroundtaskitem/{Id}/{Junction}/version", "GET, POST")
// @Route("/backgroundtaskitem/{Id}/{Junction}", "GET, POST, DELETE")
interface BackgroundTaskItemJunction extends BackgroundTaskItemSearchBase, IReturn<BackgroundTaskItem[]>
{
}

// @Route("/comparator/search", "GET, POST, DELETE")
// @Route("/comparator/version", "GET, POST")
// @Route("/comparator", "GET")
interface ComparatorSearch extends ComparatorSearchBase, IReturn<Comparator[]>
{
}

// @Route("/comparator/batch", "DELETE, PATCH, POST, PUT")
interface ComparatorBatch extends Array<Comparator>
{
}

// @Route("/comparator/{Id}/copy", "POST")
// @Route("/comparator", "POST")
// @Route("/comparator/{Id}", "GET, PATCH, PUT, DELETE")
interface ComparatorCopy extends Comparator, IReturn<Comparator>, IDto
{
}

// @Route("/comparator/{Id}/{Junction}", "GET, POST, DELETE")
// @Route("/comparator/{Id}/{Junction}/version", "GET, POST")
interface ComparatorJunction extends ComparatorSearchBase, IReturn<Comparator[]>
{
}

// @Route("/project/search/extended", "GET")
interface ProjectSearchExtended extends ProjectSearchBase, IReturn<Project[]>
{
}

// @Route("/project/version", "GET, POST")
// @Route("/project", "GET")
// @Route("/project/search", "GET, POST, DELETE")
interface ProjectSearch extends ProjectSearchBase, IReturn<Project[]>
{
}

// @Route("/project/batch", "DELETE, PATCH, POST, PUT")
interface ProjectBatch extends Array<Project>
{
}

// @Route("/project/{Id}/copy", "POST")
// @Route("/project", "POST")
// @Route("/project/{Id}", "GET, PATCH, PUT, DELETE")
interface ProjectCopy extends Project, IReturn<Project>, IDto
{
}

// @Route("/project/{Id}/{Junction}", "GET, POST, DELETE")
// @Route("/project/{Id}/{Junction}/version", "GET, POST")
interface ProjectJunction extends ProjectSearchBase, IReturn<Project[]>
{
}

// @Route("/default", "GET")
// @Route("/default/version", "GET, POST")
// @Route("/default/search", "GET, POST, DELETE")
interface DefaultSearch extends DefaultSearchBase, IReturn<Default[]>
{
}

// @Route("/default/batch", "DELETE, PATCH, POST, PUT")
interface DefaultBatch extends Array<Default>
{
}

// @Route("/default/{Id}/copy", "POST")
// @Route("/default/{Id}", "GET, PATCH, PUT")
// @Route("/default", "POST")
interface DefaultCopy extends Default, IReturn<Default>, IDto
{
}

// @Route("/admin/metadata", "POST,GET")
interface GetMetadata extends IReturn<DataClass[]>
{
    Tables?: string[];
}

// @Route("/admin/metadata/version/{Table}", "POST,GET")
// @Route("/admin/metadata/version", "POST,GET")
interface GetMetadataVersion extends IReturn<number>
{
    Table?: string;
}

// @Route("/query/profiler/{Id}")
// @Route("/query/profiler")
interface QueryProfilers extends QueryDb_2<MiniProfiler, ProfilerStack>, IReturn<QueryResponse<ProfilerStack>>
{
    Id?: string;
    Started?: string;
    DurationMilliseconds?: number;
    User?: string;
    Name?: string;
    SessionId?: string;
    ClientId?: string;
}

// @Route("/query/timing")
// @Route("/query/timing/{MiniProfilerId}")
interface QueryTimings extends QueryDb_1<Timing>, IReturn<QueryResponse<Timing>>
{
    MiniProfilerId?: string;
    Started?: string;
    DurationMilliseconds?: number;
    User?: string;
}

// @Route("/query/requestlogs")
// @Route("/query/requestlogs/{Date}")
// @Route("/query/requestlogs/{Date}/{Hours}")
interface QueryRequestLogs extends QueryDb_1<RequestLog>, IReturn<QueryResponse<RequestLog>>
{
    DateTime?: string;
    RequestDuration?: string;
    Hours?: number;
    ViewErrors?: boolean;
}

// @Route("/logs/today")
interface TodayLogs extends QueryDb_1<RequestLog>, IReturn<QueryResponse<RequestLog>>
{
}

// @Route("/logs/today/errors")
interface TodayErrorLogs extends QueryDb_1<RequestLog>, IReturn<QueryResponse<RequestLog>>
{
}

// @Route("/logs/yesterday")
interface YesterdayLogs extends QueryDb_1<RequestLog>, IReturn<QueryResponse<RequestLog>>
{
}

// @Route("/logs/yesterday/errors")
interface YesterdayErrorLogs extends QueryDb_1<RequestLog>, IReturn<QueryResponse<RequestLog>>
{
}

// @Route("/impersonation/version", "GET, POST")
// @Route("/impersonation", "GET")
// @Route("/impersonation/search", "GET, POST, DELETE")
interface ImpersonationSearch extends ImpersonationSearchBase, IReturn<Impersonation[]>
{
}

// @Route("/app/version", "GET, POST")
// @Route("/app/search", "GET, POST, DELETE")
// @Route("/app", "GET")
interface AppSearch extends AppSearchBase, IReturn<App[]>
{
}

// @Route("/app/batch", "DELETE, PATCH, POST, PUT")
interface AppBatch extends Array<App>
{
}

// @Route("/app/{Id}/{Junction}", "GET, POST, DELETE")
// @Route("/app/{Id}/{Junction}/version", "GET, POST")
interface AppJunction extends AppSearchBase, IReturn<App[]>
{
}

// @Route("/auditrecord", "GET")
// @Route("/auditrecord/search", "GET, POST, DELETE")
// @Route("/auditrecord/version", "GET, POST")
interface AuditRecordSearch extends AuditRecordSearchBase, IReturn<AuditRecord[]>
{
}

// @Route("/auditrecord/{Id}/{Junction}", "GET, POST, DELETE")
// @Route("/auditrecord/{Id}/{Junction}/version", "GET, POST")
interface AuditRecordJunction extends AuditRecordSearchBase, IReturn<AuditRecord[]>
{
}

// @Route("/backgroundtaskhistory/search", "GET, POST, DELETE")
// @Route("/backgroundtaskhistory", "GET")
// @Route("/backgroundtaskhistory/version", "GET, POST")
interface BackgroundTaskHistorySearch extends BackgroundTaskHistorySearchBase, IReturn<BackgroundTaskHistory[]>
{
}

// @Route("/backgroundtaskhistory/{Id}/{Junction}", "GET, POST, DELETE")
// @Route("/backgroundtaskhistory/{Id}/{Junction}/version", "GET, POST")
interface BackgroundTaskHistoryJunction extends BackgroundTaskHistorySearchBase, IReturn<BackgroundTaskHistory[]>
{
}

// @Route("/backgroundtask", "GET")
// @Route("/backgroundtask/version", "GET, POST")
// @Route("/backgroundtask/search", "GET, POST, DELETE")
interface BackgroundTaskSearch extends BackgroundTaskSearchBase, IReturn<BackgroundTask[]>
{
}

// @Route("/backgroundtask/batch", "DELETE, PATCH, POST, PUT")
interface BackgroundTaskBatch extends Array<BackgroundTask>
{
}

// @Route("/backgroundtask/{Id}/{Junction}/version", "GET, POST")
// @Route("/backgroundtask/{Id}/{Junction}", "GET, POST, DELETE")
interface BackgroundTaskJunction extends BackgroundTaskSearchBase, IReturn<BackgroundTask[]>
{
}

// @Route("/broadcast", "GET")
// @Route("/broadcast/search", "GET, POST, DELETE")
// @Route("/broadcast/version", "GET, POST")
interface BroadcastSearch extends BroadcastSearchBase, IReturn<Broadcast[]>
{
}

// @Route("/broadcast/batch", "DELETE, PATCH, POST, PUT")
interface BroadcastBatch extends Array<Broadcast>
{
}

// @Route("/broadcast/{Id}/copy", "POST")
// @Route("/broadcast/{Id}", "GET, PATCH, PUT, DELETE")
// @Route("/broadcast", "POST")
interface BroadcastCopy extends Broadcast, IReturn<Broadcast>, IDto
{
}

// @Route("/broadcast/{Id}/{Junction}/version", "GET, POST")
// @Route("/broadcast/{Id}/{Junction}", "GET, POST, DELETE")
interface BroadcastJunction extends BroadcastSearchBase, IReturn<Broadcast[]>
{
}

// @Route("/characteristic", "GET")
// @Route("/characteristic/search", "GET, POST, DELETE")
// @Route("/characteristic/version", "GET, POST")
interface CharacteristicSearch extends CharacteristicSearchBase, IReturn<Characteristic[]>
{
}

// @Route("/characteristic/batch", "DELETE, PATCH, POST, PUT")
interface CharacteristicBatch extends Array<Characteristic>
{
}

// @Route("/characteristic/{Id}/copy", "POST")
// @Route("/characteristic/{Id}", "GET, PATCH, PUT, DELETE")
// @Route("/characteristic", "POST")
interface CharacteristicCopy extends Characteristic, IReturn<Characteristic>, IDto
{
}

// @Route("/characteristic/{Id}/{Junction}", "GET, POST, DELETE")
// @Route("/characteristic/{Id}/{Junction}/version", "GET, POST")
interface CharacteristicJunction extends CharacteristicSearchBase, IReturn<Characteristic[]>
{
}

// @Route("/client/version", "GET, POST")
// @Route("/client", "GET")
// @Route("/client/search", "GET, POST, DELETE")
interface ClientSearch extends ClientSearchBase, IReturn<Client[]>
{
}

// @Route("/client/batch", "DELETE, PATCH, POST, PUT")
interface ClientBatch extends Array<Client>
{
}

// @Route("/client/{Id}/copy", "POST")
// @Route("/client/{Id}", "GET, PATCH, PUT, DELETE")
// @Route("/client", "POST")
interface ClientCopy extends Client, IReturn<Client>, IDto
{
}

// @Route("/client/{Id}/{Junction}/version", "GET, POST")
// @Route("/client/{Id}/{Junction}", "GET, POST, DELETE")
interface ClientJunction extends ClientSearchBase, IReturn<Client[]>
{
}

// @Route("/division", "GET")
// @Route("/division/search", "GET, POST, DELETE")
// @Route("/division/version", "GET, POST")
interface DivisionSearch extends DivisionSearchBase, IReturn<Division[]>
{
}

// @Route("/division/batch", "DELETE, PATCH, POST, PUT")
interface DivisionBatch extends Array<Division>
{
}

// @Route("/division/{Id}/copy", "POST")
// @Route("/division", "POST")
// @Route("/division/{Id}", "GET, PATCH, PUT, DELETE")
interface DivisionCopy extends Division, IReturn<Division>, IDto
{
}

// @Route("/division/{Id}/{Junction}/version", "GET, POST")
// @Route("/division/{Id}/{Junction}", "GET, POST, DELETE")
interface DivisionJunction extends DivisionSearchBase, IReturn<Division[]>
{
}

// @Route("/document/export", "GET, POST")
interface DocumentZip extends IReturn<Blob>
{
    UserId?: number;
    DocumentSetId?: number;
    ReferenceIds?: number[];
}

// @Route("/document/supplemental/export", "GET, POST")
interface SupplementalZip extends IReturn<Blob>
{
    UserId?: number;
    DocumentSetId?: number;
    ReferenceIds?: number[];
}

// @Route("/document/supplemental", "GET, POST")
interface SupplementalFiles
{
    UserId?: number;
    DocumentSetId?: number;
    ReferenceIds?: number[];
}

// @Route("/document/fulltextlist", "GET, POST")
interface FullTextList
{
    UserId?: number;
    DocumentSetId?: number;
}

// @Route("/document/version", "GET, POST")
// @Route("/document", "GET")
// @Route("/document/search", "GET, POST, DELETE")
interface DocumentSearch extends DocumentSearchBase, IReturn<Document[]>
{
}

// @Route("/document/batch", "DELETE, PATCH, POST, PUT")
interface DocumentBatch extends Array<Document>
{
}

// @Route("/document/{Id}/copy", "POST")
// @Route("/document", "POST")
// @Route("/document/{Id}", "GET, PATCH, PUT, DELETE")
interface DocumentCopy extends Document, IReturn<Document>, IDto
{
}

// @Route("/document/{Id}/{Junction}", "GET, POST, DELETE")
// @Route("/document/{Id}/{Junction}/version", "GET, POST")
interface DocumentJunction extends DocumentSearchBase, IReturn<Document[]>
{
}

// @Route("/documentset/referenceid/{ReferenceId}/", "GET")
interface DocumentSetsReferenceId extends IReturn<DocumentSet[]>
{
    ReferenceId?: number;
    Select?: string[];
}

// @Route("/documentset/{Id}/referencestudies", "GET")
interface DocumentSetReferenceStudies extends IReturn<number[]>
{
    Id?: number;
    Digitized?: boolean;
}

// @Route("/documentset/{Id}/allusers", "GET, POST")
interface DocumentSetAllUsers
{
    Id?: number;
}

// @Route("/documentset/{Id}/libupdate", "GET, POST")
interface DocumentSetLibUpdate extends IReturn<DocumentSetLibUpdateInfo>
{
    Id?: number;
    TakeLimit?: number;
}

// @Route("/documentset/version", "GET, POST")
// @Route("/documentset", "GET")
// @Route("/documentset/search", "GET, POST, DELETE")
interface DocumentSetSearch extends DocumentSetSearchBase, IReturn<DocumentSet[]>
{
}

// @Route("/documentset/batch", "DELETE, PATCH, POST, PUT")
interface DocumentSetBatch extends Array<DocumentSet>
{
}

// @Route("/documentset/{Id}/copy", "POST")
// @Route("/documentset", "POST")
// @Route("/documentset/{Id}", "GET, PATCH, PUT, DELETE")
interface DocumentSetCopy extends DocumentSet, IReturn<DocumentSet>, IDto
{
}

// @Route("/documentset/{Id}/{Junction}", "GET, POST, DELETE")
// @Route("/documentset/{Id}/{Junction}/version", "GET, POST")
interface DocumentSetJunction extends DocumentSetSearchBase, IReturn<DocumentSet[]>
{
}

// @Route("/event/version", "GET, POST")
// @Route("/event", "GET")
// @Route("/event/search", "GET, POST, DELETE")
interface EventSearch extends EventSearchBase, IReturn<Event[]>
{
}

// @Route("/event/{Id}/{Junction}/version", "GET, POST")
// @Route("/event/{Id}/{Junction}", "GET, POST, DELETE")
interface EventJunction extends EventSearchBase, IReturn<Event[]>
{
}

// @Route("/featureset", "GET")
// @Route("/featureset/version", "GET, POST")
// @Route("/featureset/search", "GET, POST, DELETE")
interface FeatureSetSearch extends FeatureSetSearchBase, IReturn<FeatureSet[]>
{
}

// @Route("/featureset/batch", "DELETE, PATCH, POST, PUT")
interface FeatureSetBatch extends Array<FeatureSet>
{
}

// @Route("/featureset/{Id}/{Junction}", "GET, POST, DELETE")
// @Route("/featureset/{Id}/{Junction}/version", "GET, POST")
interface FeatureSetJunction extends FeatureSetSearchBase, IReturn<FeatureSet[]>
{
}

// @Route("/importdata/runjob")
interface ImportData_RunJob
{
}

// @Route("/importdatafull/{Id}", "GET")
interface GetImportDataFull extends IReturn<ImportData>, IDto
{
    Id?: number;
    CreatorId?: number;
    IgnoreCache?: boolean;
    Select?: string[];
    Set?: string[];
}

// @Route("/importdatastatus", "GET")
interface ImportDataStatus extends Search_1<ImportData>, IReturn<ImportData[]>
{
    StatusList?: string[];
    Select?: string[];
    StartDateTime?: string;
    EndDateTime?: string;
}

// @Route("/importdata", "GET")
// @Route("/importdata/search", "GET, POST, DELETE")
// @Route("/importdata/version", "GET, POST")
interface ImportDataSearch extends ImportDataSearchBase, IReturn<ImportData[]>
{
}

// @Route("/importdata/batch", "DELETE, PATCH, POST, PUT")
interface ImportDataBatch extends Array<ImportData>
{
}

// @Route("/importdata/{Id}/copy", "POST")
// @Route("/importdata", "POST")
// @Route("/importdata/{Id}", "GET, PATCH, PUT, DELETE")
interface ImportDataCopy extends ImportData, IReturn<ImportData>, IDto
{
}

// @Route("/importdata/{Id}/{Junction}/version", "GET, POST")
// @Route("/importdata/{Id}/{Junction}", "GET, POST, DELETE")
interface ImportDataJunction extends ImportDataSearchBase, IReturn<ImportData[]>
{
}

// @Route("/intervention/version", "GET, POST")
// @Route("/intervention/search", "GET, POST, DELETE")
// @Route("/intervention", "GET")
interface InterventionSearch extends InterventionSearchBase, IReturn<Intervention[]>
{
}

// @Route("/intervention/batch", "DELETE, PATCH, POST, PUT")
interface InterventionBatch extends Array<Intervention>
{
}

// @Route("/intervention/{Id}/copy", "POST")
// @Route("/intervention", "POST")
// @Route("/intervention/{Id}", "GET, PATCH, PUT, DELETE")
interface InterventionCopy extends Intervention, IReturn<Intervention>, IDto
{
}

// @Route("/intervention/{Id}/{Junction}/version", "GET, POST")
// @Route("/intervention/{Id}/{Junction}", "GET, POST, DELETE")
interface InterventionJunction extends InterventionSearchBase, IReturn<Intervention[]>
{
}

// @Route("/lookuptablebinding/search", "GET, POST, DELETE")
// @Route("/lookuptablebinding/version", "GET, POST")
// @Route("/lookuptablebinding", "GET")
interface LookupTableBindingSearch extends LookupTableBindingSearchBase, IReturn<LookupTableBinding[]>
{
}

// @Route("/lookuptablebinding/batch", "DELETE, PATCH, POST, PUT")
interface LookupTableBindingBatch extends Array<LookupTableBinding>
{
}

// @Route("/lookuptablebinding/{Id}/copy", "POST")
// @Route("/lookuptablebinding/{Id}", "GET, PATCH, PUT, DELETE")
// @Route("/lookuptablebinding", "POST")
interface LookupTableBindingCopy extends LookupTableBinding, IReturn<LookupTableBinding>, IDto
{
}

// @Route("/lookuptablebinding/{Id}/{Junction}", "GET, POST, DELETE")
// @Route("/lookuptablebinding/{Id}/{Junction}/version", "GET, POST")
interface LookupTableBindingJunction extends LookupTableBindingSearchBase, IReturn<LookupTableBinding[]>
{
}

// @Route("/lookuptable/version", "GET, POST")
// @Route("/lookuptable/search", "GET, POST, DELETE")
// @Route("/lookuptable", "GET")
interface LookupTableSearch extends LookupTableSearchBase, IReturn<LookupTable[]>
{
}

// @Route("/lookuptable/batch", "DELETE, PATCH, POST, PUT")
interface LookupTableBatch extends Array<LookupTable>
{
}

// @Route("/lookuptable/{Id}/copy", "POST")
// @Route("/lookuptable", "POST")
// @Route("/lookuptable/{Id}", "GET, PATCH, PUT, DELETE")
interface LookupTableCopy extends LookupTable, IReturn<LookupTable>, IDto
{
}

// @Route("/lookuptable/{Id}/{Junction}/version", "GET, POST")
// @Route("/lookuptable/{Id}/{Junction}", "GET, POST, DELETE")
interface LookupTableJunction extends LookupTableSearchBase, IReturn<LookupTable[]>
{
}

// @Route("/outcome/search", "GET, POST, DELETE")
// @Route("/outcome", "GET")
// @Route("/outcome/version", "GET, POST")
interface OutcomeSearch extends OutcomeSearchBase, IReturn<Outcome[]>
{
}

// @Route("/outcome/batch", "DELETE, PATCH, POST, PUT")
interface OutcomeBatch extends Array<Outcome>
{
}

// @Route("/outcome/{Id}/copy", "POST")
// @Route("/outcome", "POST")
// @Route("/outcome/{Id}", "GET, PATCH, PUT, DELETE")
interface OutcomeCopy extends Outcome, IReturn<Outcome>, IDto
{
}

// @Route("/outcome/{Id}/{Junction}/version", "GET, POST")
// @Route("/outcome/{Id}/{Junction}", "GET, POST, DELETE")
interface OutcomeJunction extends OutcomeSearchBase, IReturn<Outcome[]>
{
}

// @Route("/page", "GET")
// @Route("/page/search", "GET, POST, DELETE")
// @Route("/page/version", "GET, POST")
interface PageSearch extends PageSearchBase, IReturn<Page[]>
{
}

// @Route("/page/batch", "DELETE, PATCH, POST, PUT")
interface PageBatch extends Array<Page>
{
}

// @Route("/page/{Id}/copy", "POST")
// @Route("/page/{Id}", "GET, PATCH, PUT, DELETE")
// @Route("/page", "POST")
interface PageCopy extends Page, IReturn<Page>, IDto
{
}

// @Route("/page/{Id}/{Junction}", "GET, POST, DELETE")
// @Route("/page/{Id}/{Junction}/version", "GET, POST")
interface PageJunction extends PageSearchBase, IReturn<Page[]>
{
}

// @Route("/role/merge", "GET")
interface RoleMerge
{
    RoleIds?: number[];
    RoleNames?: string[];
    All?: boolean;
}

// @Route("/role", "GET")
// @Route("/role/search", "GET, POST, DELETE")
// @Route("/role/version", "GET, POST")
interface RoleSearch extends RoleSearchBase, IReturn<Role[]>
{
}

// @Route("/role/batch", "DELETE, PATCH, POST, PUT")
interface RoleBatch extends Array<Role>
{
}

// @Route("/role/{Id}/copy", "POST")
// @Route("/role", "POST")
// @Route("/role/{Id}", "GET, PATCH, PUT, DELETE")
interface RoleCopy extends Role, IReturn<Role>, IDto
{
}

// @Route("/role/{Id}/{Junction}", "GET, POST, DELETE")
// @Route("/role/{Id}/{Junction}/version", "GET, POST")
interface RoleJunction extends RoleSearchBase, IReturn<Role[]>
{
}

// @Route("/scope/version", "GET, POST")
// @Route("/scope/search", "GET, POST, DELETE")
// @Route("/scope", "GET")
interface ScopeSearch extends ScopeSearchBase, IReturn<Scope[]>
{
}

// @Route("/scope/batch", "DELETE, PATCH, POST, PUT")
interface ScopeBatch extends Array<Scope>
{
}

// @Route("/scope/{Id}/copy", "POST")
// @Route("/scope/{Id}", "GET, PATCH, PUT, DELETE")
// @Route("/scope", "POST")
interface ScopeCopy extends Scope, IReturn<Scope>, IDto
{
}

// @Route("/scope/{Id}/{Junction}/version", "GET, POST")
// @Route("/scope/{Id}/{Junction}", "GET, POST, DELETE")
interface ScopeJunction extends ScopeSearchBase, IReturn<Scope[]>
{
}

// @Route("/statsrecord/version", "GET, POST")
// @Route("/statsrecord/search", "GET, POST, DELETE")
// @Route("/statsrecord", "GET")
interface StatsRecordSearch extends StatsRecordSearchBase, IReturn<StatsRecord[]>
{
}

// @Route("/stats", "GET")
// @Route("/stats/search", "GET, POST, DELETE")
// @Route("/stats/version", "GET, POST")
interface StatsSearch extends StatsSearchBase, IReturn<Stats[]>
{
}

// @Route("/statsstudyset/{Id}/statsrecord", "GET POST DELETE")
interface StatsStudySetStatsRecord extends IReturn<StatsStudySet>, IDto
{
    Id?: number;
    CreatorId?: number;
    IgnoreCache?: boolean;
    Ids?: number[];
    Select?: string[];
    Set?: string[];
}

// @Route("/statsstudyset", "GET")
// @Route("/statsstudyset/search", "GET, POST, DELETE")
// @Route("/statsstudyset/version", "GET, POST")
interface StatsStudySetSearch extends StatsStudySetSearchBase, IReturn<StatsStudySet[]>
{
}

// @Route("/statsstudyset/{Id}/{Junction}", "GET, POST, DELETE")
// @Route("/statsstudyset/{Id}/{Junction}/version", "GET, POST")
interface StatsStudySetJunction extends StatsStudySetSearchBase, IReturn<StatsStudySet[]>
{
}

// @Route("/team/version", "GET, POST")
// @Route("/team/search", "GET, POST, DELETE")
// @Route("/team", "GET")
interface TeamSearch extends TeamSearchBase, IReturn<Team[]>
{
}

// @Route("/team/batch", "DELETE, PATCH, POST, PUT")
interface TeamBatch extends Array<Team>
{
}

// @Route("/team/{Id}/copy", "POST")
// @Route("/team", "POST")
// @Route("/team/{Id}", "GET, PATCH, PUT, DELETE")
interface TeamCopy extends Team, IReturn<Team>, IDto
{
}

// @Route("/team/{Id}/{Junction}/version", "GET, POST")
// @Route("/team/{Id}/{Junction}", "GET, POST, DELETE")
interface TeamJunction extends TeamSearchBase, IReturn<Team[]>
{
}

// @Route("/termmaster", "GET")
// @Route("/termmaster/version", "GET, POST")
// @Route("/termmaster/search", "GET, POST, DELETE")
interface TermMasterSearch extends TermMasterSearchBase, IReturn<TermMaster[]>
{
}

// @Route("/termmaster/batch", "DELETE, PATCH, POST, PUT")
interface TermMasterBatch extends Array<TermMaster>
{
}

// @Route("/termmaster/{Id}/copy", "POST")
// @Route("/termmaster", "POST")
// @Route("/termmaster/{Id}", "GET, PATCH, PUT, DELETE")
interface TermMasterCopy extends TermMaster, IReturn<TermMaster>, IDto
{
}

// @Route("/termmaster/{Id}/{Junction}/version", "GET, POST")
// @Route("/termmaster/{Id}/{Junction}", "GET, POST, DELETE")
interface TermMasterJunction extends TermMasterSearchBase, IReturn<TermMaster[]>
{
}

// @Route("/termsynonym/search", "GET, POST, DELETE")
// @Route("/termsynonym", "GET")
// @Route("/termsynonym/version", "GET, POST")
interface TermSynonymSearch extends TermSynonymSearchBase, IReturn<TermSynonym[]>
{
}

// @Route("/termsynonym/batch", "DELETE, PATCH, POST, PUT")
interface TermSynonymBatch extends Array<TermSynonym>
{
}

// @Route("/termsynonym/{Id}/copy", "POST")
// @Route("/termsynonym", "POST")
// @Route("/termsynonym/{Id}", "GET, PATCH, PUT, DELETE")
interface TermSynonymCopy extends TermSynonym, IReturn<TermSynonym>, IDto
{
}

// @Route("/termsynonym/{Id}/{Junction}/version", "GET, POST")
// @Route("/termsynonym/{Id}/{Junction}", "GET, POST, DELETE")
interface TermSynonymJunction extends TermSynonymSearchBase, IReturn<TermSynonym[]>
{
}

// @Route("/user/impersonate/{Id}", "GET, POST")
interface ImpersonateUser extends IReturn<User>
{
    /**
    * User Id to impersonate
    */
    // @ApiMember(Description="User Id to impersonate")
    Id?: number;
}

// @Route("/user/impersonate/end", "GET, POST")
interface ImpersonateUserEnd extends IReturn<User>
{
}

// @Route("/user/{Id}/password", "PATCH")
interface UserPassword extends IReturn<CurrentUser>
{
    Id?: number;
    NewPassword?: string;
    OldPassword?: string;
}

// @Route("/user/{Id}/stats")
interface UserStats
{
    Id?: number;
    DocumentSetId?: number;
    NotificationCount?: number;
    DocumentSetCount?: number;
    WorkflowCount?: number;
    LastAccessed?: string;
}

// @Route("/user/version", "GET, POST")
// @Route("/user/search", "GET, POST, DELETE")
// @Route("/user", "GET")
interface UserSearch extends UserSearchBase, IReturn<User[]>
{
}

// @Route("/user/batch", "DELETE, PATCH, POST, PUT")
interface UserBatch extends Array<User>
{
}

// @Route("/user/{Id}/copy", "POST")
// @Route("/user/{Id}", "GET, PATCH, PUT")
// @Route("/user", "POST")
interface UserCopy extends User, IReturn<User>, IDto
{
}

// @Route("/user/{Id}/{Junction}", "GET, POST, DELETE")
// @Route("/user/{Id}/{Junction}/version", "GET, POST")
interface UserJunction extends UserSearchBase, IReturn<User[]>
{
}

// @Route("/workflowcomment/search", "GET, POST, DELETE")
// @Route("/workflowcomment/version", "GET, POST")
// @Route("/workflowcomment", "GET")
interface WorkflowCommentSearch extends WorkflowCommentSearchBase, IReturn<WorkflowComment[]>
{
}

// @Route("/workflowcomment/batch", "DELETE, PATCH, POST, PUT")
interface WorkflowCommentBatch extends Array<WorkflowComment>
{
}

// @Route("/workflowcomment/{Id}/copy", "POST")
// @Route("/workflowcomment", "POST")
// @Route("/workflowcomment/{Id}", "GET, PATCH, PUT, DELETE")
interface WorkflowCommentCopy extends WorkflowComment, IReturn<WorkflowComment>, IDto
{
}

// @Route("/workflowcomment/{Id}/{Junction}/version", "GET, POST")
// @Route("/workflowcomment/{Id}/{Junction}", "GET, POST, DELETE")
interface WorkflowCommentJunction extends WorkflowCommentSearchBase, IReturn<WorkflowComment[]>
{
}

// @Route("/workflow/detail", "GET")
interface WorkflowDetailSearch extends IReturn<WorkflowDetail[]>
{
}

// @Route("/workflow/version", "GET, POST")
// @Route("/workflow", "GET")
// @Route("/workflow/search", "GET, POST, DELETE")
interface WorkflowSearch extends WorkflowSearchBase, IReturn<Workflow[]>
{
}

// @Route("/workflow/batch", "DELETE, PATCH, POST, PUT")
interface WorkflowBatch extends Array<Workflow>
{
}

// @Route("/workflow/{Id}/copy", "POST")
// @Route("/workflow", "POST")
// @Route("/workflow/{Id}", "GET, PATCH, PUT")
interface WorkflowCopy extends Workflow, IReturn<Workflow>, IDto
{
}

// @Route("/workflow/{Id}/{Junction}", "GET, POST, DELETE")
// @Route("/workflow/{Id}/{Junction}/version", "GET, POST")
interface WorkflowJunction extends WorkflowSearchBase, IReturn<Workflow[]>
{
}

// @Route("/workflowtask", "GET")
// @Route("/workflowtask/search", "GET, POST, DELETE")
// @Route("/workflowtask/version", "GET, POST")
interface WorkflowTaskSearch extends WorkflowTaskSearchBase, IReturn<WorkflowTask[]>
{
}

// @Route("/workflowtask/batch", "DELETE, PATCH, POST, PUT")
interface WorkflowTaskBatch extends Array<WorkflowTask>
{
}

// @Route("/workflowtask/{Id}/copy", "POST")
// @Route("/workflowtask/{Id}", "GET, PATCH, PUT, DELETE")
// @Route("/workflowtask", "POST")
interface WorkflowTaskCopy extends WorkflowTask, IReturn<WorkflowTask>, IDto
{
}

// @Route("/admin/queues", "GET")
interface QueueStatus
{
    Queues?: RabbitQueueItem[];
}

// @Route("/settings")
interface FrontendSettingsGet
{
    Settings?: Frontend;
    InternalMetaUrl?: string;
    ExternalMetaUrl?: string;
}

// @Route("/framedquestion/search", "GET, POST")
interface FramedQuestionSearch
{
    Id?: number;
    DocumentSetId?: number;
}

// @Route("/fqreferencestatus/search", "GET, POST")
interface LibraryFqReferenceStatusSearch
{
    FqId?: number;
}

// @Route("/librarypackage/search", "GET, POST")
interface LibraryPackageSearch
{
    DocumentSetId?: number;
    FqId?: number;
    UserId?: number;
}

// @Route("/libraryratings/search", "GET, POST")
interface LibraryRatingsSearch
{
    UserId?: number;
    DocumentSetId?: number;
    PackageId?: number;
    FramedQuestionId?: number;
    ReferenceId?: number;
}

// @Route("/librarynote/search", "GET, POST")
interface LibraryNoteSearch
{
    Id?: number;
    UserId?: number;
    ReferenceId?: number;
    DocumentSetId?: number;
    FqId?: number;
}

// @Route("/libraryfavorites/search", "GET, POST")
interface LibraryFavoriteSearch
{
    UserId?: number;
    DocumentSetId?: number;
    FqId?: number;
}

// @Route("/client/taskrayproject/{id}", "GET")
// @Route("/client/taskrayprojects", "GET")
// @DataContract
interface SalesforceTaskrayProject
{
    // @DataMember(IsRequired=true)
    Id?: string;

    // @DataMember
    TASKRAY__trAccount__r?: Account;

    // @DataMember
    TASKRAY__trAccount__c?: string;

    // @DataMember
    AccountID__c?: string;

    // @DataMember
    Description__c?: string;

    // @DataMember
    Name?: string;

    // @DataMember
    Secondary_Project_Name__c?: string;

    // @DataMember
    Contracted_Service__c?: string;

    // @DataMember
    Deliverable_Deadline_Date__c?: string;

    // @DataMember
    Database_Deadline__c?: string;

    // @DataMember
    CreatedDate?: string;

    // @DataMember
    Contact_Name__r?: SalesforceContact;

    // @DataMember
    Contact_Name__c?: string;

    // @DataMember
    FQ_ID__c?: string;

    // @DataMember
    Case__c?: string;

    // @DataMember
    Sub_Project_Number__c?: string;

    // @DataMember
    TASKRAY__Project_Parent__c?: string;

    // @DataMember
    Project_Stage__c?: string;

    // @DataMember
    TASKRAY__Project_End__c?: string;

    // @DataMember
    Workstream__c?: string;

    // @DataMember
    Library_Package_ID__c?: string;

    // @DataMember
    Library_Package_Name__c?: string;

    // @DataMember
    Database_ID__c?: string;

    // @DataMember
    Database_Name__c?: string;

    // @DataMember
    TASKRAY__Status__c?: string;

    // @DataMember
    Opportunity_ID__c?: string;

    // @DataMember
    Archived_Date__c?: string;

    // @DataMember
    Working_Group__c?: string;

    // @DataMember
    Operations_Deliverable__c?: string;
}

// @Route("/client/updatetaskrayproject", "PATCH,POST")
// @DataContract
interface UpdateTaskrayProject
{
    // @DataMember(IsRequired=true)
    TaskrayProject?: SalesforceTaskrayProject;

    // @DataMember
    IsPackageRename?: boolean;

    // @DataMember
    IsDatasetRename?: boolean;

    // @DataMember
    UpdateSfRecord?: boolean;

    // @DataMember
    LibraryPackageId?: number;

    // @DataMember
    LibraryPackageName?: string;

    // @DataMember
    DatabaseName?: string;

    // @DataMember
    DatabaseId?: string;
}

// @Route("/client/projects")
interface Case
{
    Id?: string;
    ParentId?: string;
    ChildIds?: string[];
    PicoId?: string;
    Description?: string;
    CaseName?: string;
    ProjectName?: string;
    Deliverable?: string;
    DateInitiated?: string;
    DeliverableDeadline?: string;
    DatabaseDeadline?: string;
    ClosedDate?: string;
    DeadlineDate?: string;
    GlobalBusinessUnit?: string;
    ContactName?: string;
    Workstream?: string;
    LibraryPackageName?: string;
    LibraryPackageId?: string;
    DatabaseId?: string;
    DatabaseName?: string;
    ClientName?: string;
    Status?: string;
    Opportunity?: string;
    FqId?: string;
    ArchivedDate?: string;
    OperationsDeliverable?: string;
}

interface Opportunity
{
    Id?: string;
    Name?: string;
    ClientName?: string;
    ContractEndDate?: string;
    CloseDate?: string;
    Stage?: string;
    OpportunityId?: string;
    History?: OpportunityFieldHistory[];
}

// @Route("/profile/status")
// @Route("/status")
interface StatusSearch extends Search_1<Status>, IReturn<Status[]>
{
    Enabled?: boolean;
    Running?: boolean;
    TaskRunning?: boolean;
    Tasks?: string[];
    TaskEnabled?: boolean;
    ChannelEnabled?: boolean;
    Services?: string[];
}

// @Route("/share", "GET")
interface ShareSearch extends Search_1<Scope>, IReturn<Scope[]>
{
    Client?: string;
    Division?: string;
    Team?: string;
    User?: string;
}

// @Route("/users/share", "GET")
interface UsersShare extends Search_1<User>, IReturn<User[]>
{
    /**
    * Find any user that contains part of this value in their FirstName
    */
    // @ApiMember(Description="Find any user that contains part of this value in their FirstName", Name="FirstName")
    FirstName?: string;

    /**
    * Find any user that contains part of this value in their LastName
    */
    // @ApiMember(Description="Find any user that contains part of this value in their LastName", Name="LastName")
    LastName?: string;

    /**
    * Find any user that contains part of this value in their Name (almost always should be their email address)
    */
    // @ApiMember(Description="Find any user that contains part of this value in their Name (almost always should be their email address)", Name="Name")
    Name?: string;

    /**
    * Find any user that contains part of this value in their Email
    */
    // @ApiMember(Description="Find any user that contains part of this value in their Email", Name="Email")
    Email?: string;

    /**
    * Find any user that contains part of this value in their Client's Name
    */
    // @ApiMember(Description="Find any user that contains part of this value in their Client\'s Name", Name="Client")
    Client?: string;

    /**
    * Find any user that contains part of this value in their Division's Name
    */
    // @ApiMember(Description="Find any user that contains part of this value in their Division\'s Name", Name="Division")
    Division?: string;

    /**
    * Find any user based on the user Role.IsInternal value
    */
    // @ApiMember(Description="Find any user based on the user Role.IsInternal value", Name="IsInternal")
    IsInternal?: boolean;

    /**
    * Find any user based on the user's Status value
    */
    // @ApiMember(Description="Find any user based on the user\'s Status value", Name="Status")
    Status?: string;

    /**
    * Find any user whose UserType.Type == Employee
    */
    // @ApiMember(Description="Find any user whose UserType.Type == Employee", Name="IsEmployee")
    IsEmployee?: boolean;

    /**
    * Full text search across all properties on the search object to find a match. Spaces will be split into separate search terms.
    */
    // @ApiMember(Description="Full text search across all properties on the search object to find a match. Spaces will be split into separate search terms.", Name="Search")
    Search?: string;
}

// @Route("/division/share", "GET")
interface DivisionsShare extends Search_1<Division>, IReturn<Division[]>
{
    Search?: string;
}

// @Route("/clients/share", "GET")
interface ClientsShare extends Search_1<Client>, IReturn<Client[]>
{
    Search?: string;
}

// @Route("/teams/share", "GET")
interface TeamsShare extends Search_1<Team>, IReturn<Team[]>
{
    Search?: string;
}

// @Route("/scopes/share", "GET")
interface ScopesShare extends Search_1<Scope>, IReturn<Scope[]>
{
    FirstName?: string;
    LastName?: string;
    Name?: string;
    Email?: string;
    Client?: string;
    Division?: string;
    DocumentSet?: string;
    Team?: string;
    Search?: string;
    Type?: string;
}

// @Route("/analysisaccessed", "GET")
// @Route("/analysisaccessed/version", "GET, POST")
// @Route("/analysisaccessed/search", "GET, POST, DELETE")
interface AnalysisAccessedSearch extends AnalysisAccessedSearchBase, IReturn<AnalysisAccessed[]>
{
}

// @Route("/analysisaccessed/batch", "DELETE, PATCH, POST, PUT")
interface AnalysisAccessedBatch extends Array<AnalysisAccessed>
{
}

// @Route("/analysisaccessed/{Id}/copy", "POST")
// @Route("/analysisaccessed/{Id}", "GET, PATCH, PUT, DELETE")
// @Route("/analysisaccessed", "POST")
interface AnalysisAccessedCopy extends AnalysisAccessed, IReturn<AnalysisAccessed>, IDto
{
}

// @Route("/analysis/version", "GET, POST")
// @Route("/analysis/search", "GET, POST, DELETE")
// @Route("/analysis", "GET")
interface AnalysisSearch extends AnalysisSearchBase, IReturn<Analysis[]>
{
}

// @Route("/analysis/batch", "DELETE, PATCH, POST, PUT")
interface AnalysisBatch extends Array<Analysis>
{
}

// @Route("/analysis/{Id}/copy", "POST")
// @Route("/analysis/{Id}", "GET, PATCH, PUT, DELETE")
// @Route("/analysis", "POST")
interface AnalysisCopy extends Analysis, IReturn<Analysis>, IDto
{
}

// @Route("/analysis/{Id}/{Junction}", "GET, POST, DELETE")
// @Route("/analysis/{Id}/{Junction}/version", "GET, POST")
interface AnalysisJunction extends AnalysisSearchBase, IReturn<Analysis[]>
{
}

// @Route("/dataclass", "GET")
// @Route("/dataclass/version", "GET, POST")
// @Route("/dataclass/search", "GET, POST, DELETE")
interface DataClassSearch extends DataClassSearchBase, IReturn<DataClass[]>
{
}

// @Route("/dataclass/batch", "DELETE, PATCH, POST, PUT")
interface DataClassBatch extends Array<DataClass>
{
}

// @Route("/dataclass/{Id}/{Junction}", "GET, POST, DELETE")
// @Route("/dataclass/{Id}/{Junction}/version", "GET, POST")
interface DataClassJunction extends DataClassSearchBase, IReturn<DataClass[]>
{
}

// @Route("/dataproperty", "GET")
// @Route("/dataproperty/search", "GET, POST, DELETE")
// @Route("/dataproperty/version", "GET, POST")
interface DataPropertySearch extends DataPropertySearchBase, IReturn<DataProperty[]>
{
}

// @Route("/dataproperty/batch", "DELETE, PATCH, POST, PUT")
interface DataPropertyBatch extends Array<DataProperty>
{
}

// @Route("/dataproperty/{Id}/{Junction}", "GET, POST, DELETE")
// @Route("/dataproperty/{Id}/{Junction}/version", "GET, POST")
interface DataPropertyJunction extends DataPropertySearchBase, IReturn<DataProperty[]>
{
}

// @Route("/datatab", "GET")
// @Route("/datatab/version", "GET, POST")
// @Route("/datatab/search", "GET, POST, DELETE")
interface DataTabSearch extends DataTabSearchBase, IReturn<DataTab[]>
{
}

// @Route("/datatab/batch", "DELETE, PATCH, POST, PUT")
interface DataTabBatch extends Array<DataTab>
{
}

// @Route("/faqcategory", "GET")
// @Route("/faqcategory/version", "GET, POST")
// @Route("/faqcategory/search", "GET, POST, DELETE")
interface FAQCategorySearch extends FAQCategorySearchBase, IReturn<FAQCategory[]>
{
}

// @Route("/faqcategory/batch", "DELETE, PATCH, POST, PUT")
interface FAQCategoryBatch extends Array<FAQCategory>
{
}

// @Route("/faqcategory/{Id}/copy", "POST")
// @Route("/faqcategory/{Id}", "GET, PATCH, PUT, DELETE")
// @Route("/faqcategory", "POST")
interface FAQCategoryCopy extends FAQCategory, IReturn<FAQCategory>, IDto
{
}

// @Route("/faqcategory/{Id}/{Junction}", "GET, POST, DELETE")
// @Route("/faqcategory/{Id}/{Junction}/version", "GET, POST")
interface FAQCategoryJunction extends FAQCategorySearchBase, IReturn<FAQCategory[]>
{
}

// @Route("/favorite/version", "GET, POST")
// @Route("/favorite", "GET")
// @Route("/favorite/search", "GET, POST, DELETE")
interface FavoriteSearch extends FavoriteSearchBase, IReturn<Favorite[]>
{
}

// @Route("/favorite/batch", "DELETE, PATCH, POST, PUT")
interface FavoriteBatch extends Array<Favorite>
{
}

// @Route("/favorite/{Id}/copy", "POST")
// @Route("/favorite", "POST")
// @Route("/favorite/{Id}", "GET, PATCH, PUT, DELETE")
interface FavoriteCopy extends Favorite, IReturn<Favorite>, IDto
{
}

// @Route("/image/version", "GET, POST")
// @Route("/image/search", "GET, POST, DELETE")
// @Route("/image", "GET")
interface ImageSearch extends ImageSearchBase, IReturn<Image[]>
{
}

// @Route("/image/batch", "DELETE, PATCH, POST, PUT")
interface ImageBatch extends Array<Image>
{
}

// @Route("/image/{Id}/copy", "POST")
// @Route("/image", "POST")
// @Route("/image/{Id}", "GET, PATCH, PUT, DELETE")
interface ImageCopy extends Image, IReturn<Image>, IDto
{
}

// @Route("/reconciledocument/version", "GET, POST")
// @Route("/reconciledocument", "GET")
// @Route("/reconciledocument/search", "GET, POST, DELETE")
interface ReconcileDocumentSearch extends ReconcileDocumentSearchBase, IReturn<ReconcileDocument[]>
{
}

// @Route("/reconciledocument/batch", "DELETE, PATCH, POST, PUT")
interface ReconcileDocumentBatch extends Array<ReconcileDocument>
{
}

// @Route("/reconciledocument/{Id}/copy", "POST")
// @Route("/reconciledocument", "POST")
// @Route("/reconciledocument/{Id}", "GET, PATCH, PUT, DELETE")
interface ReconcileDocumentCopy extends ReconcileDocument, IReturn<ReconcileDocument>, IDto
{
}

// @Route("/attributeinterval/version", "GET, POST")
// @Route("/attributeinterval", "GET")
// @Route("/attributeinterval/search", "GET, POST, DELETE")
interface AttributeIntervalSearch extends AttributeIntervalSearchBase, IReturn<AttributeInterval[]>
{
}

// @Route("/attributeinterval/batch", "DELETE, PATCH, POST, PUT")
interface AttributeIntervalBatch extends Array<AttributeInterval>
{
}

// @Route("/attributeinterval/{Id}/copy", "POST")
// @Route("/attributeinterval", "POST")
// @Route("/attributeinterval/{Id}", "GET, PATCH, PUT, DELETE")
interface AttributeIntervalCopy extends AttributeInterval, IReturn<AttributeInterval>, IDto
{
}

// @Route("/attribute/search", "GET, POST, DELETE")
// @Route("/attribute", "GET")
// @Route("/attribute/version", "GET, POST")
interface AttributeSearch extends AttributeSearchBase, IReturn<Attribute[]>
{
}

// @Route("/attribute/batch", "DELETE, PATCH, POST, PUT")
interface AttributeBatch extends Array<Attribute>
{
}

// @Route("/attribute/{Id}/copy", "POST")
// @Route("/attribute", "POST")
// @Route("/attribute/{Id}", "GET, PATCH, PUT, DELETE")
interface AttributeCopy extends Attribute, IReturn<Attribute>, IDto
{
}

// @Route("/auditdelta/search", "GET, POST, DELETE")
// @Route("/auditdelta/version", "GET, POST")
// @Route("/auditdelta", "GET")
interface AuditDeltaSearch extends AuditDeltaSearchBase, IReturn<AuditDelta[]>
{
}

// @Route("/auditdelta/batch", "DELETE, PATCH, POST, PUT")
interface AuditDeltaBatch extends Array<AuditDelta>
{
}

// @Route("/auditdelta/{Id}/copy", "POST")
// @Route("/auditdelta/{Id}", "GET")
// @Route("/auditdelta", "POST")
interface AuditDeltaCopy extends AuditDelta, IReturn<AuditDelta>, IDto
{
}

// @Route("/databaseversion/version", "GET, POST")
// @Route("/databaseversion", "GET")
// @Route("/databaseversion/search", "GET, POST, DELETE")
interface DatabaseVersionSearch extends DatabaseVersionSearchBase, IReturn<DatabaseVersion[]>
{
}

// @Route("/datetime", "GET")
// @Route("/datetime/version", "GET, POST")
// @Route("/datetime/search", "GET, POST, DELETE")
interface DateTimeSearch extends DateTimeSearchBase, IReturn<DateTimeDto[]>
{
}

// @Route("/datetime/batch", "DELETE, PATCH, POST, PUT")
interface DateTimeBatch extends Array<DateTimeDto>
{
}

// @Route("/datetime/{Id}/copy", "POST")
// @Route("/datetime/{Id}", "GET, PATCH, PUT, DELETE")
// @Route("/datetime", "POST")
interface DateTimeDtoCopy extends DateTimeDto, IReturn<DateTimeDto>, IDto
{
}

// @Route("/documentsethistory/search", "GET, POST, DELETE")
// @Route("/documentsethistory", "GET")
// @Route("/documentsethistory/version", "GET, POST")
interface DocumentSetHistorySearch extends DocumentSetHistorySearchBase, IReturn<DocumentSetHistory[]>
{
}

// @Route("/glossary", "GET")
// @Route("/glossary/version", "GET, POST")
// @Route("/glossary/search", "GET, POST, DELETE")
interface GlossarySearch extends GlossarySearchBase, IReturn<Glossary[]>
{
}

// @Route("/glossary/batch", "DELETE, PATCH, POST, PUT")
interface GlossaryBatch extends Array<Glossary>
{
}

// @Route("/glossary/{Id}/copy", "POST")
// @Route("/glossary/{Id}", "GET, PATCH, PUT, DELETE")
// @Route("/glossary", "POST")
interface GlossaryCopy extends Glossary, IReturn<Glossary>, IDto
{
}

// @Route("/help/version", "GET, POST")
// @Route("/help", "GET")
// @Route("/help/search", "GET, POST, DELETE")
interface HelpSearch extends HelpSearchBase, IReturn<Help[]>
{
}

// @Route("/help/batch", "DELETE, PATCH, POST, PUT")
interface HelpBatch extends Array<Help>
{
}

// @Route("/help/{Id}/copy", "POST")
// @Route("/help", "POST")
// @Route("/help/{Id}", "GET, PATCH, PUT, DELETE")
interface HelpCopy extends Help, IReturn<Help>, IDto
{
}

// @Route("/help/{Id}/{Junction}", "GET, POST, DELETE")
// @Route("/help/{Id}/{Junction}/version", "GET, POST")
interface HelpJunction extends HelpSearchBase, IReturn<Help[]>
{
}

// @Route("/history/version", "GET, POST")
// @Route("/history/search", "GET, POST, DELETE")
// @Route("/history", "GET")
interface HistorySearch extends HistorySearchBase, IReturn<History[]>
{
}

// @Route("/history/batch", "DELETE, PATCH, POST, PUT")
interface HistoryBatch extends Array<History>
{
}

// @Route("/history/{Id}/copy", "POST")
// @Route("/history", "POST")
// @Route("/history/{Id}", "GET")
interface HistoryCopy extends History, IReturn<History>, IDto
{
}

// @Route("/interval", "GET")
// @Route("/interval/search", "GET, POST, DELETE")
// @Route("/interval/version", "GET, POST")
interface IntervalSearch extends IntervalSearchBase, IReturn<Interval[]>
{
}

// @Route("/interval/batch", "DELETE, PATCH, POST, PUT")
interface IntervalBatch extends Array<Interval>
{
}

// @Route("/interval/{Id}/copy", "POST")
// @Route("/interval/{Id}", "GET, PATCH, PUT, DELETE")
// @Route("/interval", "POST")
interface IntervalCopy extends Interval, IReturn<Interval>, IDto
{
}

// @Route("/junction/search", "GET, POST, DELETE")
// @Route("/junction/version", "GET, POST")
// @Route("/junction", "GET")
interface JunctionSearch extends JunctionSearchBase, IReturn<Junction[]>
{
}

// @Route("/junction/batch", "DELETE, PATCH, POST, PUT")
interface JunctionBatch extends Array<Junction>
{
}

// @Route("/junction/{Id}/copy", "POST")
// @Route("/junction/{Id}", "GET, PATCH, PUT, DELETE")
// @Route("/junction", "POST")
interface JunctionCopy extends Junction, IReturn<Junction>, IDto
{
}

// @Route("/junction/{Id}/{Junction}/version", "GET, POST")
// @Route("/junction/{Id}/{Junction}", "GET, POST, DELETE")
interface JunctionJunction extends JunctionSearchBase, IReturn<Junction[]>
{
}

// @Route("/localelookup", "GET")
// @Route("/localelookup/version", "GET, POST")
// @Route("/localelookup/search", "GET, POST, DELETE")
interface LocaleLookupSearch extends LocaleLookupSearchBase, IReturn<LocaleLookup[]>
{
}

// @Route("/localelookup/batch", "DELETE, PATCH, POST, PUT")
interface LocaleLookupBatch extends Array<LocaleLookup>
{
}

// @Route("/localelookup/{Id}/copy", "POST")
// @Route("/localelookup/{Id}", "GET")
// @Route("/localelookup", "POST")
interface LocaleLookupCopy extends LocaleLookup, IReturn<LocaleLookup>, IDto
{
}

// @Route("/locale/version", "GET, POST")
// @Route("/locale/search", "GET, POST, DELETE")
// @Route("/locale", "GET")
interface LocaleSearch extends LocaleSearchBase, IReturn<Locale[]>
{
}

// @Route("/locale/batch", "DELETE, PATCH, POST, PUT")
interface LocaleBatch extends Array<Locale>
{
}

// @Route("/locale/{Id}/copy", "POST")
// @Route("/locale", "POST")
// @Route("/locale/{Id}", "GET")
interface LocaleCopy extends Locale, IReturn<Locale>, IDto
{
}

// @Route("/lookupcategory", "GET")
// @Route("/lookupcategory/search", "GET, POST, DELETE")
// @Route("/lookupcategory/version", "GET, POST")
interface LookupCategorySearch extends LookupCategorySearchBase, IReturn<LookupCategory[]>
{
}

// @Route("/lookupcategory/batch", "DELETE, PATCH, POST, PUT")
interface LookupCategoryBatch extends Array<LookupCategory>
{
}

// @Route("/lookupcategory/{Id}/copy", "POST")
// @Route("/lookupcategory/{Id}", "GET, PATCH, PUT, DELETE")
// @Route("/lookupcategory", "POST")
interface LookupCategoryCopy extends LookupCategory, IReturn<LookupCategory>, IDto
{
}

// @Route("/lookupcategory/{Id}/{Junction}/version", "GET, POST")
// @Route("/lookupcategory/{Id}/{Junction}", "GET, POST, DELETE")
interface LookupCategoryJunction extends LookupCategorySearchBase, IReturn<LookupCategory[]>
{
}

// @Route("/lookuptableenum", "GET")
// @Route("/lookuptableenum/version", "GET, POST")
// @Route("/lookuptableenum/search", "GET, POST, DELETE")
interface LookupTableEnumSearch extends LookupTableEnumSearchBase, IReturn<LookupTableEnum[]>
{
}

// @Route("/lookuptableenum/batch", "DELETE, PATCH, POST, PUT")
interface LookupTableEnumBatch extends Array<LookupTableEnum>
{
}

// @Route("/lookuptableenum/{Id}/copy", "POST")
// @Route("/lookuptableenum/{Id}", "GET, PATCH, PUT, DELETE")
// @Route("/lookuptableenum", "POST")
interface LookupTableEnumCopy extends LookupTableEnum, IReturn<LookupTableEnum>, IDto
{
}

// @Route("/queuechannel", "GET")
// @Route("/queuechannel/search", "GET, POST, DELETE")
// @Route("/queuechannel/version", "GET, POST")
interface QueueChannelSearch extends QueueChannelSearchBase, IReturn<QueueChannel[]>
{
}

// @Route("/queuechannel/batch", "DELETE, PATCH, POST, PUT")
interface QueueChannelBatch extends Array<QueueChannel>
{
}

// @Route("/queuechannel/{Id}/copy", "POST")
// @Route("/queuechannel/{Id}", "GET, PATCH, PUT, DELETE")
// @Route("/queuechannel", "POST")
interface QueueChannelCopy extends QueueChannel, IReturn<QueueChannel>, IDto
{
}

// @Route("/releasestatus/search", "GET, POST, DELETE")
// @Route("/releasestatus/version", "GET, POST")
// @Route("/releasestatus", "GET")
interface ReleaseStatusSearch extends ReleaseStatusSearchBase, IReturn<ReleaseStatus[]>
{
}

// @Route("/releasestatus/batch", "DELETE, PATCH, POST, PUT")
interface ReleaseStatusBatch extends Array<ReleaseStatus>
{
}

// @Route("/releasestatus/{Id}/copy", "POST")
// @Route("/releasestatus", "POST")
// @Route("/releasestatus/{Id}", "GET, PATCH, PUT, DELETE")
interface ReleaseStatusCopy extends ReleaseStatus, IReturn<ReleaseStatus>, IDto
{
}

// @Route("/tag/version", "GET, POST")
// @Route("/tag/search", "GET, POST, DELETE")
// @Route("/tag", "GET")
interface TagSearch extends TagSearchBase, IReturn<Tag[]>
{
}

// @Route("/tag/batch", "DELETE, PATCH, POST, PUT")
interface TagBatch extends Array<Tag>
{
}

// @Route("/tag/{Id}/copy", "POST")
// @Route("/tag", "POST")
// @Route("/tag/{Id}", "GET, DELETE")
interface TagCopy extends Tag, IReturn<Tag>, IDto
{
}

// @Route("/tag/{Id}/{Junction}/version", "GET, POST")
// @Route("/tag/{Id}/{Junction}", "GET, POST, DELETE")
interface TagJunction extends TagSearchBase, IReturn<Tag[]>
{
}

// @Route("/termcategory/version", "GET, POST")
// @Route("/termcategory/search", "GET, POST, DELETE")
// @Route("/termcategory", "GET")
interface TermCategorySearch extends TermCategorySearchBase, IReturn<TermCategory[]>
{
}

// @Route("/termcategory/batch", "DELETE, PATCH, POST, PUT")
interface TermCategoryBatch extends Array<TermCategory>
{
}

// @Route("/termcategory/{Id}/copy", "POST")
// @Route("/termcategory/{Id}", "GET, PATCH, PUT, DELETE")
// @Route("/termcategory", "POST")
interface TermCategoryCopy extends TermCategory, IReturn<TermCategory>, IDto
{
}

// @Route("/termcategory/{Id}/{Junction}/version", "GET, POST")
// @Route("/termcategory/{Id}/{Junction}", "GET, POST, DELETE")
interface TermCategoryJunction extends TermCategorySearchBase, IReturn<TermCategory[]>
{
}

// @Route("/timecard", "GET")
// @Route("/timecard/version", "GET, POST")
// @Route("/timecard/search", "GET, POST, DELETE")
interface TimeCardSearch extends TimeCardSearchBase, IReturn<TimeCard[]>
{
}

// @Route("/timecard/batch", "DELETE, PATCH, POST, PUT")
interface TimeCardBatch extends Array<TimeCard>
{
}

// @Route("/timecard/{Id}/copy", "POST")
// @Route("/timecard/{Id}", "GET, PATCH, PUT, DELETE")
// @Route("/timecard", "POST")
interface TimeCardCopy extends TimeCard, IReturn<TimeCard>, IDto
{
}

// @Route("/timepoint/search", "GET, POST, DELETE")
// @Route("/timepoint", "GET")
// @Route("/timepoint/version", "GET, POST")
interface TimePointSearch extends TimePointSearchBase, IReturn<TimePoint[]>
{
}

// @Route("/unitconversionrules/search", "GET, POST, DELETE")
// @Route("/unitconversionrules", "GET")
// @Route("/unitconversionrules/version", "GET, POST")
interface UnitConversionRulesSearch extends UnitConversionRulesSearchBase, IReturn<UnitConversionRules[]>
{
}

// @Route("/unitconversionrules/batch", "DELETE, PATCH, POST, PUT")
interface UnitConversionRulesBatch extends Array<UnitConversionRules>
{
}

// @Route("/unitconversionrules/{Id}/copy", "POST")
// @Route("/unitconversionrules", "POST")
// @Route("/unitconversionrules/{Id}", "GET, PATCH, PUT, DELETE")
interface UnitConversionRulesCopy extends UnitConversionRules, IReturn<UnitConversionRules>, IDto
{
}

// @Route("/unitofmeasure/search", "GET, POST, DELETE")
// @Route("/unitofmeasure", "GET")
// @Route("/unitofmeasure/version", "GET, POST")
interface UnitOfMeasureSearch extends UnitOfMeasureSearchBase, IReturn<UnitOfMeasure[]>
{
}

// @Route("/unitofmeasure/batch", "DELETE, PATCH, POST, PUT")
interface UnitOfMeasureBatch extends Array<UnitOfMeasure>
{
}

// @Route("/unitofmeasure/{Id}/copy", "POST")
// @Route("/unitofmeasure", "POST")
// @Route("/unitofmeasure/{Id}", "GET, PATCH, PUT, DELETE")
interface UnitOfMeasureCopy extends UnitOfMeasure, IReturn<UnitOfMeasure>, IDto
{
}

// @Route("/unlock", "PUT, PATCH, GET")
// @Route("/unlock/{Id}", "PUT, PATCH, GET")
interface Unlock
{
    Id?: number;
    Ids?: number[];
}

// @Route("/update", "GET")
// @Route("/update/search", "GET, POST, DELETE")
// @Route("/update/version", "GET, POST")
interface UpdateSearch extends UpdateSearchBase, IReturn<Update[]>
{
}

// @Route("/update/batch", "DELETE, PATCH, POST, PUT")
interface UpdateBatch extends Array<Update>
{
}

// @Route("/update/{Id}/copy", "POST")
// @Route("/update/{Id}", "GET")
// @Route("/update", "POST")
interface UpdateCopy extends Update, IReturn<Update>, IDto
{
}

// @Route("/update/{Id}/{Junction}/version", "GET, POST")
// @Route("/update/{Id}/{Junction}", "GET, POST, DELETE")
interface UpdateJunction extends UpdateSearchBase, IReturn<Update[]>
{
}

// @Route("/userrequest", "GET")
// @Route("/userrequest/search", "GET, POST, DELETE")
// @Route("/userrequest/version", "GET, POST")
interface UserRequestSearch extends UserRequestSearchBase, IReturn<UserRequest[]>
{
}

// @Route("/usersession", "GET")
// @Route("/usersession/version", "GET, POST")
// @Route("/usersession/search", "GET, POST, DELETE")
interface UserSessionSearch extends UserSessionSearchBase, IReturn<UserSession[]>
{
}

// @Route("/usersession/{Id}/{Junction}/version", "GET, POST")
// @Route("/usersession/{Id}/{Junction}", "GET, POST, DELETE")
interface UserSessionJunction extends UserSessionSearchBase, IReturn<UserSession[]>
{
}

// @Route("/usertype", "GET")
// @Route("/usertype/version", "GET, POST")
// @Route("/usertype/search", "GET, POST, DELETE")
interface UserTypeSearch extends UserTypeSearchBase, IReturn<UserType[]>
{
}

// @Route("/usertype/batch", "DELETE, PATCH, POST, PUT")
interface UserTypeBatch extends Array<UserType>
{
}

// @Route("/usertype/{Id}/copy", "POST")
// @Route("/usertype/{Id}", "GET, PATCH, PUT, DELETE")
// @Route("/usertype", "POST")
interface UserTypeCopy extends UserType, IReturn<UserType>, IDto
{
}

// @Route("/usertype/{Id}/{Junction}/version", "GET, POST")
// @Route("/usertype/{Id}/{Junction}", "GET, POST, DELETE")
interface UserTypeJunction extends UserTypeSearchBase, IReturn<UserType[]>
{
}

// @Route("/valuetype", "GET")
// @Route("/valuetype/version", "GET, POST")
// @Route("/valuetype/search", "GET, POST, DELETE")
interface ValueTypeSearch extends ValueTypeSearchBase, IReturn<ValueType[]>
{
}

// @Route("/variableinstance/version", "GET, POST")
// @Route("/variableinstance", "GET")
// @Route("/variableinstance/search", "GET, POST, DELETE")
interface VariableInstanceSearch extends VariableInstanceSearchBase, IReturn<VariableInstance[]>
{
}

// @Route("/variableinstance/batch", "DELETE, PATCH, POST, PUT")
interface VariableInstanceBatch extends Array<VariableInstance>
{
}

// @Route("/variableinstance/{Id}/copy", "POST")
// @Route("/variableinstance", "POST")
// @Route("/variableinstance/{Id}", "GET, PATCH, PUT, DELETE")
interface VariableInstanceCopy extends VariableInstance, IReturn<VariableInstance>, IDto
{
}

// @Route("/variableinstance/{Id}/{Junction}", "GET, POST, DELETE")
// @Route("/variableinstance/{Id}/{Junction}/version", "GET, POST")
interface VariableInstanceJunction extends VariableInstanceSearchBase, IReturn<VariableInstance[]>
{
}

// @Route("/variablerule/version", "GET, POST")
// @Route("/variablerule", "GET")
// @Route("/variablerule/search", "GET, POST, DELETE")
interface VariableRuleSearch extends VariableRuleSearchBase, IReturn<VariableRule[]>
{
}

// @Route("/variablerule/batch", "DELETE, PATCH, POST, PUT")
interface VariableRuleBatch extends Array<VariableRule>
{
}

// @Route("/variablerule/{Id}/copy", "POST")
// @Route("/variablerule/{Id}", "GET, PATCH, PUT, DELETE")
// @Route("/variablerule", "POST")
interface VariableRuleCopy extends VariableRule, IReturn<VariableRule>, IDto
{
}

// @Route("/variablerule/{Id}/{Junction}/version", "GET, POST")
// @Route("/variablerule/{Id}/{Junction}", "GET, POST, DELETE")
interface VariableRuleJunction extends VariableRuleSearchBase, IReturn<VariableRule[]>
{
}

// @Route("/admin/atlassianlogin", "POST,GET")
interface AdminAtlassianLogin extends IDto
{
    Id?: number;
    CreatorId?: number;
    IgnoreCache?: boolean;
    site?: string;
    destination?: string;
    Select?: string[];
    Set?: string[];
}

// @Route("/admin/study/{Id}", "DELETE")
interface AdminStudy extends IDto
{
    Id?: number;
    CreatorId?: number;
    IgnoreCache?: boolean;
    DeleteContentOnly?: boolean;
    Select?: string[];
    Set?: string[];
}

// @Route("/admin/studyset/{Id}", "DELETE,GET")
interface AdminStudySet extends IDto
{
    Id?: number;
    CreatorId?: number;
    IgnoreCache?: boolean;
    OnlyDeleteUniqueToThisSet?: boolean;
    StudyCount?: number;
    Name?: string;
    Select?: string[];
    Set?: string[];
}

// @Route("/admin/referencestudy/{Id}/documentset/{DocumentSetId}", "POST,GET")
interface AdminDocumentImport extends IReturn<Document>, IDto
{
    Id?: number;
    CreatorId?: number;
    DocumentSetId?: number;
    IgnoreCache?: boolean;
    Select?: string[];
    Set?: string[];
}

// @Route("/admin/{EntityName}/ids", "POST,GET")
interface AdminEntityIds extends IReturn<number[]>
{
    EntityName?: string;
}

// @Route("/admin/select/{EntityName}", "POST,GET")
interface AdminSelect
{
    EntityName?: string;
    UserIds?: number[];
    Select?: string[];
}

// @Route("/datahub", "GET")
interface DataHub extends IReturn<SearchSummary[]>
{
    SearchTerm?: string;
}

// @Route("/datahub/details", "GET")
interface DataHubDetails extends Search_1<SearchRecord>, IReturn<SearchRecord[]>
{
    SearchTerm?: string;
    Source?: string;
    Category?: string;
}

// @Route("/concept/all", "GET")
interface ConceptsGetAll extends Search_1<Concept>, IReturn<Concept[]>
{
    IsBound?: boolean;
}

// @Route("/concept/references")
interface ConceptReference extends IReturn<Reference[]>
{
    Id?: number;
    ReferenceId?: number;
    SourceReferenceId?: string;
    Source?: string;
    Authors?: string;
    Title?: string;
    DOI?: string;
    MedlineId?: number;
    ImportType?: string;
    DocumentSets?: string[];
}

// @Route("/federate/login")
interface FederateLogin
{
    Username?: string;
    Password?: string;
    Site?: string;
    Authenticated?: boolean;
    IP?: string;
}

// @Route("/federate/logout")
interface FederateLogout
{
    RedirectURL?: string;
}

// @Route("/federate/loginentry")
interface FederateLoginEntry
{
    Site?: string;
    Client?: string;
    ReturnUrl?: string;
}

// @Route("/UniqueIds")
interface UniqueIdGet extends IReturn<UniqueId>
{
    Select?: string[];
    CurrentIds?: string[];
    Count?: number;
}

// @Route("/login")
interface Login
{
    Redirect?: string;
}

// @Route("/auth")
// @Route("/auth/{provider}")
// @Route("/authenticate")
// @Route("/authenticate/{provider}")
// @DataContract
interface Authenticate extends IReturn<AuthenticateResponse>, IPost
{
    // @DataMember(Order=1)
    provider?: string;

    // @DataMember(Order=2)
    State?: string;

    // @DataMember(Order=3)
    oauth_token?: string;

    // @DataMember(Order=4)
    oauth_verifier?: string;

    // @DataMember(Order=5)
    UserName?: string;

    // @DataMember(Order=6)
    Password?: string;

    // @DataMember(Order=7)
    RememberMe?: boolean;

    // @DataMember(Order=8)
    Continue?: string;

    // @DataMember(Order=9)
    ErrorView?: string;

    // @DataMember(Order=10)
    nonce?: string;

    // @DataMember(Order=11)
    uri?: string;

    // @DataMember(Order=12)
    response?: string;

    // @DataMember(Order=13)
    qop?: string;

    // @DataMember(Order=14)
    nc?: string;

    // @DataMember(Order=15)
    cnonce?: string;

    // @DataMember(Order=16)
    UseTokenCookie?: boolean;

    // @DataMember(Order=17)
    AccessToken?: string;

    // @DataMember(Order=18)
    AccessTokenSecret?: string;

    // @DataMember(Order=19)
    Meta?: { [index:string]: string; };
}

// @Route("/assignroles")
// @DataContract
interface AssignRoles extends IReturn<AssignRolesResponse>, IPost
{
    // @DataMember(Order=1)
    UserName?: string;

    // @DataMember(Order=2)
    Permissions?: string[];

    // @DataMember(Order=3)
    Roles?: string[];
}

// @Route("/unassignroles")
// @DataContract
interface UnAssignRoles extends IReturn<UnAssignRolesResponse>, IPost
{
    // @DataMember(Order=1)
    UserName?: string;

    // @DataMember(Order=2)
    Permissions?: string[];

    // @DataMember(Order=3)
    Roles?: string[];
}

